<template>
    <v-container style="padding-bottom: 100px;" fluid>
		<body id="comandaproforma" class="content">
			<div class="ticket">
				<div v-for="det in DatosLocalidad" :key="det.nombre" id="centrado">
					<b class="primary--text" >Proforma : {{noFactura}} <br>{{det.nombre}} </b>  <br>{{det.razonSocial}},<br> {{det.dirreccion}}, Costa Rica <br>
					{{det.cedulaJuridica}} <br> {{det.telefono}}  <br>
					{{det.correo}} <br> 
					------------------------- <br>
					<div class="caption">
						Vendedor: {{vendedor}} <br>
						Fecha: {{today}}  <br>
						Cliente {{clienteNombre}} <br> 
					</div> 
				</div>
				-------------------------
				<table>
					<thead>
						<tr>
							<th class="producto">Cant</th>
							<th class="precio">Nombre</th>
							<th class="precio">Precio</th>
						</tr>
					</thead>
					<tbody>
					<tr v-for="det in detalles" :key="det.noFacturaReal" >
						<td style="text-align:center;"> {{det.cantidad}} </td>
						<td style="text-align:center;">{{det.descripcion}}</td>
						<td style="text-align:center;">{{det.precioVenta }}</td>
					</tr>
					</tbody>
				</table>
				-------------------------
				<div style="text-align:center; ticket"> 
					<div>Detalle: {{detalleFactura}} </div>
					
				</div>
			</div>
		</body>
        <v-layout wrap >
			<v-flex xs sm3 md2>
				<v-text-field  dense filled id="CodigoBarras" @keyup.enter="BuscarCodeBar()" v-model="codigo" label="Código barras"/>
			</v-flex>
			<v-flex xs6 sm3 md2>
				<v-select
					class="mx-2"
					filled
					dense
					@change="setDocType"
					append-icon="mdi-card-account-details"
					v-model="tipoFactura"
					:style="{ backgroundColor: tipoFacturaColor }"
					:items="tipoFacturas"
					label="Tipo de Documento"
				></v-select>
			</v-flex>
			<v-flex xs6 sm3 md2>
				<v-select class="mx-2" filled dense v-model="vendedor" append-icon="mdi-briefcase-account" :items="Vendedores" color="success" :label="`Vendedor`"></v-select>
			</v-flex>
			<v-flex xs6 sm3 md2>
				<v-select class="mx-2" dense filled v-model="monedaPago" @change="CambiarMoneda()" :items="monedas" label="Moneda de Cobro"></v-select>
			</v-flex>
			<v-flex xs6 sm12 md4>
				<v-combobox
					filled
					clearable
					@change="obtenerCliente()"
					dense
					v-model="idcliente"
					:items="clientes"
					label="Cliente"
					append-icon="mdi-account-circle-outline"
				>
					<template v-slot:append>
						<v-btn small color="primary" @click.stop="dialogCliente = true">
							<v-icon>mdi-account-multiple-plus</v-icon>
						</v-btn>
					</template>
				</v-combobox>
			</v-flex>
			<v-flex xs12 sm8 md8>
				<v-card>
					<v-row class="mx-2 mb-2">
						<v-combobox :loading="loading" id="buscador" filled clearable onfocus="this.select();"  prepend-inner-icon="mdi-briefcase-outline" @keyup="selectProductos()" @change="buscarProducto()" :items="productos" v-model="codigo" label="Código de producto o servicio"></v-combobox>
						
							<v-btn v-if="esAdministrador || esSupervisor" :loading="loading" fab small color="primary" id="clienteActualizar" @click="mostrarArticulos()">
								<v-icon >mdi-briefcase-upload </v-icon>
							</v-btn>
					</v-row>
					<b class="d-md-none">Total:  {{Moneda()}} {{total}}</b>
					<div class="d-md-none">
						<v-data-table id="scroll"
							:headers="cabeceraDetalles2"
							:items="detalles"
							sort-by="id"
							sort-desc=""
							dense
							>
								<template v-slot:item.descripcion="props">
									<v-edit-dialog
									:return-value.sync="props.item.descripcion"
									>
									{{ props.item.descripcion }} <br>
									<p style="font-size:10px;">Stock <b>{{props.item.inv}} </b></p>
									<p style="white-space: pre-line; font-size: 12px;">{{props.item.detalle}} </p>
									<template v-slot:input>
										<v-text-field
										onfocus="this.select();"
										v-model="props.item.descripcion"
										:label="'Código: '"
										></v-text-field>
									</template>
									</v-edit-dialog>
								</template>
								<template v-slot:item.precio="props">
									<v-edit-dialog
									:return-value.sync="props.item.precio"
									>
									{{ props.item.precio }} <br>
									<template v-slot:input>
										<v-text-field
										onfocus="this.select();"
										v-model="props.item.precio"
										:disabled="esVendedor || esRecepcion "
										:label="'Digite el nuevo precio y enter para guardar: '"
										></v-text-field>
									</template>
									</v-edit-dialog>
								</template>
								<template id="field" v-slot:item.cantidad="props"> 
									<v-text-field style="width:80px" v-if="ModoCant == false" autofocus :background-color="getColor(props.item.inv,props.item.minimo)" @change="validarCantidad(props.item)" @focus="handleFocus($event, item.id)" ref="inputCantidadIngreso" @keyup.enter="Enfocar()" onfocus="this.select();" :label="''+props.item.idarticulo" type="number" v-model="props.item.cantidad"/>
									<v-text-field style="width:60px" v-if="ModoCant == true" :background-color="getColor(props.item.inv,props.item.minimo)"  @keyup.enter="Enfocar()" onfocus="this.select();" id="cantidadAuto" :label="''+props.item.idarticulo" type="number" v-model="props.item.cantidad"/>
								</template>
								<template v-slot:item.actionmovimiento="{ item }">
									<v-menu top :offset-y="offset">
										<template v-slot:activator="{ on, attrs }">
											<v-btn small text v-bind="attrs" v-on="on">
												<v-icon color="info">mdi-dots-horizontal</v-icon>
											</v-btn>
										</template>

										<v-list>
											<v-list-item>
												<v-text-field 
													outlined="" 
													label="Descuento" 
													onfocus="this.select();" 
													class="body-2 mt-2" 
													dense 
													v-model="item.descuento" 
													@click.stop
												></v-text-field>
											</v-list-item>
											<v-list-item>
												<v-select 
													@change="EsGrabado(item)" 
													outlined="" 
													label="Valor Impuesto" 
													v-if="esAdministrador || esSupervisor || esBodega || esTaller" 
													:items="Impuestos" 
													class="body-2 mt-2" 
													dense 
													v-model="item.valorImpuesto" 
													@click.stop
												></v-select>
											</v-list-item>
											<v-list-item @click="AñadirCabys(item)">
												<v-list-item-title>
													<v-icon>mdi-barcode-scan</v-icon> Añadir código CAByS
												</v-list-item-title>
											</v-list-item>
											<v-list-item @click="CambiarIvi(item)">
												<v-list-item-title>
													<v-icon>mdi-barcode-scan</v-icon> Cambiar Ivi
												</v-list-item-title>
											</v-list-item>
											<v-list-item @click="AbrirDetalle(item)">
												<v-list-item-title>
													<v-icon>mdi-barcode-scan</v-icon> Agregar Detalle
												</v-list-item-title>
											</v-list-item>
											<v-list-item @click="eliminarProducto(item.id,item.descricion)">
												<v-list-item-title>
													<v-icon>mdi-delete</v-icon> Eliminar Linea
												</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>

						</v-data-table>
					</div>	
					<div class="d-none d-md-block">
						<v-data-table
							:headers="cabeceraDetalles"
							:items="detalles"
							dense
							sort-by="id"
							sort-desc=""
							>
								<template v-slot:item.descripcion="props">
									<v-edit-dialog
									:return-value.sync="props.item.descripcion"
									>
									{{ props.item.descripcion }} <br>
									<p style="font-size:12px;">Stock <b> {{props.item.inv}} </b></p>
									<p style="white-space: pre-line; font-size: 12px;">{{props.item.detalle}} </p>
									<template v-slot:input>
										<v-text-field
										onfocus="this.select();"
										v-model="props.item.descripcion"
										:label="'Código: '"
										></v-text-field>
									</template>
									</v-edit-dialog>
								</template>
								<template id="field" v-slot:item.cantidad="props">
									<v-text-field style="width:80px" v-if="ModoCant == false" :background-color="getColor(props.item.inv,props.item.minimo)" @change="validarCantidad(props.item)" @focus="handleFocus($event, item.id)" ref="inputCantidadIngreso" @keyup.enter="Enfocar()" onfocus="this.select();" :label="''+props.item.idarticulo" type="number" v-model="props.item.cantidad"/>
									<v-text-field style="width:80px" v-if="ModoCant == true" :background-color="getColor(props.item.inv,props.item.minimo)" @change="validarCantidad(props.item)" @keyup.enter="Enfocar()" onfocus="this.select();" id="cantidadAuto" :label="''+props.item.idarticulo" type="number" v-model="props.item.cantidad"/>
								
								</template>
								<template v-slot:item.valorImpuesto="props"> 
									<v-edit-dialog
										:return-value.sync="props.item.valorImpuesto"
										large
										persistent
										>
										<div>{{ props.item.valorImpuesto }}</div>
										<template v-slot:input>
											<div class="mt-4 text-h6">
											Valor Impuesto
											</div>
											<v-select @change="EsGrabado(props.item)" outlined="" :label="'Cabys:'+ props.item.cabys" v-if="esAdministrador || esSupervisor || esTaller" :items="Impuestos" class="body-2 mt-2" dense v-model="props.item.valorImpuesto">  </v-select>
									
										</template>
									</v-edit-dialog>
								</template>
								<template v-slot:item.descuento="props">
									<v-edit-dialog
										:return-value.sync="props.item.descuento"
										>
										<div>{{ props.item.descuento }}</div>
										<template v-slot:input>
											<div class="mt-4 text-h6">
											% Descuento
											</div>
											<v-text-field @change="ValidarDescuento(props.item)" outlined="" :label="'Cabys:'+ props.item.cabys" onfocus="this.select();" class="body-2 mt-2" dense v-model="props.item.descuento">  </v-text-field>
										</template>
									</v-edit-dialog>
								</template>
								<template v-slot:item.actionmovimiento="{ item }">
									<v-icon
									large
									color="grey"
									@click="eliminarProducto(item.id,item.descricion)"
									>
									mdi-delete
									</v-icon>
									
									<v-menu top :offset-y="offset">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
											small
											text
											v-bind="attrs"
											v-on="on"
											
											> <v-icon color="info">mdi-dots-horizontal</v-icon>
											</v-btn>
										</template>

										<v-list>
											<v-list-item @click="AñadirCodigo(item)">
											<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Añadir códigos seriales</v-list-item-title>
											</v-list-item>
											<v-list-item @click="AñadirCabys(item)">
												<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Añadir código CAByS</v-list-item-title> 
											</v-list-item>
											<v-list-item @click="CambiarIvi(item)">
												<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Cambiar Ivi</v-list-item-title>
												</v-list-item>
											<v-list-item @click="AbrirDetalle(item)">
												<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Agregar Detalle</v-list-item-title>
											</v-list-item>
											<v-list-item @click="AbrirDetalle(item)">
												<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Asignar % Utilidad</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>
								<template v-slot:item.precio="props">
									<v-text-field
										style="width:80px"
										onfocus="this.select();"
										v-model="props.item.precio"
										:label="props.item.LlevaIvi"
										:readonly="esVendedor"
										@keyup.enter="Enfocar()"
										></v-text-field>
								</template>
						</v-data-table>
					</div>
					Items: {{totalCantidadFiltrada}}
				</v-card>
			</v-flex>
			<v-flex class="d-md-block" style="border-left: 1px solid rgb(224, 224, 224);" xs12 sm4 md4 > 
				<v-alert
				v-if="MensajeDescuento"
					text
					prominent
					type="error"
					icon="mdi-alert"
				> 
				Posible Promoción disponible con los productos seleccionados, verifique que el pago no sea en tarjeta para aplicar el descuento.
				<v-btn outlined text color="red" @click="ActivadorPromos = true"> Aplicar Descuento </v-btn>
				</v-alert>
				<v-alert
				v-if="puntos > 0 && clienteCedula != ''"
					text
					prominent
					type="green"
					icon="mdi-alert"
				> 
				{{Moneda()}} {{puntos}} puntos disponibles
				</v-alert>
				<v-card class="mx-1 var" >
					<v-flex sm12 style="color:grey; font-size: min(max(8px, 1vw), 12px);">
						<b>
						<b >Pre Total: {{Moneda()}} {{(calcularPreTotal)}} |
							Pre Total Gravado: {{Moneda()}}  {{totalGravado=(calcularImpuestoTotal)}} |
							Pre Total Exento: {{Moneda()}}  {{totalExento=(calcularExento)}}</b> <br>
						Exento: {{Moneda()}}  {{totalExento=(calcularExento) | formatNumber}}</b> <br>
						<b > Sub Total: {{Moneda()}} {{totalParcial=(calcularSubTotal) | formatNumber}} <br>
						Descuento: {{Moneda()}}  {{totalDescuento=(calcularDescuento)}} </b> <br>
						<b >IVA 1%: {{Moneda()}}  {{imp1=(calcularimp1) | formatNumber}} |
						IVA 2%: {{Moneda()}}  {{imp2=(calcularimp2) | formatNumber}} |
						IVA 4%: {{Moneda()}}  {{imp4=(calcularimp4) | formatNumber}} |
						IVA 13%: {{Moneda()}}  {{imp13=(calcularimp13) | formatNumber}}
						Imp Especial: {{Moneda()}}  {{impEspecial=(calcularImpEspecial) | formatNumber}} |</b>
						
						<b>Total Iva: {{Moneda()}}  {{totalImpuesto=(calcularImpuesto) | formatNumber}}</b>
						{{orden}}
						<br>
						<v-icon small> mdi-printer </v-icon> POS:{{ip1}} <v-icon small> mdi-printer </v-icon> COCINA {{ip2}} {{Regimen}}
						<br> <b v-if="esAdministrador || esSupervisor">Costo: {{Moneda()}}{{calcularCosto}} Utilidad: {{Moneda()}}{{(total - calcularCosto) | formatNumber}} </b>
						
					</v-flex>
					<v-flex sm12 style="font-size: min(max(20px, 1.9vw), 40px);">
						<b >Total: </b> {{Moneda()}} {{total=(calcularTotal) | formatNumber}} 
					</v-flex>
					<v-btn small outlined color="error" class="btnLimpiarGrid mr-1" @click="eliminarLinea()">
						<v-icon > mdi-delete </v-icon>
					</v-btn> 
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador || esRecepcion || esTaller"  v-bind="attrs" color="accent"  v-on="on" class="btnLimpiarGrid mr-1" @click="ExonerarProductos()">
							<v-icon > mdi-content-cut </v-icon>
							</v-btn> 
						</template>
						<span>Da click para exonerar el documento</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador || esTaller"  v-bind="attrs" color="accent"  v-on="on" class="btnLimpiarGrid mr-1" to="/compras" >
							<v-icon > mdi-shopping</v-icon>
							</v-btn> 
						</template>
						<span>Registrar nueva compra</span>
					</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-if="esAdministrador || esSupervisor || esBodega || esFacturador || esVendedor || esRecepcion || esTaller"  v-bind="attrs" color="accent"  v-on="on" class="btnLimpiarGrid mr-1" @click="dialogdescuento = true">
								<v-icon > mdi-sale </v-icon>
								</v-btn> 
							</template>
							<span>Digita un descuento para toda la factura</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador || esTaller"  v-bind="attrs" color="accent" class="btnLimpiarGrid mr-1" v-on="on" to="/repventas">
								<v-icon > mdi-file-document-multiple </v-icon>
								</v-btn> 
							</template>
							<span>Consulta de Facturas</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador"  v-bind="attrs" color="accent" class="btnLimpiarGrid mr-1" v-on="on" to="/clientes">
								<v-icon > mdi-account-plus </v-icon>
								</v-btn> 
							</template>
							<span>Clientes</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador || esTaller"  v-bind="attrs" color="accent" class="btnLimpiarGrid mr-1" v-on="on" to="/cuentasporcobrar" >
								CxC
								</v-btn> 
							</template>
							<span>Cuentas Por Cobrar</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-if="esAdministrador || esSupervisor || esVendedor || esBodega || esFacturador || esTaller"  v-bind="attrs" color="accent" class="btnLimpiarGrid mr-1" v-on="on" @click="NCManual()" >
								NC M
								</v-btn> 
							</template>
							<span>Nota de crédito manual</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small outlined v-bind="attrs" color="accent"  v-on="on" @click="ConsultaAperturaCajon" class="btnLimpiarGrid mr-1" >
								<v-icon >mdi-cash-register</v-icon>
								</v-btn> 
							</template>
							<span>Abrir cajón de dinero</span>
						</v-tooltip>
						<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn small outlined text v-bind="attrs" color="accent"  v-on="on" @click="DesactivarPromo" class="btnLimpiarGrid mr-1" id="espacioBoton">
									<v-icon >mdi-cookie-off </v-icon>
									</v-btn> 
								</template>
								<span>Desabilitar promociones para esta factura</span>
							</v-tooltip>
						<v-btn small outlined v-if="esFacturador || esRecepcion || esTaller"  v-bind="attrs" color="accent" class="btnLimpiarGrid mr-1"
						v-on="on"  to="/inventarioactual">
							Inventario
						</v-btn> 
						<v-menu top :offset-y="offset">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
								small
								class="btnLimpiarGrid mr-1"
								outlined
								v-bind="attrs"
								v-on="on"
								> LP
								</v-btn>
							</template>

							<v-list>
								<v-list-item @click="SetPrecioVenta()">
								<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Precio Venta</v-list-item-title>
								</v-list-item>
								<v-list-item @click="SetPrecioCentral()">
									<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Precio Central</v-list-item-title> 
								</v-list-item>
								<v-list-item @click="SetPrecioMayor()">
									<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Precio Mayor</v-list-item-title>
									</v-list-item>
								<v-list-item @click="SetPrecioDetalle()">
									<v-list-item-title><v-icon >mdi-barcode-scan</v-icon> Precio al Detalle</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-menu top :offset-y="offset">
							<template v-slot:activator="{ on, attrs }">
								
								<v-btn
								small
								@click="listarAsociadas"
								outlined
								v-bind="attrs"
								v-on="on"
								> Pedido
								</v-btn>
							</template>

							<v-list dense>
								<v-list-item 
									v-for="(localidad, index) in Localidades" 
									:key="index" 
									@click="SelectOrden(localidad)"
								>
									<v-list-item-content>
									<v-list-item-title>{{ localidad }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-btn v-if="esAdministrador || esSupervisor" small outlined @click="imprimirTicket"> Print </v-btn>
						<v-btn :loading="loading" large="" v-if="$route.params.id == '0' && esCrifasa" color="primary" class="mr-4 mt-3" style="color: white;" @click="CrearProforma2()" >
							<v-icon> mdi-file-export </v-icon> Crear Orden
						</v-btn> 
						<v-btn :loading="loading" large="" v-if="$route.params.id != '0' && esCrifasa" color="primary"  class="mr-4 mt-3" style="color: white;" @click="ActualizarProforma()" >
							<v-icon> mdi-file-export </v-icon> Actualizar Orden
						</v-btn>
						<v-toolbar-items class="hidden-md-and-down" >
							<div> <v-icon> mdi-home-account </v-icon> {{localidad}} </div>
							<div> <v-icon> mdi-account-circle </v-icon> {{userName}} </div>
						</v-toolbar-items>
						<v-text-field v-model="ReferenciaFactura" filled persistent-hint hint="Puede obtener el numero de factura desde el reporte de ingresos, a cual desea aplicar la nota de crédito" v-if="NotaCreditoFactura" label="Referencia de Factura" /> 
				</v-card>
			</v-flex>
        </v-layout>
		<v-dialog max-width="400" v-model="dialogToken">
          <template>
            <v-card rounded="lg">
              <v-card-title class="d-flex justify-space-between align-center">
                <div class="text-h5 text-medium-emphasis ps-2">
                  Ingrese el token de acceso
                </div>

                <v-btn
                  icon="mdi-close"
                  variant="text"
                  @click="isActive.value = false"
                ></v-btn>
              </v-card-title>

              <v-divider class="mb-4"></v-divider>

              <v-card-text>
                <div class="text-medium-emphasis mb-4">
                 	Este código puede ser obtenido con cualqueir usuario supervisor o administrador.
                </div>

                <v-text-field
                  class="mb-2"
                  rows="2"
				  v-model="TokenDigitado"
                  variant="outlined"
                  persistent-counter
                />

                <div class="text-overline mb-2">💎 Token</div>
              </v-card-text>

              <v-divider class="mt-2"></v-divider>

              <v-card-actions class="my-2 d-flex justify-end">
                <v-btn
                  class="text-none"
                  rounded="xl"
                  text="Cancel"
                  @click="dialogToken = false"
                >Cancelar</v-btn>

                <v-btn
                  class="text-none"
                  color="primary"
                  rounded="xl"
                  variant="flat"
                  @click="ConfirmacionToken()"
                >Aceptar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
		<v-dialog
           v-model="modelCarga"
            width="300"
            dark
		>
            <v-card
              color="white"
              
            >
              <v-card-text class="black--text">
                Por Favor, Espere..
                <v-progress-linear
                  indeterminate
                  color="black"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
              <v-img
                  src="https://i.pinimg.com/originals/e2/6d/87/e26d873ee68fbcd9dc1c40d8b0c6b3b4.gif"
                  class="my-3"
                  contain
                  height="200"
              ></v-img>
            </v-card>
        </v-dialog>
		<v-dialog
			v-model="dialogdescuento"
			max-width="390"
			>
			<v-card>
				<v-card-title class="headline">
				Aplicar Descuento
				</v-card-title>
				<v-text-field hint="Para utilizar esta funcion debe digitar el porcentaje de descuento que desea aplicar a toda la factura y despúes dar click en el botón con el simbolo porcentual"
				label="Descuento al total de factura" autofocus @keyup.enter="AplicarDescuento()" dense rounded v-model="descuentototal" outlined> </v-text-field>
				<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="error"
					text
					@click="dialogdescuento = false"
				>
					Salir
				</v-btn>

				<v-btn
					color="green darken-1"
					text
					@click="AplicarDescuento()"
				>
					Aplicar Descuento %
				</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogNota"
			max-width="390"
			>
			<v-card>
				<v-card-title class="headline">
					Nota de crédito como pago
				</v-card-title>
				<v-text-field hint="Digite el numero de factura interno de nota de crédito a cual desea aplicar como método de pago para esta venta"
				label="No Factura interno" autofocus @keyup.enter="BuscarNotaCredito()" dense rounded v-model="noFactura" outlined> </v-text-field>
				<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="error"
					text
					@click="dialogdescuento = false"
				>
					Salir
				</v-btn>
				<v-btn
					color="green darken-1"
					text
					@click="BuscarNotaCredito()"
				>
					Buscar Documento
				</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="modelSeriales" persistent max-width="800" class="primary">
			<v-toolbar  dark color="primary" class="font-weight-light body-1">
				<h4>Agregar códigos Seriales</h4>
				<v-card-subtitle>Producto: {{nombre}} </v-card-subtitle>
			</v-toolbar>
			<v-container fluid>
				<v-col cols="12" sm="12">
					<v-form ref="form" v-model="validFactura"  @submit.prevent="facturar">
						<v-row>
							<v-col class="mt-2" cols="12" sm="10">
								<v-text-field clearable v-model="serial" @keyup.enter="agregarSerial()" label="Escanear o digitar Código"></v-text-field>
							</v-col>
							<v-col class="mt-2" cols="12" sm="2">
								<v-btn  @click="agregarSerial()"> Agregar</v-btn>
							</v-col>
							<v-col cols="12" sm="12">
								<v-data-table
									:headers="cabeceraSeriales"
									single-select
									:items="seriales"
									v-model="selected">
									<template slot="no-data">
										<h3>No hay artículos agregados al detalle.</h3>
									</template> 
									<template v-slot:item.actionmovimiento="{ item }">
										<v-checkbox
										v-model="item.existe"
										:label="`Agregar`"
										></v-checkbox>

									</template>
									<template v-slot:item.actioncantidad="{ item }"> 
										<v-text-field v-model="item.cantidadIngreso">  </v-text-field>
									</template> 

								</v-data-table>
							<v-btn  color="primary"  class="mr-4" style="top: 10px;" @click="guardarSeriales()">
								Agregar Seriales
							</v-btn>
							<v-btn color="error" id="espacioBoton" @click="modelSeriales = false">
								Cancelar
							</v-btn> 
							</v-col>
						</v-row>
					</v-form>
				</v-col>
			</v-container>
		</v-dialog>
		<v-dialog v-model="modelCabys" persistent max-width="800" class="primary">
			<v-toolbar  dark color="primary" class="font-weight-light body-1">
				<h4>Agregar código CAByS</h4>
				<v-card-subtitle>Producto: {{nombre}} {{codigoProducto}} </v-card-subtitle>
				</v-toolbar>
				<v-card>
				<v-container fluid>
					<v-col cols="12" sm="12">
						<v-form ref="form" v-model="validFactura"  @submit.prevent="facturar">
							<v-row>
							<v-col class="mt-2" cols="12" sm="10">
								<v-text-field clearable v-model="serial" @keyup.enter="agregarCabys()" label="Digitar Código"></v-text-field>
							</v-col>
							<v-col class="mt-2" cols="12" sm="2">
								<v-btn  @click="agregarCabys()"> Agregar</v-btn>
							</v-col>
								<v-col cols="12" sm="12">
								<v-btn  color="primary"  class="mr-4" style="top: 10px;" @click="agregarCabys()">
								Agregar Seriales
								</v-btn>
								<v-btn color="error" id="espacioBoton" @click="modelCabys = false">
								Cancelar
								</v-btn> 
								<v-btn color="success"  class="mx-4"  @click="abrirCabys()">Catalogo CABYS</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-col>
			</v-container>
			</v-card>
		</v-dialog>
		<v-dialog v-model="modelDetalle" persistent max-width="800" class="primary">
			<v-toolbar  dark color="primary" class="font-weight-light body-1">
				<h4>Agregar Detalle</h4>
				<v-card-subtitle>Producto: {{nombre}} {{codigoProducto}} </v-card-subtitle>
			</v-toolbar>
			<v-card>
			<v-container fluid>
				<v-col cols="12" sm="12">
				<v-form ref="form" v-model="validFactura">
				<v-row>
				<v-col class="mt-2" cols="12" sm="10">
					<v-textarea auto-grow prepend-icon="mdi-comment" clearable v-model="detalleFactura" label="Digitar detalle"></v-textarea>
				</v-col>
					<v-col cols="12" sm="12">
					<v-btn  color="primary"  class="mr-4" style="top: 10px;" @click="AddDetail()">
					Agregar Detalle
					</v-btn>
					<v-btn color="error" id="espacioBoton" @click="modelDetalle = false">
					Cancelar
					</v-btn> 
					</v-col>
				</v-row>
				</v-form>
				</v-col>
			</v-container>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogAgregarProducto" persistent max-width="500">
			<v-card>
				<v-container fluid>
					<v-row>
					<div style="display:none">
					<v-text-field clearable type="text" v-model="indexProducto" hidden></v-text-field>
					</div>
					<v-col cols="6" sm="12">
					<v-text-field clearable type="text" readonly v-model="codigoArticulo2" label="Código"></v-text-field>
					</v-col>
					<v-col cols="6" sm="12">
					<v-text-field clearable type="text" readonly v-model="descripcion2" label="Descripcion"></v-text-field>
					</v-col>
					<v-col cols="6" sm="12">
					<v-text-field clearable type="number" v-model="cantidadDialog2" v-on:keyup="agregarProducto()" min="1" label="Cantidad"></v-text-field>
					</v-col>
					<v-col cols="6" sm="12">
					<v-text-field clearable type="number" v-model="descuento2" min="0" label="Descuento"></v-text-field>
					</v-col>
					<div style="display:none">
					<v-text-field clearable type="number" hidden v-model="precio2" label="Precio"></v-text-field>
					<v-text-field clearable type="number" hidden v-model="impuestoDialog2" label="Impuesto"></v-text-field>
					<v-text-field clearable type="number" hidden v-model="subtotal2" label="Subtotal"></v-text-field>
					<v-text-field clearable type="text" hidden v-model="valorImpuesto2" label="ValorImpuesto"></v-text-field>
					<v-text-field clearable type="text" hidden disabled v-model="gravado2" label="Gravado"></v-text-field>
					</div>
					<v-btn  color="primary" id="espacioBoton" class="mr-4" style="top: 10px; color: white;" @click="agregarProducto()">
					Agregar
					</v-btn>
					<v-btn color="error" id="espacioBoton" @click="dialogAgregarProducto = false">
					Cancelar
					</v-btn>
					</v-row>
				</v-container>
        	</v-card>
      	</v-dialog>
        <v-dialog persistent v-model="dialogEfectivo"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Efectivo</h4>
                
            </v-toolbar>
            <v-card>
                <v-col cols="12" sm="12"> 
                  <v-text-field id="PagoEnEfectivo" autofocus @keyup.enter="PagoEfectivo()" rounded="" onfocus="this.select();" v-model="efectivoPagar"  label="Pago en efectivo"></v-text-field>
               
                    <v-btn class="mr-2 mx-2" @click="PagoEfectivo()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-col>
				<v-col v-if="monedaPago == 'CRC'" cols="12" sm="12">
					<v-img class="mt-2 mx-2 rounded-lg"  @click="Paga1000()" max-height="100" max-width="200" :src="require('../assets/Mil.jpg')"> </v-img> 
					<v-img class="mt-2 mx-2 rounded-lg"  @click="Paga2000()" max-height="100" max-width="200" :src="require('../assets/DosMil.jpg')"> </v-img> 
					<v-img class="mt-2 mx-2 rounded-lg"  @click="Paga5000()" max-height="100" max-width="200" :src="require('../assets/CincoMil.jpg')"> </v-img> 
					<v-img class="mt-2 mx-2 rounded-lg"  @click="Paga10000()" max-height="100" max-width="200" :src="require('../assets/DiezMil.jpg')"> </v-img> 
					<v-img class="mt-2 mx-2 rounded-lg"  @click="Paga20000()" max-height="100" max-width="200" :src="require('../assets/VeinteMIl.jpg')"> </v-img> 
				</v-col>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogTarjeta"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Tarjeta</h4>
                
            </v-toolbar>
            <v-card>
				<v-container fluid>
					<v-row > 
					<v-text-field id="PagoEnTarjeta" autofocus @keyup.enter="PagoTarjeta()" rounded="" v-model="tarjetaPagar" onfocus="this.select();" label="Pago en Tarjeta"></v-text-field>
					
					<v-select  rounded="" v-model="banco" :items="bancos" label="Banco"></v-select>
					
					<v-text-field @keyup.enter="PagoTarjeta()" rounded="" v-model="comprobantePago" label="Número de referencia"></v-text-field>
				
					<v-text-field @keyup.enter="PagoTarjeta()" rounded="" v-model="señas"  label="Otras señas(opcional)"></v-text-field>
					
					
						<v-btn color="success" class="mr-2 mx-2" @click="PagoTarjeta()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
						<v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
					</v-row>
					
				</v-container>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogDeposito"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Deposito</h4>
                
            </v-toolbar>
            <v-card>
				<v-container fluid>
					<v-row > 
					<v-text-field id="PagoEnDeposito" autofocus @keyup.enter="PagoDeposito()" rounded="" v-model="depositoPagar" onfocus="this.select();" label="Pago en deposito"></v-text-field>
					
					<v-select  rounded="" v-model="banco" :items="bancos" label="Banco"></v-select>
					
					<v-text-field @keyup.enter="PagoDeposito()" rounded="" v-model="comprobantePago"  label="Número de referencia"></v-text-field>
					
					<v-text-field @keyup.enter="PagoDeposito()" rounded="" v-model="señas"  label="Otras señas"></v-text-field>
					
						<v-btn color="success" class="mr-2 mx-2" @click="PagoDeposito()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
						<v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
					</v-row>
				</v-container>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogSinpe"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en SINPE Móvil</h4>
                
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <v-row > 
                  <v-text-field id="PagoSinpeField" autofocus @keyup.enter="PagoSinpe()" rounded="" onfocus="this.select();" v-model="SinpePagar"  label="Pago en SINPE Móvil"></v-text-field>
                
                  <v-text-field @keyup.enter="PagoSinpe()" rounded="" type="tel" onfocus="this.select();" v-model="comprobantePago"  label="Número de SINPE"></v-text-field>
               
                  <v-text-field @keyup.enter="PagoSinpe()" rounded="" v-model="señas"  label="Otras señas"></v-text-field>
                
                    <v-btn color="sucess" class="mr-2 mx-2" @click="PagoSinpe()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-row>

            </v-container>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogCheque"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
              <h4 >Dolar Payment</h4>
            </v-toolbar>
            <v-card>
            <v-container fluid>
              <v-row > 
                <v-text-field id="dolares" class="text-h4" onfocus="this.select();" @keyup.enter="PagoDolaresMethod()" rounded="" v-model="PagoDolares"  label="$"></v-text-field>
                <v-btn large outlined color="success" class="mr-2 mx-2" @click="PagoDolaresMethod()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                <v-btn large outlined color="error" @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
              </v-row>
            </v-container>
            </v-card>
      	</v-dialog>
		<v-dialog persistent v-model="dialogpuntos"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
              <h4>Puntos </h4>
            </v-toolbar>
            <v-card>
            <v-container fluid>
              <v-row > 
                <v-text-field hint="Solo se permite aplicar el 50% de la factura en puntos" persistent-hint id="dolares" onfocus="this.select();" @keyup.enter="PuntosMetodoPago()" rounded="" v-model="puntosAplicados"  label="Cantidad de puntos aplicar"></v-text-field>
                <v-btn large outlined color="success" class="mr-2 mx-2" @click="PuntosMetodoPago()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                <v-btn large outlined color="error" @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
              </v-row>
            </v-container>
            </v-card>
      	</v-dialog>
        <v-dialog v-model="dialogPago" persistent max-width="1300">
            <v-card>
					<v-toolbar dark color="primary">
					<v-toolbar-title >PROCESO DE PAGO</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items >
						<v-btn icon dark @click="dialogPago = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
					</v-toolbar> 
					<v-container>
						<v-row >
							<v-flex xs6 sm3 md3>
								<v-text-field class="mx-1" outlined type="text"  filled	hide-details="" v-model="clienteNombre" label="Nombre:"></v-text-field>
								<v-select class="mx-1" outlined type="tel" :items="tipoDocumentos" hide-details="" filled  v-model="clienteTipoCedula" label="Tipo de Cédula:"></v-select>
								<v-textarea
									label="Detalle:"
									auto-grow
									outlined
									hide-details=""
									class="mx-1"
									rows="1"
									filled
									row-height="25"
									v-model="detalleFactura"
								></v-textarea>
							</v-flex>
							<v-flex xs6 sm3 md3>
								<v-text-field hide-details="" @input="validateInputCedula" class="mx-1" outlined type="text" @change="BuscarPersona()" clearable filled  v-model="clienteCedula" label="Cédula:"></v-text-field>
								<v-text-field hide-details="" class="mx-1" outlined type="email"  filled v-model="clienteCorreo" label="Correo:"></v-text-field>
								<v-select hide-details="" class="mx-1" outlined="" :readonly="esVendedor" filled v-model="vendedor" :items="Vendedores" color="success"></v-select>
							</v-flex>
							<v-flex xs6 sm3 md3>
								
								<v-text-field hide-details="" class="mx-1" outlined="" filled v-model="RefXML" color="success" :label="`Referencia(MM) u Orden de compra`"></v-text-field>
								<v-text-field hide-details="" class="mx-1" outlined type="email"  filled v-model="clienteCorreo2" label="Correo2:"></v-text-field>
							</v-flex>
							<v-flex xs6 sm3 md3>
								<v-menu
									class="mx-1"
									v-model="menu2"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="vencimiento"
										label="Vence"
										append-icon="mdi-calendar"
										readonly
										filled
										class="mx-1"
										outlined
										hide-details=""
										v-bind="attrs"
										v-on="on"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="vencimiento"
									@input="menu2 = false"
									></v-date-picker>
								</v-menu>
								<v-text-field class="mx-1" hid append-icon="mdi-phone" outlined="" filled v-model="clienteTelefono" color="success" :label="`Tel`"></v-text-field>
								
							</v-flex>
							<v-flex xs12 sm3 md6 v-if="SaldoAgotado">
								<v-flex class="h6">
								<strong class="error--text">Lo sentimos, Haz agotado tu limite de facturas</strong>
								<p>Plan Actual:  {{Plan}} <br>
								<div>Limite Fact:  {{LimiteFacturas}}</div> <br>
								<div>Facturas Realizadas este mes: {{FacturasRealizadas}}</div> <br>
								<div>Saldo de Facturas: {{SaldoFacturas}}</div> <br> 
								</v-flex>
								<v-btn link href="https://chat.whatsapp.com/DGSSGdXIZd98DpWH5QxiVr" block="" color="info"> Ascender de Plan </v-btn>
							</v-flex>
							<v-flex xs6 sm6 md6>
								<v-card-text>
								<div class="primary--text font-weight mx-4">Método de Pago </div>
									<v-row v-if="vueltoPagar < 0" class="mx-3"> 
											<v-list class="mx-1">
												<button @click="abrirSinpe()" class="payment-button cash">
													<div class="button-content">
													<v-img  @click="abrirSinpe()" max-height="55" max-width="55" :src="require('../assets/SINPEMOVIL.jpeg')"> </v-img> 
													<span>Sinpe</span>
													</div>
												</button>
											</v-list>  
											<v-list class="mx-1">
												<button @click="abrirDeposito()" class="payment-button cash">
													<div class="button-content">
													<i class="mdi mdi-bank"></i>
													<span>Depósito</span>
													</div>
												</button>
											</v-list>  
											<v-list class="mx-1">
												<button @click="abrirTarjeta()" class="payment-button cash">
													<div class="button-content">
													<i class="mdi mdi-credit-card"></i>
													<span>Tarjeta</span>
													</div>
												</button>
											</v-list>
											<v-list class="mx-1">
												<button @click="abrirEfectivo()" class="payment-button cash">
													<div class="button-content"> 
													<i class="mdi mdi-cash"></i><br>
													<span>Efectivo</span>
													</div>
												</button>
											</v-list >
											<v-list class="mx-1" v-if="monedaPago =='CRC'">
												<button v-if="monedaPago =='CRC'" @click="abrirCheque()" class="payment-button cash">
													<div class="button-content">
													<i class="mdi mdi-currency-usd"></i>
													<span>Dolares</span>
													</div>
												</button>
											</v-list> 
											<v-list class="mx-1" v-if="monedaPago =='CRC'">
												<button @click="abrir_rapi()" class="payment-button cash">
													<div class="button-content">
													<v-img  @click="abrir_rapi()" max-height="55" max-width="55" :src="require('../assets/logo_rapi.png')"> </v-img> 
													<span>Rappi</span>
													</div>
												</button>
											</v-list> 
											<v-list class="mx-1" v-if="puntos > 0 && clienteCedula != ''">
												<button v-if="monedaPago =='CRC'" @click="abrirPuntos()" class="payment-button cash">
													<div class="button-content">
													<i class="mdi mdi-star-half-full"></i>
													<span>Puntos</span>
													</div>
												</button>
											</v-list> 
											<v-btn @click="dialogNota = true" color="#ddfcf9" small>Nota Crédito </v-btn>
									</v-row>
									<v-btn v-if="esAdministrador || esSupervisor || esVendedor || esFacturador || esBodega || esTaller" block="" x-large :loading="loading" type="submit" color="primary" id="BotonPagar" autofocus class="pa-2" style="top: 10px;" @click="pagar()" @click.stop="dialog = false">
										Pagar
									</v-btn>
									
								</v-card-text>
							</v-flex>
							<v-flex xs6 sm6 md6 class="grey lighten-4 blockquote">
								<v-flex class="h6">
									<div style="color:grey; font-size: min(max(15px, 1vw), 12px);">  <small> Efectivo: {{Moneda()}} {{efectivoPagar}}</small> |
										<small>Tarjeta: {{Moneda()}} {{tarjetaPagar}} </small> |
										<small>Depositos: {{Moneda()}} {{depositoPagar}}
											Sinpe: {{Moneda()}} {{SinpePagar}} 
											NC: {{Moneda()}} {{totalNC}}
											<b v-if="monedaPago == 'CRC'">$: {{Moneda()}} {{PagoDolares}} </b>
										</small>
									</div>
									<div style="color:grey; font-size: min(max(15px, 1vw), 12px);" class="indigo--text">  <small> IVA: {{Moneda()}} {{totalImpuesto=(calcularImpuesto)}} </small> 
									</div>
									
									<strong v-if="vueltoPagar < 0" style="font-size: min(max(20px, 1.9vw), 35px);" class="red--text"> Faltante {{Moneda()}} {{vueltoPagar}} </strong>
									
                            		<strong v-if="vueltoPagar >= 0" style="font-size: min(max(20px, 1.9vw), 35px);" class="green--text"> Vuelto {{Moneda()}} {{vueltoPagar.toFixed(2)}}
									<strong v-if="monedaPago == 'USD'"> Vuelto ₡ {{(vueltoPagar*TipoCambioInterno).toFixed(2)}} </strong> </strong> <br>
									<strong style="font-size: min(max(25px, 1.9vw), 40px);" class="primary--text">Total: {{Moneda()}} {{Total=calcularTotal}} | 
									<strong v-if="monedaPago =='CRC'">  ${{ TotalDolares = (Total/TipoCambioInterno).toFixed(2)}} </strong>
									<strong v-if="monedaPago =='USD'">  ₡{{ (Total*TipoCambioInterno).toFixed(2)}} </strong> </strong>
									<div class="text-caption"> <small>Saldo Facts:  {{SaldoFacturas}}</small>  |
									<small>Banco Central $:  Compra:{{Compra}}  | Venta: ${{Venta}} Tipo Cambio Interno: {{TipoCambioInterno}} </small>  </div>  
									<div class="text-caption">Fuente: Banco Central de Costa Rica  </div>
									<v-btn :loading="loading" large="" v-if="$route.params.id == '0'" color="primary" :disabled="!validFactura" id="espacioBoton" class="mr-4 mt-3" style="top: 10px; color: white;" @click="CrearProforma2()" >
										<v-icon> mdi-file-export </v-icon> Crear Proforma
									</v-btn> 
									<v-btn :loading="loading" large="" v-if="$route.params.id != '0'" color="primary" :disabled="!validFactura" id="espacioBoton" class="mr-4 mt-3" style="top: 10px; color: white;" @click="ActualizarProforma()" >
									<v-icon> mdi-file-export </v-icon> Actualizar Proforma
									</v-btn> 
									<v-btn color="teal darken-1" large outlined class="mr-4 mt-3" style="top: 10px; color: white;" @click="limpiarPago()">
									<v-icon> mdi-update </v-icon> Limpiar
									</v-btn>
									<v-btn color="error" outlined large class="mr-4 mt-3" style="top: 10px; color: white;"  @click="dialogPago = false">
									<v-icon> mdi-exit-to-app </v-icon> Atrás
									</v-btn>
									
									<v-checkbox
										v-model="EnviarEmail"
										color="green"
										prepend-icon="mdi-email"
									></v-checkbox>
									<v-btn outlined small text @click="SendBill()"> Enviar Correo </v-btn>
								</v-flex>
							</v-flex>
						</v-row>
					</v-container>
					
			</v-card>
        </v-dialog>
        <v-dialog v-model="dialogPagoCredito" persistent max-width="1300">
            <v-card>
                <v-toolbar dark color="primary">
                <v-toolbar-title>Proceso de Crédito</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="dialogPagoCredito = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
                </v-toolbar>
                <v-card-title class="title font-weight-regular">
                </v-card-title>
                <v-card-text>
                <v-container fluid>
                    <v-row>
						<v-col cols="12" sm="4">
							<v-text-field outlined type="text" hide-details="" dense  v-model="clienteNombre" label="Nombre:"></v-text-field>
							<v-select outlined type="tel" hide-details="" :items="tipoDocumentos"  dense  v-model="clienteTipoCedula" label="Tipo de Cédula:"></v-select>
								<v-textarea
									label="Detalle:"
									auto-grow
									outlined
									rows="1"
									dense
									hide-details=""
									row-height="25"
									v-model="detalleFactura"
								></v-textarea>
						</v-col>
						<v-col cols="12" sm="4">
							<v-text-field hide-details="" @input="validateInputCedula" outlined type="text" @change="BuscarPersona()" clearable dense  v-model="clienteCedula" label="Cédula:"></v-text-field>
							<v-text-field hide-details="" outlined type="email"  dense v-model="clienteCorreo" label="Correo:"></v-text-field>
							<v-select hide-details="" outlined="" :readonly="esVendedor" dense v-model="vendedor" :items="Vendedores" color="success" :label="`Vendedor`"></v-select>
						</v-col>
						<v-col cols="12" sm="2">
							<v-text-field hide-details="" outlined="" dense v-model="RefXML" color="success" :label="`Referencia(MM) u Orden de compra`"></v-text-field>
							<v-text-field hide-details="" outlined type="email"  dense v-model="clienteCorreo2" label="Correo2:"></v-text-field>
						</v-col>
						<v-col cols="12" sm="2">
							<v-menu
								v-model="menu2"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="vencimiento"
									label="Vence"
									append-icon="mdi-calendar"
									readonly
									hide-details=""
									class="mx-1"
									dense
									outlined
									v-bind="attrs"
									v-on="on"
								></v-text-field>
								</template>
								<v-date-picker
								v-model="vencimiento"
								@input="menu2 = false"
								></v-date-picker>
							</v-menu>
							<v-text-field append-icon="mdi-phone" outlined="" dense v-model="clienteTelefono" hide-details="" color="success" :label="`Tel`"></v-text-field>
							<v-text-field outlined dense v-model="diasCredito" label="Dias de crédito"></v-text-field>
						</v-col>
						<v-col cols="6" sm="6">
							<div class="primary--text font-weight">Método de Pago </div>
								<v-row> 
									<div class="payment-buttons">
										<v-list class="mx-1">
											<button @click="abrirSinpe()" class="payment-button cash">
												<div class="button-content">
												<v-img  @click="abrirSinpe()" max-height="55" max-width="55" :src="require('../assets/SINPEMOVIL.jpeg')"> </v-img> 
												<span>Sinpe</span>
												</div>
											</button>
										</v-list>  
										<v-list>
										<button @click="abrirEfectivo()" class="payment-button cash">
											<div class="button-content"> 
											<i class="mdi mdi-cash"></i><br>
											<span>Efectivo</span>
											</div>
										</button>
										</v-list>
										<v-list>
										<button @click="abrirTarjeta()" class="payment-button cash">
											<div class="button-content">
											<i class="mdi mdi-credit-card"></i>
											<span>Tarjeta</span>
											</div>
										</button>
										</v-list>
										<button @click="abrirDeposito()" class="payment-button cash">
											<div class="button-content">
											<i class="mdi mdi-bank"></i>
											<span>Depósito</span>
											</div>
										</button>
									</div>
								</v-row>
						</v-col>
						<v-col cols="12" sm="6" class="grey lighten-4 blockquote">
							<v-flex class="h6">
								<div>  <small> Abono Efectivo: {{Moneda()}} {{efectivoPagar}}</small> |
								<small>Aboono Tarjeta: {{Moneda()}} {{tarjetaPagar}} </small> |
								<small>Depositos: {{Moneda()}} {{depositoPagar}} 
									Depositos: {{Moneda()}} {{SinpePagar}} </small></div>
							<div class="indigo--text">  <small> IVA: {{Moneda()}} {{totalImpuesto=(calcularImpuesto)}} </small> |
								Vuelto: {{Moneda()}} {{vueltoPagar}}</div>
							<strong class="text-h4 primary--text">Total: {{Moneda()}} {{Total=calcularTotal | formatNumber}} | ${{ TotalDolares = (Total/TipoCambioInterno).toFixed(2)}} </strong> <br>
							<strong class="text-h6 primary--text">Saldo Pendiente: {{Moneda()}} {{saldo}} </strong> <br>
							<div class="text-caption"> <small>Saldo Facts:  {{SaldoFacturas}}</small>  |
								<small>Banco Central $:  Compra:{{Compra}}  | Venta: ${{Venta}} Tipo Cambio Interno: {{TipoCambioInterno}} </small>  </div>  
							<div class="text-caption">Fuente: Banco Central de Costa Rica  </div>
							
							</v-flex>
						</v-col>
						<v-col cols="7" sm="7">
							<v-btn :loading="loading" large type="submit" color="primary" id="espacioBoton" class="mr-4" style="top: 10px;" @click="pagarCredito()" @click.stop="dialog = false">
								Facturar a Crédito
							</v-btn>
							<v-btn :loading="loading" large="" v-if="$route.params.id != '0'" color="primary" class="mr-4" style="top: 10px; color: white;" @click="CrearODT()" >
								<v-icon> mdi-tools </v-icon> Crear ODT
							</v-btn> 
							<v-btn color="primary" large class="mr-4" style="top: 10px; color: white;" @click="limpiarPago()">
								Limpiar
							</v-btn>
							<v-btn class="mr-4" large color="error" style="top: 10px; color: white;" @click="dialogPagoCredito = false">
							<v-icon> mdi-exit-to-app </v-icon>
							</v-btn> 
						</v-col>
                    </v-row>
                </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
		<v-dialog v-model="dialogCuenta"> 
			<v-card :loading="loading">
				
				<v-toolbar :loading="loading" color="primary"> <v-toolbar-title class="white--text"> Ordenes pendientes de facturación </v-toolbar-title> <v-spacer/>
					<v-btn x-large rounded outlined color="error" @click="dialogCuenta = false"> X</v-btn>
			  	</v-toolbar>
				<v-row class="mx-1">
					<v-card :style="{ height: 'auto' }" class="mx-auto justify-center align-center" width="350" v-for="(item , index) in Cuentas" :key="index">
						<v-toolbar dark color="#23262d"> 
							<div >Orden {{item.noFactura}} </div> <v-spacer />
							<a :href="`https://waze.com/ul?ll=${item.latitud},${item.longitud}&navigate=yes`" target="_blank">
								<i style="font-size: 34px;" class="mdi mdi-waze white--text"></i> 
							</a>
							<a :href="`https://www.google.com/maps/search/?api=1&query=${item.latitud},${item.longitud}`" target="_blank">
								<i style="font-size: 34px;" class="mdi mdi-google-maps white--text"></i> 
							</a>
						</v-toolbar>
						<v-edit-dialog
								:return-value.sync="item.estado"
								@save="updateOrdenExpress(item)"
								large
								persistent
						>
							<v-chip class="mt-2 white--text" :color="getColor2(item.estado)" style="font-size:20px">  {{EstadoNombre(item.estado)}}</v-chip>
							<template v-slot:input>
								<v-select
									v-model="item.estado"
									label="Seleccione El estado:"
									:items="Estados"
									></v-select>
							</template>
						</v-edit-dialog>
						
						<div class="mx-1" style="font-size:20px; color: secondary; border-bottom: 1px solid #DBDBDB;">  <b>Pago:</b> {{item.estadoPago}}<br>
							
							<v-edit-dialog
								:return-value.sync="item.tipoCompra"
								@save="updateOrdenExpress(item)"
								large
								persistent
							>
								<b> Entrega:{{item.tipoCompra}} </b>
								<template v-slot:input>
									<v-select
										v-model="item.tipoCompra"
										label="Seleccione el método de entrega:"
										:items="MetodosEntrega"
									></v-select>
								</template>
							</v-edit-dialog>
								
							</div>

							<p class="mx-1" style="font-size:12px; color: secondary;"> 
								No Orden {{item.noFactura}} 
								Guía {{item.orden}} 
								<v-edit-dialog
									:return-value.sync="item.nombre"
									@save="updateOrdenExpress(item)"
								>
									<b>Cliente:{{item.nombre}} </b>
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.nombre"
											label="Nombre del cliente:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								
								<v-edit-dialog
									:return-value.sync="item.telefono"
									@save="updateOrdenExpress(item)"
								>
									Teléfono {{item.telefono}}
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.telefono"
											label="Teléfono:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								
								<v-edit-dialog
									:return-value.sync="item.tipoPago1"
									@save="updateOrdenExpress(item)"
								>
									Tipo Pago:{{ item.tipoPago1 }}
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.tipoPago1"
											label="Tipo de pago:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.EstadoPago"
									@save="updateOrdenExpress(item)"
								>
									Estado Pago {{item.EstadoPago}} 
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.EstadoPago"
											label="Estado Pago:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.medioOrden"
									@save="updateOrdenExpress(item)"
								>
									Medio {{item.medioOrden}} 
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.medioOrden"
											label="Tomado por medio de:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.mensajero"
									@save="updateOrdenExpress(item)"
									large
								>
									<b>Mensajero {{item.mensajero}}  </b>
									<template v-slot:input>
										<v-select
											v-model="item.mensajero"
											:items="Mensajeros"
											label="Mensajero:"
										></v-select>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.cajero"
									@save="updateOrdenExpress(item)"
								>
									Agente {{item.cajero}} 
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.cajero"
											label="Agente:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.cedula"
									@save="updateOrdenExpress(item)"
								>
									Cédula {{item.cedula}} {{item.tipoCedula}} 
									<template v-slot:input>
										<v-text-field
											onfocus="this.select();"
											v-model="item.cedula"
											label="Cedula:"
										></v-text-field>
									</template>
								</v-edit-dialog>
								<v-edit-dialog
									:return-value.sync="item.direccion"
									@save="updateOrdenExpress(item)"
									large
									persistent
								>
									Dirección: {{item.direccion}}   {{item.latitud}}   {{item.longitud}}  
									<template v-slot:input>
										<v-textarea onfocus="this.select();"
											v-model="item.direccion"
											label="Direccion:"/>
									</template>
								</v-edit-dialog> 
								<v-edit-dialog
									:return-value.sync="item.nota"
									@save="updateOrdenExpress(item)"
									large
									persistent
								>
									Nota: {{item.nota}} 
									<template v-slot:input>
										<v-textarea onfocus="this.select();"
											v-model="item.nota"
											label="Nota:"/>
									</template>
								</v-edit-dialog> 
								Nota del Mensajero: <b>{{item.detalle}} </b>
									<br>
								₡{{item.total}}
							</p>
							<v-expansion-panels>
								<v-expansion-panel>
								<v-expansion-panel-header>
									Ver Productos
								</v-expansion-panel-header>

								<v-expansion-panel-content>
									<v-simple-table dense>
										<template v-slot:default>
										<thead>
											<tr>
											<th class="text-left">
												Item
											</th>
											<th class="text-left">
												Precio
											</th>
											<th class="text-left">
												Opciones
											</th>
											</tr>
										</thead>
										<tbody>
											<tr
											v-for="x in item.detalles"
											:key="x.name"
											>
											
											<td>{{x.descripcion}} <b>x{{x.cantidad}}</b></td>
											<td>
												<div v-if="x.descuento != 0">
													<s>{{x.precio * x.cantidad}} </s>
													{{calcularPrecioPromos(x)}}	
												</div>
												<div v-else>
													{{x.precio * x.cantidad}}
												</div>
												
											</td>
											<td><v-icon @click="BorrarLinea(x)"> mdi-delete </v-icon> </td>
											</tr>
										</tbody>
										</template>
									</v-simple-table>
								</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
							<v-card-text>
								<v-btn
									color="success"
									block
									large
									:loading="loading"
									@click="AñadirPOS(item,2)"
								>
									Facturar
								</v-btn>
							</v-card-text>
					</v-card>
				</v-row>
				
			</v-card>
		</v-dialog>
        <v-dialog v-model="verArticulos" max-width="1000px">
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title>SELECCIONE UN ARTICULO</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="verArticulos = false">
                      <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-btn color="primary" id="productoBoton"  dark @click.stop="dialogNuevoProducto = true">
              <v-icon> mdi-clipboard-plus </v-icon>
              </v-btn>
              <v-btn color="primary" id="productoBoton"  dark @click="selectProductos()" >
                <v-icon> mdi-reload </v-icon>
              </v-btn>
              <v-btn color="primary" id="productoBoton"  dark @click="dialogCalculadora = true" >
                <v-icon> mdi-calculator </v-icon>
              </v-btn>
              <v-btn color="primary" id="productoBoton"  dark @click="dialogPrecioVariable = true" >
                Precio Variable
              </v-btn>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <v-text-field
                                v-model="search"
                                label="Ingrese artículo a buscar"
                                single-line
                                hide-details
                                
                                solo
                              ></v-text-field>
                                <template>
                                    <v-data-table
                                        :headers="cabeceraArticulos"
                                        :items="articulos"
                                        :loading="articulos != []" 
                                        loading-text="Cargando productos, por favor espere"
                                        :search="search"
                                        @click:row="rowClickProducto"
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td>{{props.item.codigoProducto}}</td>
                                            <td>{{props.item.descripcion}}</td>
                                            <td>{{props.item.familia}}</td>
                                            <td>{{props.item.precioVenta}}</td>
                                            <td>{{props.item.cantidadInvActual}}</td>
                                        </template>
                                        <template slot="no-data">
                                            <h3>No hay artículos para mostrar.</h3>
                                        </template>
                                    </v-data-table> 
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="ocultarArticulos()" color="error">
                        Salir
                    </v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogProducto" persistent max-width="500">
            <v-card>
            <v-container fluid>
                <v-row>
                <div style="display:none">
                <v-text-field clearable type="text" v-model="indexProducto" hidden></v-text-field>
                </div>
                <v-col cols="6" sm="12">
                <v-text-field clearable type="text" disabled v-model="codigoArticulo" label="Código"></v-text-field>
                </v-col>
                <v-col cols="6" sm="12">
                <v-text-field clearable type="text" disabled v-model="descripcion" label="Descripcion"></v-text-field>
                </v-col>
                <v-col cols="6" sm="12">
                <v-text-field clearable type="number" v-model="cantidadDialog" label="Cantidad"></v-text-field>
                </v-col>
                <v-col cols="6" sm="12">
                <v-text-field clearable type="number" v-model="descuento" min="0" label="Descuento"></v-text-field>
                </v-col>
                <div style="display:none">
                <v-text-field clearable type="number" hidden v-model="precio" label="Precio"></v-text-field>
                <v-text-field clearable type="number" hidden v-model="impuestoDialog" label="Impuesto"></v-text-field>
                <v-text-field clearable type="number" hidden disabled v-model="subtotal" label="Subtotal"></v-text-field>
                <v-text-field clearable type="text" hidden v-model="valorImpuesto" label="ValorImpuesto"></v-text-field>
                <v-text-field clearable type="text" hidden disabled v-model="gravado" label="Gravado"></v-text-field>
                </div>
                <v-btn loading="loading" color="teal darken-1" id="espacioBoton" class="mr-4" style="top: 10px; color: white;" @click="editItem()">
                Guardar
                </v-btn>
                <v-btn  color="error" id="espacioBoton" class="mr-4" style="top: 10px;" @click="deleteItem()">
                Eliminar
                </v-btn>
                <v-btn color="primary" id="espacioBoton" @click="dialogProducto = false">
                Cancelar
                </v-btn>
                </v-row>
            </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNuevoProducto" max-width="1300px">
          <v-toolbar dark color="primary">
              <v-toolbar-title>NUEVO PRODUCTO</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="dialogNuevoProducto = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
          </v-toolbar-items>
          </v-toolbar>
          <v-card>
            <v-card-title>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                  <v-layout wrap>
                  <v-flex xs6 sm6 md6>
                      <v-text-field v-model="codigoProducto" label="Código interno">
                      </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                      <v-select v-model="categoria"
                      :items="Impuesto" label="% IVA">
                      </v-select>
                  </v-flex>
                  <v-flex xs6 sm3 md3>
                      <v-text-field type="tel" v-model="precioVenta" label="Precio Venta">
                      </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3 md3>
                      <v-text-field type="tel" v-model="precioCompra" label="Precio Compra">
                      </v-text-field>
                  </v-flex>
				  <v-flex xs6 sm3 md3>
                      <v-text-field type="tel" v-model="codigoCabys" label="CABYS">
                      </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                     <v-card-actions>
                        <v-text-field v-model="descripcion" label="Nombre"></v-text-field>
                        <v-switch v-model="Ivi" color="success" :label="`IVI`"></v-switch>
                    </v-card-actions>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-show="valida">
                      <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                      </div>
                  </v-flex>
                  </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="guardar()">Guardar</v-btn>
              <v-btn color="error" @click="dialogNuevoProducto = false">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPrecioVariable" max-width="800px">
          <v-toolbar dark color="primary">
              <v-toolbar-title>Precio Variable</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="dialogPrecioVariable = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
          </v-toolbar-items>
          </v-toolbar>
          <v-card>
            <v-card-title>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                  <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                      <v-text-field v-model="descripcion" label="Nombre"></v-text-field>
                  </v-flex>
                  
                  <v-flex xs6 sm6 md6>
                      <v-text-field type="tel" v-model="precioVenta" label="Precio Venta">
                      </v-text-field>
                  </v-flex>
				  <v-flex xs6 sm6 md6>
                      <v-text-field type="tel" v-model="serial" label="Código Cabys">
                      </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                      <v-select v-model="categoria"
                      :items="Impuesto" label="% IVA">
                      </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-show="valida">
                      <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                      </div>
                  </v-flex>
                  </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="PrecioVariable()">Facturar</v-btn>
              <v-btn color="error" @click="dialogPrecioVariable = false">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCliente" persistent max-width="900">
                <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Agregar Cliente</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="dialogCliente = false">
                        <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-form ref="form">
                        <v-row>
							<v-col cols="12" sm="4">
								<label style="color:red; font-size:12px;">Número Cédula o ID *</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" @change="BuscarPersona" type="text" required v-model="cedula" @input="validateInputCedula" />
								
                            	<label style="color:grey; font-size:12px;">Teléfono principal</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="number" required v-model="telefono" @input="validateInputTelefono" />

								<label style="color:grey; font-size:12px;">Días de Crédito</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="number" required v-model="DiasCreditoCliente" />

								<label style="color:grey; font-size:12px;">Limite de crédito</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="number" required v-model="limiteCredito"  />

								
                           
							</v-col>
							
                            <v-col cols="12" sm="4">
								<label style="color:red; font-size:12px;">Nombre (Razón Social)*</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="text" required v-model="nombre"  />

								<label style="color:red; font-size:12px;">Correo Electrónico*</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="text" required v-model="correo" />

								<label style="color:grey; font-size:12px;">Correo Electrónico Alernativo</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="text" required v-model="clienteCorreo2" />


								<label style="color:grey; font-size:12px;">Referencia , No Tarjeta</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="text" required v-model="nombreFantasia" />
                            </v-col>
                            <v-col cols="12" sm="4">
								<label style="color:grey; font-size:12px;" for="listaDePrecio">Tipo Documento</label>
								<select style="border: 1px solid #ccc; padding: 8px; width: 100%;" id="listaDePrecio" v-model="tipoDocumento">
									<option :key="item" v-for="item in tipoDocumentos" :value="item">{{ item }}</option>
								</select>
                              	
								<label style="color:grey; font-size:12px;" for="listasDePrecios">Lista de Precio</label>
								<select style="border: 1px solid #ccc; padding: 8px; width: 100%;" id="listaDePrecio" v-model="listaDePrecio">
									<option :key="item" v-for="item in listasDePrecios" :value="item">{{ item }}</option>
								</select>

								<label style="color:grey; font-size:12px;" for="Vendedores">Vendedor Asociado</label>
								<select style="border: 1px solid #ccc; padding: 8px; width: 100%;" id="listaDePrecio" v-model="vendedor">
									<option :key="item" v-for="item in Vendedores" :value="item">{{ item }}</option>
								</select>

								<label style="color:grey; font-size:12px;" for="Vendedores">Fecha nacimiento</label>
								<input style="border: 1px solid #ccc; padding: 8px; width: 100%;" type="date" name="bday" v-model="fechanacimiento" />

                            </v-col>
							
							<v-col cols="12" sm="12"> 
								<v-divider/>
								<v-card-actions>
									<v-btn color="teal darken-1" outlined text @click="limpiarCliente()">
										Limpiar
									</v-btn>
									
									<v-btn color="error" outlined text @click="dialogCliente = false">
										Salir
									</v-btn>
									<v-spacer/>
									<v-btn @click.stop="crearCliente" :disabled="!validCliente" color="primary" outlined >
										Crear Cliente
									</v-btn>
								</v-card-actions>
							</v-col>
                        </v-row>
                      
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar" top vertical="" :timeout="6000"
                >
                {{ Mensaje }}
                <v-btn
                color="pink"
                text
                @click="snackbar = false"
                >
                Close
                </v-btn>
        </v-snackbar>
        <v-footer
			v-if="!esCrifasa"
				style="#3d464d"
				color="#3d464d"
				fixed
				padless
			>
				<v-row
				justify="center"
				no-gutters
			>
				<v-btn min-height="55" width="20%" @click="BuscarCuentas()" dark text style="border-left: 1px solid rgb(224, 224, 224);" > <v-icon style="justify: center;"> mdi-clipboard-list</v-icon> <div style="font-size: min(max(10px, 1vw), 20px);" class="hidden-sm-and-down"> Ordenes </div> </v-btn>
				<v-btn min-height="55" width="20%" dark to="/conteos/Cierre"  text style="border-left: 1px solid rgb(224, 224, 224);" > <v-icon style="justify: center;"> mdi-cash-lock</v-icon> <div style="font-size: min(max(10px, 1vw), 20px);" class="hidden-sm-and-down"> Cierre Caja </div> </v-btn>
				<v-btn min-height="55" width="20%" dark to="/conteos/Apertura"  text style="border-left: 1px solid rgb(224, 224, 224);" > <v-icon style="justify: center;"> mdi-cash-lock-open</v-icon> <div style="font-size: min(max(10px, 1vw), 20px);" class="hidden-sm-and-down">Apertura </div>  </v-btn>
				<v-btn min-height="55" width="20%" dark @click="facturarCredito()" text style="border-left: 1px solid rgb(224, 224, 224);" > <v-icon style="justify: center;"> mdi-contactless-payment</v-icon> <div style="font-size: min(max(10px, 1vw), 20px);" class="hidden-sm-and-down"> Crédito </div>   </v-btn>
				<v-btn v-if="!CrearOrdenSelector" height="55" width="20%" @click="facturar()" dark color="#2797ce" > <div style="font-size: min(max(10px, 1vw), 20px);"> Facturar </div>  </v-btn>
				<v-btn v-if="CrearOrdenSelector"  height="55" width="20%" @click="CrearOrden()" dark color="#2797ce" > <div style="font-size: min(max(10px, 1vw), 20px);"> Crear Orden  </div>  </v-btn>
			</v-row>
		</v-footer>
    </v-container>
	
</template>


<script scoped>
import axios from 'axios';
import { debounce } from 'lodash';

export default {
	filters: {
		formatNumber(value) {
			const formatter = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 0, // Mínimo número de dígitos fraccionarios
			maximumFractionDigits: 2, // Máximo número de dígitos fraccionarios
			});
			return formatter.format(value);
		}
	},
  	data: () => (
	{
		today: new Date().toISOString().substr(0, 10),
		focus: new Date().toISOString().substr(0, 10),
		tipoDocumentos: [
			'FISICA',
			'JURIDICA',
			'DIMEX',
			'NITE',
			],
		tipoFacturas: [
		{ text: 'Factura Electronica', value: 1  },
		{ text: 'Tiquete Electronico', value: 4  }, 
		{ text: 'Recibo', value: 8  },  
		],
		valid: true,
		codigoCabys: 0,
		modelCabys: false,
		validDate: true,
		date: null,
		validEdit: true,
		validCliente: true,
		validBarbero: true,
		validFactura: true,
		dialogEfectivo: false,
		descripcion: "",
		CondicionVenta : 'CONTADO',
		limiteCredito: 0,
		indexProducto: 0,
		precio: 0,
		descuento: 0,
		vencimiento: (() => {
            let fecha = new Date();
            fecha.setDate(fecha.getDate() + 15);
            return fecha.toISOString().substr(0, 10);
        })(),
		localidadencabezado: [],
		Mensajeros:[],
		codigoArticulo : 0,
		impuestoDialog: 0,
		nombreFantasia: "",
		impuestoDialog2: 0,
		codigoArticulo2: 0,
		descripcion2: 0,
		SoN: 'S',
		dialogPrecioVariable: false,
		cantidadDialog2: 0,
		gravado2: "",
		valorImpuesto2: 0,
		totalImpuestoTotal:0,
		descuento2: 0,
		EnviarEmail: false,
		Tap: false,
		precio2: 0,
		descuento2: 0,
		subtotal: 0,
		subtotal2: 0,
		ClaveComprobante: '',
		RefXML: '',
		dialogPagoCredito: false,
		cantidad: 0.0,
		cantidadDialog: 0,
		tipoDocumento: "FISICA",
		tipoFactura: 0,
		tarjetaPagar:0,
		SaldoAgotado: false,
		efectivoPagar:0,
		vueltoPagar:0,
		totalGravado:0,
		totalPagar:0,
		efectivoCampo:true,
		tarjetaCampo:true,
		selectedId: -1,
		selected: [],
		monedas: [
			'CRC',
			'USD',
		],
		monedaPago: "CRC",
		monedaCuenta:"",
		dataArticulo: [],
		singleSelect: true,
		tipoDocumentoBarbero: null,
		dialog: false,
		name: null,
		details: null,
		start: new Date().toISOString().substr(0, 10),
		end: new Date().toISOString().substr(0, 10),
		color: '#1976D2', // default event color
		estado: null,
		idcliente: null,
		idLocalidadCliente: null,
		clientes:[],
		depositoPagar:0,
		ReferenciaFactura:"",
		dialogpuntos: false,
		orden:null,
		totalNC:0,
		puntosAplicados: 0,
		puntos: 0,
		productos:[],
		dialogCalculadora: false,
		productosDatos:[],
		rules: {
		cedula: [
			v => !!v || 'Ingrese un número de cédula o ID',
			v => /^\d+$/.test(v) || 'Solo se permiten números'
		]
		},
		fechaInicialR: [
			value => !!value || 'La fecha inicial es requerida'
		],
		fechanacimiento: new Date().toISOString().substr(0, 10),
		celRules: [
		value => !!value || 'No debe ingresar guiones ni simbolos, únicamente números',
		value => (value && value.length >= 8) || 'Debe ingresar 8 carácteres como mínimo, no ingrese guines ni simbolos',
		],
		Localidades:[],
		localidadesColor:[],
		idusuario: 2,
		localidad: "",
		hora: null,
		hora2: null,
		barbero: "Sin barbero",
		codigo:'',
		search: '',
		codigo2: '',
		stock: 0,
		precio_venta: 0,
		valida: 0,
		validaMensaje:[],
		dialogNota: false,
		adModal: 0,
		adAccion: 0,
		adNombre: '',
		adId: '',
		noFactura: 0,
		barcode: '',
		impEspecial:0,
		Costo:'',
		DatosLocalidad:[],
		loading: false,
		plataforma_pago:0,
		codigoProducto: '',
		modelSeriales: false,
		seriales: [],
		proveedor:'',
		categoria:13,
		qzReady: false,
		familia:'',
		familias:[],
		precioCompra:0,
		modelDetalle: "",
		precioVenta: 0,
		maximo:0,
		minimo:0,
		tipoProducto:'',
		maxDescuento: 90,
		nombreComercial: "",
		comision:0,
		localizacion:'NA',
		compuesto: false,
		ip1: "",
		devid2: "",
		ip2: "",
		devid1: "",
		cocina: 0,
		estado: 0,
		clienteExiste: false,
		cabeceraArticulos: [
		{ text: 'Código Producto', value: 'codigoProducto' },
		{ text: 'Descripción', value: 'descripcion' },
		{ text: 'Familia', value: 'familia' },
		{ text: 'Precio Venta', value: 'precioVenta', sortable: false  },  
		{ text: 'Inv Actual', value: 'cantidadInvActual', sortable: false  }            
		],
		cabeceraDetalles: [
		{ text: 'Descripción', value: 'descripcion', sortable: false  },
		{ text: 'Cantidad', value: 'cantidad', sortable: false  },
		{ text: 'Precio', value: 'precio', sortable: false  },
		{ text: '% Descuento', value: 'descuento', sortable: false  },   
		{ text: '% Impuesto', value: 'valorImpuesto', sortable: false  },
		{ text: 'Eliminar', value: 'actionmovimiento', sortable: false },
		],
		cabeceraDetalles2: [
		{ text: 'Descripción', value: 'descripcion', sortable: false  },
		{ text: 'Cantidad', value: 'cantidad', sortable: false  },
		{ text: 'Precio', value: 'precio', sortable: false  },
		{ text: 'Opciones', value: 'actionmovimiento', sortable: false },
		],
		valorImpuesto:0,
		gravado:"",
		articulos:[],
		texto:'',
		verArticulos:0,
		dialogToken:false,
		ActivarRecibos:false,
		MensajeDescuento : false,
		ActivadorPromos: true,
		verNuevo:0,
		Multiplo:5,
		errorArticulo:null,
		totalParcial:0,
		modelCarga: true,
		menu20: false,
		menu2: false,
		totalImpuesto:0,
		ModoCant: false,
		AgregarCompuesto :false,
		TokenDigitado:null,
		NotaCreditoFactura:false,
		GuiaToken: 1,
		AddImpServ: false,
		Stock0: false,
		serial: '',
		totalDescuento:0,
		total:0,
		totalExento:0,
		barberos: [],
		SinpePagar:0,
		impuesto: 0,
		tipo_comprobante: null,
		detalles:[],
		facturaTemporal:[],
		datosFacturaArreglo:[],
		detallesEditar:[],
		currentlyEditing: null,
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		events: [],
		dialogDate: false,
		dialogCliente: false,
		dialogBarbero: false,
		mme: false,
		Plan: '',
		LimiteFacturas: 5,
		FacturasRealizadas: 0,
		SaldoFacturas : 5,
		dialogProducto: false,
		dialogNuevoProducto: false,
		dialogAgregarProducto: false,
		diasCredito: 30,
		dialogFactura: false,
		dialogFacturaReserva: false,
		dialogPago: false,
		pago:0,
		proceso: null,
		dialogTap: false,
		idreserva: null,
		procede: true,
		nombre: "",
		cedula: "",
		BloqueoVendedor:false,
		telefono: "",
		correo: "",
		AdelantoTrabajo:"",
		Cuentas:[],
		emailRules: [
			v => !!v || 'El correo electrónico es requerido',
			v => /.+@.+\..+/.test(v) || 'El correo electrónico es requerido debe ser válido',
		],
		direccion: "",
		nombreBarbero: "",
		time:"",
		cedulaRules: [
			value => !!value || 'La cédula es requerida',
			value => (value && value.length >= 9) || 'Debe ingresar 9 carácteres como mínimo, no ingrese guiones ni otro caractéres',
		],
		nameRules: [
			value => !!value || 'El nombre es requerido',
			value => (value && value.length >= 8) || 'Debe ingresar 8 carácteres como mínimo',
		],
		fechaInicialR: [
			value => !!value || 'La fecha inicial es requerida'
		],
		horaInicialR: [
			value => !!value || 'La hora inicial es requerida'
		],
		fechaFinalR: [
			value => !!value || 'La fecha final es requerida'
		],
		horaFinalR: [
			value => !!value || 'La hora final es requerida'
		],
		cedulaBarbero: "",
		telefonoBarbero: "",
		saldo: 0,
		correoBarbero: "",
		direccionBarbero: "",
		passwordBarbero: "",
		dialogTicket: false,
		exonerar: false,
		UtilidadFactura: 0,
		Mensaje: '',
		celular: '',
		snackbar: false,
		passwordBarbero2: "",
		clienteCorreo2: "",
		info: [],
		idrol: 1,
		tipoPagoCredito: 'EFECTIVO',
		combinado: true,
		resultadoCompra: 0,
		TipoCambioInterno: 0,
		detalleFactura: "",
		procesoPago: true,
		flagProducto: false,
		codigoProductoViejo: "",
		keyValue: "",
		auxVenta:0,
		ImpuestoAduanal: 0,
		Peso: 0,
		modoPDV: false,
		generos: ["Masculino","Femenino"],
		genero: "Masculino",
		flete: 0,
		productoAduanal: 0,
		TotalImpuestoAduanal: 0,
		clienteNombre: "",
		bancos: [],
		credito: 0,
		Ivi: true,
		banco: '',
		listasDePrecios: ["Precio Venta", "Precio Detalle", "Precio Central","Precio Mayor", "Precio Mall"],
		listaDePrecio: 'Precio Venta',
		Vendedores : [],
		señas : '',
		comprobantePago: '',
		dialogSinpe: false,
		dialogTarjeta: false,
		dialogdescuento: false,
		dialogCheque: false,
		PagoDolares: 0,
		dialogDeposito: false,
		timeouts: [],
		factura: 0,
		abono: 0,
		CrearOrdenSelector:false,
		Regimen:"TRADICIONAL",
		clienteCorreo: "",
		listaPrecio : null,
		ValorUSD: 0,
		tipoPago : '',
		Compra: 0,
		Venta: 0,
		vendedor: "",
		clienteTipoCedula: "",
		DiasCreditoCliente : 15,
		ImpuestosObtenidos: 0,
		clienteCedula: "",
		IviBackend: false,
		VentaSeriales: [],
		offset:false,
		id:'',
		descuentototal: '',
		clienteTelefono: "",
		dialogCuenta:false,
		Fuente: '',
		FechaObtencion: '',
		clienteIdReserva: 0,
		PagaBillete: false,
		imp1: 0.0,
		imp2: 0.0,
		imp4: 0.0,
		imp13: 0.0,
		clienteId: 0,
		cabeceraSeriales: [
		{ text: 'Código Producto', value: 'codigoproducto', sortable: false  },
		{ text: 'Nombre Producto', value: 'descricion', sortable: false  },
		{ text: 'Código Serial', value: 'codigoSerial', sortable: false  },
		{ text: 'Vendedor', value: 'vendedor', sortable: false  },
		{ text: 'Ingresado por', value: 'usuario', sortable: false  },
		{ text: 'Estado ', value: 'estado', sortable: false  },
		{ text: 'Asignar ', value: 'actionmovimiento', sortable: false  },
		],
		Impuesto:[    
			{ text: '0% Exento', value: 0  },
			{ text: '1% Canasta Bàsica e Insumos', value: 1  }, 
			{ text: '2% Medicamentos, Primas, ect.' , value: 2  },
			{ text: '4% Boletos y Salud', value: 4  }, 
			{ text: '13% Tarifa General', value: 13  },                      
			],
		Impuestos:[    
			{ text: '0% Excento', value: 0  }, 
			{ text: '1% Canasta Bàsica e Insumos', value: 1  }, 
			{ text: '2% Medicamentos, Primas, ect.' , value: 2  },
			{ text: '4% Boletos y Salud', value: 4  }, 
			{ text: '13% Tarifa General', value: 13  },                      
			],
			Compuestos:[    
				{ text: 'NO', value: false  },
				{ text: 'SI', value: true  },     
			],
			Proveedores:[    
				{ text: 'Mayka', value: "Mayka"  },
				{ text: 'Dos Puntos', value: "dos Pinos"  },                  
			],
  }),
	mounted () {
		 console.log("Cargando tipo de factura desde localStorage...");
		if(localStorage.getItem("docType") === null) {
			this.tipoFactura = 1;
		} else {
			this.tipoFactura = parseInt(localStorage.getItem("docType"), 10);
		}
		console.log("Tipo de Factura establecido en:", this.tipoFactura);
		this.enterFullscreen();
		axios
		.get('https://tipodecambio.paginasweb.cr/api')
		.then(response => (this.info = response))
	},
  
	computed: {
		tipoFacturaColor() {
			switch (this.tipoFactura) {
				case 4:
				return '#E3FFFB'; // Color rojo pastel
				case 8:
				return '#CCE5FF'; // Color azul pastel
				case 1:
				return '#CCFFCC'; // Color verde pastel
				default:
				return ''; // Sin clase adicional
			}
		},
		totalCantidadFiltrada() {
			return this.sumarCantidades(this.detalles);
		},

		esRecepcion(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Recepcion';
		},
		esBodega(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Bodegas';
		},
		esAdministrador(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Administrador';
		},
		esSupervisor(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Supervisor';
		},
		esVendedor(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Vendedor';
		},
		esCliente(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Cliente';
		},
		esBoss(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='King Boss';
		},
		esPropietario(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Propietario';
		},
		esCrifasa(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Crifasa';
		},
		esTaller(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='Gerente Taller';
		},
		userName (){
				return this.$store.state.usuario.nombre
		},
		esFacturador(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='King Facturador';
		},
		
		Localidad (){
			return this.$store.state.usuario.localidad
		},
		monthFormatter () {
		return this.$refs.calendar.getFormatter({
			timeZone: 'UTC', month: 'long',
		})
		},
		IrRepVentas(){
			if(confirm('Esta seguro de ir a reporte ventas?')){
			router.push({name: 'repventas'})
		}
		},
		
		ActivarExoneracion(){
		var exo = false;
		if(confirm('Esta seguro de exonerar este documento?')){
			this.exonerar = true;
		}
		},
		DesactivarExoneracion(){
			if(confirm('Esta seguro de eliminar exoneración este documento?')){
				this.exonerar = false;
			}
		},
		calcularTotal:function(){
		var resultado=0.0;
		var preresult = 0.0;
			for(var i=0;i<this.detalles.length;i++){
					if(this.detalles[i].Ivi == false){  //Si el campo estadoInventario es = a false entonces el IVA se suma
						resultado= (parseFloat(this.totalGravado) + parseFloat(this.calcularImpuesto)+parseFloat(this.totalExento)) - parseFloat(this.totalDescuento);
				} if(this.detalles[i].Ivi == true){
					if(this.monedaPago == 'USD'){
						preresult= (parseFloat(this.totalGravado) + parseFloat(this.calcularImpuesto) +parseFloat(this.totalExento)) - parseFloat(this.totalDescuento);
						resultado = parseFloat(preresult)
						return resultado.toFixed(2);
					} else
					{
						preresult = (parseFloat(this.totalGravado) + parseFloat(this.calcularImpuesto) + parseFloat(this.totalExento)) - parseFloat(this.totalDescuento);
						resultado = Math.round(preresult / this.Multiplo) * this.Multiplo;
						//resultado = preresult

					}
					
				}
			}
			
			
			return resultado.toFixed(2);
		},
		sumarIv:function(){
		var resultado = 0;
		for(var i=0;i<this.detalles.length;i++ ){
			if(this.detalles[i].estadoInventario = true){
			if(this.detalles[i].gravado == 'S')
			{
				if(this.detalles[i].valorImpuesto == 13)
				{
				resultado=resultado+(((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad) * 0.13);
				} else
				if(this.detalles[i].valorImpuesto == 4)
				{
				resultado=resultado+(((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad) * 0.04);
				} else
				if(this.detalles[i].valorImpuesto == 2)
				{
				resultado=resultado+(((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad) * 0.02);
				} else
				if(this.detalles[i].valorImpuesto == 1)
				{
				resultado=resultado+(((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad) * 0.01);
				} 
			}     
				
			}        
		}
		return resultado;
		},
		calcularImpuesto:function(){
			
			var resultado=0.0;
			// if(this.tipoFactura == 8){
			// 	return 0;
			// }
			resultado=this.imp1 + this.imp2+ this.imp4 + this.imp13;
			return resultado.toFixed(2);
		},
		calcularPreTotal:function(){
		var resultado=0.0;
			resultado = parseFloat(this.totalExento) + parseFloat(this.totalGravado);
		return resultado;
		},
		calcularSubTotal:function(){
		var resultado=0.0;
			resultado = parseFloat(this.totalExento) + parseFloat(this.totalGravado) ;
		return resultado.toFixed(2);
		},
		calcularImpuestoTotal:function(){
		var resultado=0.0;
		var test= false;
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].Ivi == false && this.detalles[i].gravado == 'S'){
				resultado=resultado+(this.detalles[i].precio * this.detalles[i].cantidad);
				
			}    
				if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == true)
				{
				if(this.detalles[i].valorImpuesto == 13)
				{
				resultado+=((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad);
				} else
				if(this.detalles[i].valorImpuesto == 1)
				{
					resultado+=((this.detalles[i].precio / 1.01) * this.detalles[i].cantidad);
				} else
				if(this.detalles[i].valorImpuesto == 2)
				{
					resultado+=((this.detalles[i].precio / 1.02) * this.detalles[i].cantidad);
				} else
				if(this.detalles[i].valorImpuesto == 4)
				{
					resultado+=((this.detalles[i].precio / 1.04) * this.detalles[i].cantidad);
				}
				}
			}
		return resultado.toFixed(2);
		},
		calcularImpEspecial:function(){
			var resultado=0.0;
				for(var i=0;i<this.detalles.length;i++){
					if (this.detalles[i].impEspecial != 0 && this.detalles[i].impEspecial !== null && this.detalles[i].impEspecial !== "") {
						resultado = resultado + ((this.detalles[i].impEspecial /100)*this.detalles[i].precioVenta );
					}
				}
			return resultado;
		},
		calcularExento:function(){
			var resultado=0.0;
				for(var i=0;i<this.detalles.length;i++){
				if(this.detalles[i].gravado == 'N')
				{
					resultado=resultado+(this.detalles[i].precio * this.detalles[i].cantidad);
				}
				}
			return resultado;
		},
		calcularimp13:function(){
		var resultado=0.0;
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == false && this.detalles[i].valorImpuesto == 13 )
			{
				resultado=resultado+((this.detalles[i].precio -(this.detalles[i].precio* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.13;
			}
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == true && this.detalles[i].valorImpuesto == 13)
			{
				resultado=resultado+(((this.detalles[i].precio / 1.13) -((this.detalles[i].precio / 1.13)* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.13;
			}
			}
		return resultado;
		},
		calcularimp1:function(){
		var resultado=0.0;
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == true && this.detalles[i].valorImpuesto == 1)
			{
				resultado=resultado+(((this.detalles[i].precio / 1.01) -((this.detalles[i].precio / 1.01)* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.01;
			}
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == false && this.detalles[i].valorImpuesto == 1)
			{
				resultado=resultado+((this.detalles[i].precio -(this.detalles[i].precio* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.01;
			}
			}
		return resultado;
		},
		calcularimp2:function(){
		var resultado=0.0;
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == false && this.detalles[i].valorImpuesto == 2)
			{
				resultado=resultado+((this.detalles[i].precio -(this.detalles[i].precio* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.02;
			}
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == true && this.detalles[i].valorImpuesto == 2)
			{
				resultado=resultado+(((this.detalles[i].precio / 1.02) -((this.detalles[i].precio / 1.02)* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.02;
			}
			}
		return resultado;
		},
		calcularimp4:function(){
		var resultado=0.0;
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == false && this.detalles[i].valorImpuesto == 4)
			{
				resultado=resultado+((this.detalles[i].precio -(this.detalles[i].precio* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.04;
			}
			if(this.detalles[i].gravado == 'S' && this.detalles[i].Ivi == true && this.detalles[i].valorImpuesto == 4)
			{
				resultado=resultado+(((this.detalles[i].precio / 1.04) -((this.detalles[i].precio / 1.04)* (this.detalles[i].descuento)/100)) * this.detalles[i].cantidad) * 0.04;
			}
			}
		return resultado;
		},
		calcularCosto:function(){
			var resultado=0.0;
				for(var i=0;i<this.detalles.length;i++){
					resultado+= this.detalles[i].precioCompra * this.detalles[i].cantidad;
				}
			return resultado.toFixed(2);
		},
		calcularDescuento:function(){
			var resultado=0.0; 
			var desc = 0;
				for(var i=0;i<this.detalles.length;i++)
				{
					if(this.detalles[i].activador === true){
						if(this.detalles.length > 1 || this.detalles[i].cantDescuento == 1){
							this.MensajeDescuento = true;
						}
						
						if(this.ActivadorPromos == true)
						{
							if (this.detalles[i].cantMinima <= this.detalles[i].cantidad){ 
								this.detalles[i].descuento = this.detalles[i].cantDescuento;
							} else {
								this.detalles[i].descuento = 0;
							}
							
							if(i == 0){
								desc = this.detalles[i].cantDescuento
							}	else
							{
								if(desc == this.detalles[i].cantDescuento){
									//Aplicar descuento a todas las lineas
									this.descuentototal = desc;
									//this.AplicarDescuento();
									this.detalles[i].descuento = desc;
									this.detalles[0].descuento = desc;
								}
							}
						}
					} else 
					{
						this.MensajeDescuento = false;
					}
				} // Aqui se calcula el descuento 
				if(this.Regimen == "SIMPLIFICADO"){
					for(var j=0;j<this.detalles.length;j++)
					{
						resultado = resultado+(((this.detalles[j].descuento)/100)*(this.detalles[j].precio * this.detalles[j].cantidad));
					}
				} else
				for(var j=0;j<this.detalles.length;j++)
				{
					if( this.detalles[j].Ivi == false){
						resultado = resultado+(((this.detalles[j].descuento)/100)*(this.detalles[j].precio * this.detalles[j].cantidad));
					} else
					if( this.detalles[j].Ivi == true){
						resultado = resultado + ((this.detalles[j].descuento/100)*((this.detalles[j].precio / 1.13) * this.detalles[j].cantidad));
					}
				}
			
			return resultado.toFixed(2);
		},
		debouncedSearch: debounce(function() {
		this.selectProductos();
		}, 500)
	},  
	created () {
		this.select();
		//this.selectProductos();
		//this.selectVendedores();
		this.localidad = this.$store.state.usuario.localidad
		this.agregarProforma();
		this.selectPanelControl();
		this.selectTipoCambio();
		this.TipoCambio2();
		this.enterFullscreen();
	},
  	methods: {
		setDocType(){
			localStorage.setItem("docType",this.tipoFactura)
		},
		NCManual(){
			this.tipoFactura = 3;
			this.tipoFacturas.push({text:'Nota de Crédito', value:3})
			this.NotaCreditoFactura = true;
		},
		listarAsociadas(){
			var items = [];
			let me=this;
			this.Localidades = [];
			this.modelCarga = true;
			me.Localidades.push(me.$store.state.usuario.localidad);
			this.detalles = [];
			this.localidad = this.$store.state.usuario.localidad
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
				me.modelCarga = false
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
    	},
		SelectOrden(localidad){
			this.CrearOrdenSelector = true;
			this.localidad = localidad;
		},
		async CrearOrden() 
		{ 
			this.modelCarga = true;
			let barcodepreview = Date.now();
			let idsa = barcodepreview.toString();
			let NoProforma = idsa.substring(5, 12);
			for(var i = 0; i < this.detalles.length; ++i)
			{
			this.productosDatos.push(
				{
					CodigoProducto:this.detalles[i].idarticulo,
					Cantidad:this.detalles[i].cantidad,
					UnidadMedida:"UND",
					Descripcion:this.detalles[i].descripcion,
					PrecioUnitario:this.detalles[i].precio,
					MontoDescuento:this.detalles[i].descuento,                          
					ValorImpuesto:this.detalles[i].valorImpuesto,
					Gravado:this.detalles[i].gravado,
					Ivi: this.detalles[i].Ivi,
					DetalleLinea :this.detalles[i].detalle
				}
				);
			}
			var self = this;
			var link = '';
			var linkProforma = location.origin+'/proformas';
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.post('api/Proformas/Crear',{
				'Cajero':self.$store.state.usuario.nombre,
				'Localidad': this.localidad,
				'Cliente':self.$store.state.usuario.localidad,
				'Correo': "",
				'Vendedor': self.vendedor,
				'iva': self.totalImpuesto,
				'PrecioSinIva': self.totalGravado,
				'Contacto':"",
				'TipoDocumento':"JURIDICA",
				'MontoFacturado':self.total,
				'Contacto1':self.monedaPago,
				'Estado': 0,
				'Mail':'',
				'detalles': self.productosDatos,
				'Detalle':self.detalleFactura,
				'Descuento':self.totalDescuento,
				'EnviarMail': false,
				'Vencimiento': this.vencimiento,
			},configuracion).then(function (response) {
				self.snackbar = true;
				self.Mensaje = 'Proforma creada con éxito'+response;
				self.detalles = [];
				self.modelCarga = false;
				self.productosDatos = [];
				self.CrearOrden = false
			}).catch(function(error){ 
				self.snackbar = true;
				self.productosDatos = [];
				self.modelCarga = false;
				self.Mensaje = 'Error al crear proforma, reporte a su proveedor el problema'+error;
			}); 
		},
		enterFullscreen() {
			const docEl = document.documentElement;
			if (docEl.requestFullscreen) {
			docEl.requestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.mozRequestFullScreen) { // Firefox
			docEl.mozRequestFullScreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.webkitRequestFullscreen) { // Chrome, Safari y Opera
			docEl.webkitRequestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.msRequestFullscreen) { // Internet Explorer/Edge
			docEl.msRequestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			}
		},
		validarMoneda(){
			if(localStorage.getItem("Moneda") == null) {
				this.monedaPago = "CRC";
				return;
			}
			this.monedaPago = localStorage.getItem("Moneda");
		},
		CambiarMoneda(){
			localStorage.setItem("Moneda",this.monedaPago)
		},
		Paga1000(){
			if(this.PagaBillete == false){
				this.efectivoPagar =  1000;
				this.PagaBillete = true;
				return;
			}
			this.efectivoPagar = parseInt(this.efectivoPagar) + 1000;
		},
		Paga2000(){
			if(this.PagaBillete == false){
				this.efectivoPagar =  2000;
				this.PagaBillete = true;
				return;
			}
			this.efectivoPagar = parseInt(this.efectivoPagar) + 2000;
		},
		getColor (stock,minimo) {
			if (stock <= 0) return '#FF7373'
			else if (stock < minimo) return '#FF9A50'
			else  if (stock == minimo) return '#8FD3FF'
			else  if (stock > minimo) return '#C7FFBD'
			else  return '#EAEAEA'
		},
		Paga5000(){
			if(this.PagaBillete == false){
				this.efectivoPagar =  5000;
				this.PagaBillete = true;
				return;
			}
			this.efectivoPagar = parseInt(this.efectivoPagar) + 5000;
		},
		Paga10000(){
			if(this.PagaBillete == false){
				this.efectivoPagar =  10000;
				this.PagaBillete = true;
				return;
			}
			this.efectivoPagar = parseInt(this.efectivoPagar) + 10000;
		},
		Paga20000(){
			if(this.PagaBillete == false){
				this.efectivoPagar =  20000;
				this.PagaBillete = true;
				return;
			}
			this.efectivoPagar = parseInt(this.efectivoPagar) + 20000;
		},
		EsGrabado(item){
			if(item.valorImpuesto == 0){
				item.gravado = 'N'
				return;
			}
			item.gravado = 'S'
		},
		DesactivarPromo(){
			this.Mensaje ="Promociones desactivadas para esta factura";
			this.snackbar = true;
			for(var i=0;i<this.detalles.length;i++){
				this.detalles[i].activador = false;
				this.detalles[i].descuento = 0;
			}
		},
		AplicarDescuento(){
			if(this.descuentototal == ''){
				this.snackbar = true;
				this.Mensaje= 'Debe digiar el porcentaje de descuento al total de factura';
				return;
			}
			for(var i=0;i<this.detalles.length;i++){
				//alert("entramos al for Descuento: "+this.detalles[i].descuento +" y maxDescuento: "+this.detalles[i].MaxDescuento);
				if(this.descuentototal > this.detalles[i].MaxDescuento){
					this.Mensaje = "Lo sentimos, el máximo descuento para el producto "+this.detalles[i].descripcion +" es de "+ this.detalles[i].MaxDescuento +", seleccione un descuento menor a este.";
					this.snackbar = true;
					this.GuiaToken = 2;
					this.dialogToken = true;
					this.detalles[i].descuento = 0;
					return;
				}
				this.detalles[i].descuento = this.descuentototal;
			}
			this.dialogdescuento = false;
			this.snackbar = true;
			this.Mensaje= 'Descuento de %'+this.descuentototal+' aplicado a todas las lineas actuales, si ingresa mas lineas deberá repetir este proceso';

		},
		ExonerarProductos(){
			for(var i=0;i<this.detalles.length;i++){
				if(this.detalles[i].Ivi == true){
					this.detalles[i].precio = (this.detalles[i].precio / 1.13).toFixed(2)
				}
				this.detalles[i].valorImpuesto = 0;
				this.detalles[i].gravado = 'N';
			}
		},
		TipoCambio2(){
			this.modelproveedor = true;
			let me=this;
			var familiasArray=[];
			axios.get('http://apis.gometa.org/tdc/tdc.json').then(function(response){
				familiasArray=response.data;
				me.Compra = bncr[0].compra;
				me.Venta = bncr[0].venta;
				
				
			}).catch(function(error){
				this.snackbar = true;
				this.Mensaje = 'Error de conexión con el TSE, digite los datos de forma manual'
				alert(error);
			});
			var localidadesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ParametrosEmisors/ListarLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
			localidadesArray=response.data;
			me.TipoCambioInterno= localidadesArray[0].tipoCambio;
			})
		},
		selectTipoCambio(){
			let barcodepreview = Date.now();
			let idsa = barcodepreview.toString();
			let NoProforma = idsa.substring(5, 12);
			this.codigoProducto = NoProforma;
			this.Venta = this.info[0].data.compra;
		},
		BuscarNotaCredito() {
			let me = this;
			let headers = { "Authorization": "Bearer " + this.$store.state.token }; // Asegúrate de que el token esté disponible
			let config = { headers: headers };

			axios.get(`api/RepVentasVistas/ConsultaNC/${this.noFactura}/${this.$store.state.usuario.localidad}`, config)
			.then(function (response) {
				if (response.data.success) {
					// Procesa la respuesta exitosa
					console.log('Datos recibidos:', response.data.data);
					if (response.data.data.length > 0 && response.data.data[0].total !== undefined) {
						me.totalNC = response.data.data[0].total;
						me.tipoPago = "EFECTIVO";
						console.log('Total capturado:', me.totalNC);
					} else {
						console.error('No se encontró el total en la respuesta');
					}
					me.Mensaje = response.data.message;
					me.snackbar = true
					me.dialogNota = false;
					me.vuelto();
				} else {
					// Maneja la situación donde la factura no es una nota de crédito
					me.Mensaje = response.data.message;
					me.snackbar = true
					//alert(response.data.message);
				}
			})
			.catch(function (error) {
				// Manejo de errores de la solicitud
				console.error('Error en la solicitud:', error);
				alert('Error al consultar la nota de crédito');
			});
		},
		selectVendedores(){
			if(this.BloqueoVendedor == true){
				this.vendedor = "";

			} else
			{
				this.vendedor = this.$store.state.usuario.nombre;
				
			}

			this.Vendedores.push(this.$store.state.usuario.nombre);
			let me=this;
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			var proveedoresArray=[];
			axios.get('api/Usuarios/SelectUsuariosLocalidad/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
				proveedoresArray=response.data;
				proveedoresArray.map(function(x){
					me.Vendedores.push(x.nombre);
				});
				me.validarMoneda();
			}).catch(function(error){
				alert(error);
			});
		},
		BuscarPersona(){
			this.modelproveedor = true;
			let me=this;
			var familiasArray=[];
			axios.get('https://apis.gometa.org/cedulas/'+this.cedula+'&key=u0vSHKh0dVRckNH').then(function(response){
				familiasArray=response.data;
				me.nombre = familiasArray.results[0].fullname;
				me.tipoDocumento = familiasArray.results[0].guess_type
				
				
			}).catch(function(error){
			this.snackbar = true;
			this.Mensaje = 'Error de conexión con el TSE, digite los datos de forma manual'
				alert(error);
			});
		},
		rowClickProducto: function (item) { 
			this.codigo2 = item.codigoProducto;
			this.descripcion = item.descripcion;
			this.buscarCodigo();
			this.verArticulos = false;

			this.indexProducto2 = this.detalles.indexOf(item);
		},
		reset() {
			this.$refs.form.reset()
		
		},
		Moneda(){
		if(this.monedaPago == 'USD'){
			return "$";
		} 
		return "₡";
		},
		idioma(){
			localStorage.setItem("idioma",this.Pais)
			location.reload();
		},
		abrirEfectivo(){
			this.dialogEfectivo = true;
			this.efectivoPagar = this.vueltoPagar * -1;
			document.querySelector("#PagoEnEfectivo").focus();
		},
		abrirTarjeta(){
			this.dialogTarjeta = true;
			this.tarjetaPagar = this.vueltoPagar * -1;
			document.querySelector("#PagoEnTarjeta").focus();
			//this.listarBancos();
		},
		printLabel() {
			if (!this.qzReady) {
				alert('QZ Tray aún no está listo.');
			return;
			}
			// Conectarse a QZ Tray en el cliente
			qz.websocket.connect().then(function() {
			return qz.printers.find();
			}).then((found => {
				var config = qz.configs.create("LR2000 Printer");
				var data = [{
				type: 'pixel',
				format: 'html',
				flavor: 'plain', // or 'plain' if the data is raw HTML
				data: '<h1> Probando impresiones directas desde web</h1>',
				}];
				return qz.print(config,data);
			})).catch((e) => {
				alert(e);
			}).finally(() =>{
				return qz.websocket.disconnect();
			})
		},
		abrirDeposito(){
			this.dialogDeposito = true;
			this.depositoPagar = this.vueltoPagar * -1;
			document.querySelector("#PagoEnDeposito").focus();
			//this.listarBancos();
		},
		abrirSinpe(){
			this.dialogSinpe = true;
			this.SinpePagar = this.vueltoPagar * -1;
			document.querySelector("#PagoSinpeField").focus();
		},
		abrirCheque(){
			this.dialogCheque = true;
			this.PagoDolares = this.TotalDolares;
			document.querySelector("#dolares").focus();
		},
		abrirPuntos(){
			this.dialogpuntos = true;
			let mitad = this.Total / 2;
			if(this.puntos > mitad ){
				this.puntosAplicados = mitad;
			} else
			{
				this.puntosAplicados = this.puntos;
			}
			//this.listarBancos();
		},
		validarCantidad(item) {
			if(this.Stock0){
				if (item.cantidad > item.inv) {
					this.$set(item, 'cantidad', item.inv); // Usamos $set para forzar la reactividad
					this.snackbar = true;
					this.Mensaje = "No puedes facturar más de "+item.inv + " cantidades de "+item.descripcion;
					
				}
				// if(this.esVendedor){
				// 	let porcentaje = item.dimensiones /100;
				// 	let cantidadMaximoFacturacion = porcentaje * item.inv;
				// 	if(item.cantidad > cantidadMaximoFacturacion){
				// 		item.cantidad = cantidadMaximoFacturacion;
				// 		this.snackbar = true;
				// 		this.Mensaje ="El máximo de facturación permitido para este articulo es un "+porcentaje+"%, solicite un aumento de limite para facturar mas unidades";
				// 	}

				// }
			}
			
		},	
		PagoEfectivo(){
			if(this.tipoPago != "CREDITO"){
				this.tipoPago = 'EFECTIVO';
			}
			this.tipoPagoCredito = 'EFECTIVO'
			if (this.monedaPago === "USD") {
				var Dolares = this.efectivoPagar / this.TipoCambioInterno;
				//Preguntamos si el monto digitado es mayor al total de la factura
				this.vueltoPagar = ((parseInt(this.tarjetaPagar) + parseInt(this.SinpePagar) + parseInt(this.efectivoPagar) + parseInt(this.depositoPagar)+ parseInt(this.totalNC)) - parseInt(this.Total));
				this.recibidoEfectivo = this.efectivoPagar;
				if(this.calcularTotal < parseInt(this.efectivoPagar)){
					this.recibidoEfectivo = this.efectivoPagar;
					this.efectivoPagar = this.Total;
				}
					
			} else
			{
				this.vueltoPagar = ((parseInt(this.tarjetaPagar) + parseInt(this.SinpePagar) + parseInt(this.efectivoPagar) + parseInt(this.depositoPagar)+ parseInt(this.totalNC)) - parseInt(this.Total));
				this.recibidoEfectivo = this.efectivoPagar;
				if(this.calcularTotal < parseInt(this.efectivoPagar)){
					this.recibidoEfectivo = this.efectivoPagar;
					this.efectivoPagar = this.Total;
				}
			}
			this.dialogEfectivo = false;
			this.SaldoPendiente();
		},
		abrir_rapi(){
			this.tarjetaPagar = 0;
			this.efectivoPagar = 0;
			this.SinpePagar = 0;
			this.depositoPagar =0;
			this.plataforma_pago = this.total;
			this.vueltoPagar = 0;
			this.tipoPago = "Rappi";
		},
		vuelto()
		{
			this.vueltoPagar = ((parseInt(this.tarjetaPagar) + parseInt(this.efectivoPagar) + parseInt(this.depositoPagar)+ parseInt(this.SinpePagar) + parseInt(this.totalNC)) - parseInt(this.Total));
			if(this.vueltoPagar >= 0){
				this.efectivoPagar = this.Total - (parseInt(this.tarjetaPagar) + parseInt(this.depositoPagar)+ parseInt(this.SinpePagar));
			}
		},  
		PagoDolaresMethod(){
			if(this.tipoPago != "CREDITO"){
				this.tipoPago = 'EFECTIVO';
			}
			this.tipoPago = 'EFECTIVO';
			this.dialogCheque = false;
			//Pregunta si la configuracion de la moneda actual es Colones
			if (this.monedaPago === "CRC") 
			{
					// Aqui la moneda es colones por lo que se hace la conversion a colones
					this.Colones = this.PagoDolares * this.TipoCambioInterno;
					this.vueltoPagar = ((parseInt(this.Colones) + parseInt(this.depositoPagar)+ parseFloat(this.tarjetaPagar) ) - parseInt(this.Total));
						// Preguntamos si lo que estoy recibiendo es mayor al monto a pagar para agregar al cierre solamente el monto de la factura, el sobrando se asume que es un vuelto
						// if(this.calcularTotal < parseInt(Colones)){
						// 	this.efectivoPagar = this.calcularTotal;
						// } else
						// // 
						// 	this.efectivoPagar = Colones;
					
			} else
			if (this.monedaPago === "USD") 
			{
				// EN esta ocacion la moneda esta en Dolares por lo que no se hace la conversion, solo se agregar el pago
				this.Colones = this.PagoDolares;
				this.vueltoPagar = parseFloat(this.Colones) + parseFloat(this.depositoPagar) + parseFloat(this.tarjetaPagar) - parseFloat(this.Total);
					// Preguntamos si lo que estoy recibiendo es mayor al monto a pagar para agregar al cierre solamente el monto de la factura, el sobrando se asume que es un vuelto
					if(this.calcularTotal < parseInt(this.Colones)){
						this.efectivoPagar = this.calcularTotal;
						this.recibidoEfectivo = this.Colones;
					} else
					// 
					this.efectivoPagar = this.Colones;
					this.recibidoEfectivo = this.Colones;
				
			}
			this.SaldoPendiente();
		},
		PuntosMetodoPago(){
			if(this.puntosAplicados > this.puntos){
				this.Mensaje = "Este cliente solo cuenta con "+this.puntos+" puntos"
				this.snackbar = true;
				return;
			}
			this.dialogpuntos = false;
			let saldo = 0;
			let mitad = this.Total /2;
			if(this.puntos < this.puntosAplicados){
				this.Mensaje = "El maximo puntos que tiene diponible el cliente es: "+this.puntos+ " no puede aplicar "+this.puntosAplicados;
				this.snackbar = true;
				return;
			}
			if(this.puntosAplicados > mitad ){
				this.puntosAplicados = mitad;
			} 
			saldo = parseInt(this.puntos) - parseInt(this.puntosAplicados);
			// Primero, calcula la suma del valor total de todos los detalles
			var totalDetalles = this.Total;
			// Obten el valor de puntosAplicados (supongo que ya lo tienes definido)
			var puntosAplicados = this.puntosAplicados;  
			// Calcula el porcentaje de descuento que se debe aplicar
			var porcentajeDescuento = (puntosAplicados / totalDetalles) * 100;
			alert("total:" +totalDetalles+" Puntos Aplicados: "+puntosAplicados+" Porcentaje Descuento : "+porcentajeDescuento);
			// Ahora, aplica el descuento a cada detalle individual
			for (var i = 0; i < this.detalles.length; i++) {
				this.detalles[i].descuento = porcentajeDescuento;
			}
			
			// Esperar 5 segundos antes de ejecutar el método this.vuelto()
			setTimeout(() => {
				this.vuelto();
			}, 1000); // 5000 milisegundos = 5 segundos

			this.detalleFactura = this.puntosAplicados+" Puntos aplicados en esta factura, Saldo: "+saldo
		},
		PagoTarjeta(){
			if(this.tipoPago != "CREDITO"){
				this.tipoPago = 'TARJETA';
			}
				this.tipoPagoCredito = 'TARJETA'
				this.SaldoPendiente();
					for(var i=0;i<this.detalles.length;i++){
					if(this.detalles[i].valorImpuesto == 4)
					{
						if(this.detalles[i].Ivi == false){
							this.detalles[i].gravado = 'N';
							this.detalles[i].valorImpuesto = 0;
							this.IviBackend = false;
							this.totalPagar = this.calcularTotal;
							this.tarjetaPagar = this.totalPagar;
						} else
						if(this.detalles[i].Ivi == true){
							this.detalles[i].gravado = 'N';
							this.detalles[i].valorImpuesto = 0;
							this.detalles[i].precio = this.detalles[i].precio / 1.04;
							this.IviBackend = false;
							this.totalPagar = this.calcularTotal;
							this.tarjetaPagar = this.totalPagar;
						}
					}
					}
			this.dialogTarjeta = false;
			var resultado = 0;
			this.vueltoPagar = ((parseFloat(this.tarjetaPagar) + parseFloat(this.efectivoPagar) + parseFloat(this.depositoPagar) + parseFloat(this.depositoPagar)) - parseFloat(this.Total));
			this.detalleFactura = this.detalleFactura+this.banco 
			+ this.comprobantePago + ' '+ this.señas;
			this.SaldoPendiente();	
				
		},
		CambiarIvi(item){
			let ind = item.id
			for(var i=0;i<this.detalles.length;i++){
				if(this.detalles[i].id == ind){
					if(this.detalles[i].Ivi == true)
					{
					this.detalles[i].Ivi = false;
					this.detalles[i].LlevaIvi = 'I.V.N.I.'
					} else
					if(this.detalles[i].Ivi == false)
					{
					this.detalles[i].Ivi = true;
					this.detalles[i].LlevaIvi = 'I.V.I.'
					}
				}
			}
			this.detalles[ind].Ivi = false;

		},
		AddDetail(){
			for(var i=0;i<this.detalles.length;i++){
				if(this.detalles[i].id == this.codigoProducto){
					this.detalles[i].detalle = this.detalleFactura;
					this.detalleFactura  = "";
					this.modelDetalle = false;
					return;
				}
			}
		},
		AbrirDetalle(item){
			this.modelDetalle = true;
			this.codigoProducto = item.id;
			this.nombre = item.descripcion;
		},
		ValidarDescuento(item){
			if(item.descuento > item.MaxDescuento){
				this.Mensaje = "Lo sentimos, el máximo descuento para este producto es de "+ item.MaxDescuento +", seleccione un descuento menor a este o ingrese el token";
				this.snackbar = true;
				this.GuiaToken = 2;
				this.dialogToken = true;
				item.descuento = 0;
			}
		},
		PagoSinpe(){
				
				if(this.tipoPago != "CREDITO"){
					this.tipoPago = 'SINPE';
				}
				this.tipoPagoCredito = 'SINPE'
				this.dialogSinpe = false;
				this.vueltoPagar = ((parseFloat(this.tarjetaPagar) + parseFloat(this.efectivoPagar) + parseFloat(this.depositoPagar)+ parseFloat(this.SinpePagar)) - parseFloat(this.Total));
				this.detalleFactura = this.detalleFactura+ this.comprobantePago + ' '+ this.señas;
				this.SaldoPendiente();
		},
		PagoDeposito(){
			if(this.tipoPago != "CREDITO"){
				this.tipoPago = 'TRANSFERENCIA';
			}
			this.tipoPagoCredito = 'TRANSFERENCIA'
			this.dialogDeposito = false;
			this.vueltoPagar = ((parseFloat(this.tarjetaPagar) + parseFloat(this.efectivoPagar) + parseFloat(this.depositoPagar)+ parseFloat(this.SinpePagar)) - parseFloat(this.Total));
			this.detalleFactura = this.detalleFactura+this.banco +' '+ this.comprobantePago + ' '+ this.señas;
			this.SaldoPendiente();
		},
		PagoCheque(){
			if(this.tipoPago != "CREDITO"){
				this.tipoPago = 'EFECTIVO';
			}
			this.tipoPagoCredito = 'EFECTIVO'
			this.dialogCheque = false;
			var Colones = this.PagoDolares * this.TipoCambioInterno;
			this.efectivoPagar = Colones;
			this.vueltoPagar = ((parseInt(Colones) + parseInt(this.efectivoPagar) + parseInt(this.depositoPagar)+ parseInt(this.totalNC)+ parseFloat(this.SinpePagar)) - parseInt(this.Total));
				// Esperar 5 segundos antes de ejecutar el método this.vuelto()
			setTimeout(() => {
				this.vuelto();
			}, 1000); // 5000 milisegundos = 5 segundos
		},
		updateOrdenExpress(data) {
			axios.put('/api/OrdenExpress/ActualizarOrden', data)
				.then(response => {
					
					console.log('Actualizado exitosamente');
				})
				.catch(error => {
					console.error('Hubo un error al actualizar:', error);
				});
		},
		getColor2 (estado) {
			if (estado == '0') return '#23262d'
			else 
			if (estado == '1') return 'error'
			else 
			if (estado == '2') return 'orange'
			else 
			if (estado == '3') return 'green'
			else 
			if (estado == '4') return 'indigo'
			
			else  return 'red'
		},
		EstadoNombre (estado) {
			if (estado == '0') return 'En Central'
			else 
			if (estado == '1') return 'Esperando Sucursal'
			else 
			if (estado == '2') return 'En Sucursal'
			else 
			if (estado == '3') return 'En Ruta'
			else 
			if (estado == '4') return 'Entregado'
			else 
			if (estado == '5') return 'Cancelado'
			else 
			if (estado == '6') return 'No se pudo entregar'
			
		},
		BuscarCuentas(){
			this.loading = true;
			this.dialogCuenta = true;
			let me =this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/OrdenExpress/ListarComandasSucursal/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				me.Cuentas=response.data;
				me.loading = false;
				me.listarMensajeros();
				});
		},
		eliminarProducto(id){
			//console.log(id)
			this.detalles = this.detalles.filter(e => e.id != id)
			//console.log(this.cards)
			if(this.detalles.length == 0){
				if(this.orden != null){
					let confirmar = confirm("¿Deseas editar los productos de la orden?");

					// Verifica si el usuario confirmó la acción
					if (confirmar) {
						this.snackbar = true;
						this.Mensaje ="Selcciona los nuevos productos de la orden";
					} else {
						this.orden = null;
						this.snackbar = true;
						this.Mensaje ="Se ha limpiado el número de orden";
					}
				} 
			}
		},
		BorrarLinea (item,mesa,producto) {
			var me = this;
			if(confirm("Seguro que quiere eliminar el producto "+producto+", Se creará un registro y una notificación por correo?")){
				this.loading = true;
				let header={"Authorization" : "Bearer " + this.$store.state.token};
				let configuracion= {headers : header};
				axios.post('api/OrdenExpress/DeleteTemp',{
					'IdRegistro': item.idRegistro,
						
					},configuracion).then(function (response) {
						me.Mensaje = "Linea eliminada correctamente: "+response;
						me.BuscarCuentas();
						//me.selectMesa(me.MesaSeleccionada)
					})
					.catch(function (error) {
						me.snackbar = true;
						me.loading = false;
						me.Mensaje = 'Error eliminando el proveedor.'+error;    
					})
			}
      	},
		AñadirPOS(item){
			this.orden = item.noFactura;
			this.clienteCedula = item.cedula;
			this.clienteNombre = item.nombre,
			this.dialogCuenta = false;
			this.clienteCorreo = item.correo;
			this.vendedor = "Express"
			this.detalleFactura = "Agente: "+item.cajero +" "+item.nota +" "+item.noFactura;
			this.clienteTipoCedula = item.tipoCedula;

			for(var i=0;i<item.detalles.length;i++){
				this.detalles.push(
				{
				id: this.detalles.length + 5, 
				idarticulo:item.detalles[i].codigop,
				descripcion:item.detalles[i].descripcion,
				cantidad:item.detalles[i].cantidad,
				precio:item.detalles[i].precio,
				precioVenta:item.detalles[i].precio,
				precioDetalle:item.detalles[i].precio,
				precioCentral:item.detalles[i].precio,
				precioMayor:item.detalles[i].precio,
				precioCompra:item.detalles[i].precioCompra,
				Ivi:1,
				LlevaIvi: 'I.V.I',
				descuento:item.detalles[i].descuento,
				subtotal:item.detalles[i].precio,
				valorImpuesto:13,
				gravado:'S',
				cabys:item.detalles[i].codigoRaiz,
				inv:10,
				minimo:0,
				detalle: "",
				MaxDescuento:50,
				activador:0,
				cantDescuento:item.detalles[i].descuento,
				cantMinima:1,
				}
				);
				this.BuscarInventario(item.detalles[i].codigop);

			}
		},
		calcularPrecioPromos(data) {
			var resultado = 0.0;
			var montoDescuento;
			// Calcular el descuento
			montoDescuento = (data.precio * data.cantidad) - ((data.descuento) / 100) * (data.precio * data.cantidad);
			resultado = (montoDescuento / this.multiplo) * this.multiplo;
			resultado = resultado.toFixed(2); // Redondea a 2 decimales (ajusta el número según tus necesidades)
			return parseFloat(montoDescuento); // Convierte el resultado nuevamente a un número decimal

		},
		listarMensajeros(){
			var items = [];
			let me=this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Usuarios/SelectMensajeros/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				items = response.data;
				items.map(function(x){
					me.Mensajeros.push(x.nombre);
				});
				
			}).catch(function(error){
				alert("Mensajeros no encontrados"+error);
			});
		},
		obtenerPlan(){
			if(this.VentaSeriales != []){
				for(var i=0;i<this.VentaSeriales.length;i++ ){
					this.detalleFactura += this.VentaSeriales[i].CodigoSerial +",";
				}
			} else 
			{
				this.detalleFactura =  'Tipo Cambio $:' +this.Compra;
			}
			var self = this;
			var planes=[];
			var planes2=[];
			var clientePrevio="";
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/RepVentasVistas/ListarPlan/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				planes=response.data;
				if(!planes){

					return
				}else
				self.diasCredito = planes[0].periodo;
				self.Plan = planes[0].planNoah;
				self.LimiteFacturas = planes[0].limiteFact;
				self.FacturasRealizadas = planes[0].facturaMes;
				self.SaldoFacturas = planes[0].saldoFacturas;
				
			})
			
			axios.get('api/Localidades/ListarFiltrada/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				self.DatosLocalidad=response.data;
				self.modoPDV = self.DatosLocalidad[0].modoPDV;
				self.Regimen = self.DatosLocalidad[0].regimen;
				if(self.modoPDV == 6){
					self.validarConexionImpresora();
				}
				
			})
		},
		validarConexionImpresora(){
			axios.get('http://localhost:5000/status')
			.then(response => {
			console.log('El servicio de impresión está activo:', response.data);
			// Aquí podrías activar cualquier funcionalidad dependiente del backend
			})
			.catch(error => {
			console.error('El servicio de impresión no está disponible:', error);
			// Aquí mostrarías un mensaje al usuario indicando que debe iniciar el servicio
			alert('Por favor, inicia el app para impresión antes de continuar.');
			});
		},
		guardarSeriales(){
			for(var i=0;i<this.seriales.length;i++ ){
			if(this.seriales[i].existe == true )

				this.VentaSeriales.push(
				{
				Codigoroducto:this.seriales[i].codigoProducto,
				Descricion:this.seriales[i].descricion,
				CodigoSerial:this.seriales[i].codigoSerial,
				}
				);
			}
			this.Mensaje = "Seriales Agregados con éxito";
			this.snackbar = true;
			this.modelSeriales = false;
			this.seriales = [];
		},
		AñadirCodigo(item){
			this.modelCarga = true;
			this.modelSeriales = true;
			this.codigoProducto = item.idarticulo;
			this.nombre = item.descripcion;
			let me=this;
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
				var productosArray=[];
				axios.get('api/CodigosSeriales/ObtenerSerialStock/'+me.$store.state.usuario.localidad+'/'+me.codigoProducto,configuracion).then(function(response){
					me.seriales=response.data;
					me.modelCarga = false;
				}).catch(function(error){
					me.modelCarga = false;
					me.Mensaje = error;
					me.snackbar = true;
					alert(error);
				});
		},
		AñadirCabys(item){
			this.modelCabys = true;
			this.codigoProducto = item.idarticulo;
			this.nombre = item.descripcion;
		},
		CalcularPrecio(){
			var resultado = 0;
			let me=this;
			if(this.listaPrecio == 'Precio Detalle'){
				for(var i=0;i<this.detalles.length;i++ ){
					me.detalles[i].precio = me.detalles[i].precioDetalle;
				}
			}
			if(this.listaPrecio == 'Precio Central'){
				for(var i=0;i<this.detalles.length;i++ ){
					me.detalles[i].precio = me.detalles[i].precioCentral;
				}
			}
			if(this.listaPrecio == 'Precio Mayor'){
				for(var i=0;i<this.detalles.length;i++ ){
					me.detalles[i].precio = me.detalles[i].precioMayor;
				}
			}
		
		},
		SetPrecioVenta(){
			this.listaPrecio = 'Precio Venta';
			this.CalcularPrecio();
		},
		SetPrecioDetalle(){
			this.listaPrecio = 'Precio Detalle';
			this.CalcularPrecio();
		},
		SetPrecioCentral(){
			this.listaPrecio = 'Precio Central';
			this.CalcularPrecio();
		},
		SetPrecioMayor(){
			this.listaPrecio = 'Precio Mayor';
			this.CalcularPrecio();
		},
		sumarCantidades(items) {
			return items.reduce((total, item) => {
			return total + (parseInt(item.cantidad) || 0);
			}, 0);
		},
		ValidarIvI(){
			for(var i=0;i<this.detalles.length;i++){
			if(this.detalles[i].Ivi == false)
			{
			this.IviBackend = true; //se va sumar el iva si llega aqui
			return;
			}
			if(this.detalles[i].Ivi == true)
			{
			this.IviBackend = false; // si entra aqui el IVa no se suma al precio de venta
			return;
			}
			} 
		},
		async obtenerCliente(){
			var self = this;
			var clientesArray=[];
			var clientePrevio="";
			if (this.idcliente.text2 === undefined)
			{
				clientePrevio = this.idcliente;
			}
			else
			{
				clientePrevio = this.idcliente.text2;
			}
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/Empleados/ObtenerCliente', { params: {'clienteFactura': clientePrevio}},configuracion).then(function(response){
				clientesArray=response.data;
				self.clienteNombre = clientesArray[0].nombre;
				self.clienteCorreo = clientesArray[0].correo;
				for(var i = 0; i < clientesArray.length; ++i)
				{
				self.clienteCedula = clientesArray[i].cedula;
				self.clienteTipoCedula = clientesArray[i].tipoCedula;
				self.clienteTelefono = clientesArray[i].telefono;
				self.listaPrecio = clientesArray[i].listaPrecio;
				//self.vendedor = clientesArray[i].vendedor;
				self.diasCredito = clientesArray[i].periodo;
				self.nombreComercial= clientesArray[i].nombreFantasia;
				break;
				
				} 
				self.ConsultarPuntos();
				self.CalcularPrecio();
			})
		},
		async ConsultarPuntos(){
			let self = this;
			let header = {"Authorization" : "Bearer "}; // Asegúrate de que el token de autorización esté incluido aquí
			let configuracion = {headers: header};

			// Añade la localidad como parte de la URL
			let url = `api/RepVentasVistas/CalcularPuntos/${this.clienteCedula}/${this.$store.state.usuario.localidad}`;

			await axios.get(url, configuracion).then(function(response){
				self.puntos = response.data;
			}).catch(function(error){
				console.error("Error en la consulta de puntos:", error);
				// Manejo de errores (opcional)
			});
		},

		obtenerClienteProforma(){
			var self = this;
			var clientesArray=[];
			var clientePrevio="";
			clientePrevio = this.idcliente.split("-", 1);
			var divisiones = clientePrevio[0].trimEnd();
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Empleados/ObtenerCliente', { params: {'clienteFactura': divisiones}},configuracion).then(function(response){
				clientesArray=response.data;
				self.clienteNombre = clientesArray[0].nombre;
				self.clienteCorreo = clientesArray[0].correo;
				for(var i = 0; i < clientesArray.length; ++i)
				{
				self.clienteCedula = clientesArray[i].cedula;
				self.clienteTipoCedula = clientesArray[i].tipoCedula;
				self.clienteTelefono = clientesArray[i].telefono;
				self.listaPrecio = clientesArray[i].listaPrecio;
				self.diasCredito = clientesArray[i].periodo;
				self.nombreComercial= clientesArray[i].nombreFantasia;
				
				return;
				
				} 
			})
		},
		facturar() { 
			if(this.NotaCreditoFactura === true && this.ReferenciaFactura === ""){
				this.snackbar = true;
				this.Mensaje ="Debe digitar la factura de referencia para la nota de crédito para continuar";
				return;
			}
			this.limpiarPago()
			var esIvi = 0;
			var noesIvi = 0;
			this.selectTipoCambioInterno();
			if(this.Stock0 == true){
				for(var i=0;i<this.detalles.length;i++){
				if (this.detalles[i].inv <= 0){
					this.Mensaje = "No se puede facturar el producto "+this.detalles[i].descripcion + " porque no tiene inventario";
					this.snackbar = true;
					
					return;
				}
			}
			}
			for(var i = 0; i < this.detalles.length; ++i)
			{
			if(this.detalles[i].cabys == '0' || this.detalles[i].cabys == '' || this.detalles[i].cabys == null){
				if(confirm('ADVERTENCIA: El producto '+this.detalles[i].descripcion+' sin códigos Cabys, esto podría producir rechazo en comprobantes electrónicos, desea revisarlos?')){
				this.snackbar = true;
				this.Mensaje = 'Buena idea, revisa que tus productos tengan el cabys correcto.';
				return;
				}
			}
			if( this.detalles[i].Ivi == false){
				noesIvi = 1;
				} else
				if( this.detalles[i].Ivi == true){
					esIvi = 1;
				}
			}
			if(esIvi == noesIvi){
				if(confirm('ADVERTENCIA: existen algunos productos IVI y otros no, esto podría producir una alteración en su cobro de impuestos, desea revisarlos?')){
				this.snackbar = true;
				this.Mensaje = 'Buena idea, revisa que tus productos tengan el impuesto correcto en el campo de precio';
				return;
				}
			}
			if(this.info.data == undefined){
				this.Venta = 590;
				this.Compra = 540;
			} else
			{
				this.Venta = this.info.data.venta;
				this.Compra = this.info.data.compra;
			}
			
			//this.date = this.sumarDias();
			//this.date = this.date.toISOString().substr(0, 10);
			if (this.validarPago() != 0)
			{
				this.vueltoPagar = this.total * -1;
				this.totalPagar = this.total;
				this.dialogPago = true;
				this.efectivoPagar = 0;
				this.tarjetaPagar = 0;
				this.obtenerPlan();
				this.listarBancos();
			}
			else
			{
				this.dialogPago = false;
				return;
			}
		},
		facturarCredito() {
			if (!this.idcliente)
			{
				this.Mensaje ="Seleccione un cliente para crear cuenta crédito";
				this.snackbar = true;
				return
			} 
			else if(this.detalles.length == 0){
				this.Mensaje ="Selecione Productos para facturar a crédito";
				this.snackbar = true;
				return
			} else
			{
				this.detalleFactura = "";
				this.totalPagar = this.total;
				this.dialogPagoCredito = true;
				this.obtenerPlan();
				this.efectivoPagar = 0;
				this.tipoPago = "CREDITO";
				this.saldo = this.totalPagar;
				this.tarjetaPagar = 0;
			}
		},
		async selectPanelControl(){  
			let me=this;
			var localidadesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/PanelControls/ListarLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				localidadesArray=response.data;
				me.AddImpServ= localidadesArray[0].impServ;
				me.AgregarCompuesto= localidadesArray[0].agregarCompuesto; // Este campo es para no enviar hacienda ninguna factura -- utilizar en règimen simplificado
				me.Stock0 = localidadesArray[0].otro; // este campo si esta en true busca el inventario al facturar, si esta en false no busca inventario
				me.BloqueoVendedor = localidadesArray[0].mostrarTeclado; // este se utiliza para hacer obligatorio el uso de Vendedor y TipoDoc
				me.ModoCant= localidadesArray[0].modoCantidades; // Si esta funcion esta en true posiciona el focus sobre la cantidad de data table
				me.Multiplo = localidadesArray[0].multiplo;
				me.ActivarRecibos =  localidadesArray[0].recibos;
				me.selectVendedores();
			})
		},
		Enfocar(){
			document.querySelector("#buscador").focus();
		},
		SelectLastIdTable(){
			document.querySelector("#cantidad").focus();
		},
		agregarSerial(){
			var me = this;
			for(var i = 0; i < this.seriales.length; ++i)
			{
				if(this.serial == this.seriales[i].codigoSerial){
				me.seriales[i].existe = true;
				me.seriales[i].vendedor = me.$store.state.usuario.nombre;
				me.Mensaje = "Serial "+me.serial+" agregado";
				me.snackbar = true;
				me.serial = '';
				return;
				}
				me.Mensaje = "Serial "+me.serial+" no Encontrado"
				me.snackbar = true;
			}
		},
		agregarCabys(){
			var me = this;
			for(var i = 0; i < this.detalles.length; ++i)
			{
				if(this.codigoProducto == this.detalles[i].idarticulo){
				me.detalles[i].cabys = me.serial;
				me.Mensaje = "Código Cabys "+me.serial+" agregado al código: "+me.codigoProducto;
				me.snackbar = true;
				me.modelCabys = false;
				me.ActualizarCabys();
				return;
				}
				me.Mensaje = "Producto con Cabys "+me.serial+" no Encontrado"
				me.snackbar = true;
				me.modelCabys = false;
			}
			
		},
		selectProductos(){
			let me=this;
			let Objeto = [];
			let myInput = document.getElementById('buscador');
			myInput = myInput.value;
			let cant = myInput.length;
			if ( cant > 2 ) {
				var search_term = myInput;
				
				this.timeouts.map( timeout => {
					window.clearTimeout( timeout );
				} );
				this.timeouts.push(
					setTimeout( () => {
						this.loading = true;
						axios.get('api/Productos/BuscadorEnter/'+this.$store.state.usuario.localidad+'/'+myInput).then( response => {
							Objeto = response.data
								// Cargar Productos 
								Objeto.map(function(x){
									me.productos.push({text:x.descripcion, value:x.codigoProducto});
								});
								me.loading = false;
							} )
							.catch( error => { } );
					}, 500 )
				);
			} else {
				this.timeouts.map( timeout => {
					window.clearTimeout( timeout );
				} );
				this.productos = [];
			}
		},
		SaldoPendiente() { 
				this.saldo = (((parseInt(this.tarjetaPagar) + parseInt(this.SinpePagar) + parseInt(this.efectivoPagar) +parseInt(this.depositoPagar)) - parseInt(this.totalPagar))) * -1;
		},    
		validarDetalles() {
			for (let i = 0; i < this.detalles.length; i++) {
				let detalle = this.detalles[i];

				// Verifica si 'cantidad' o 'precio' están vacíos o no son numéricos
				if (detalle.cantidad === '' || isNaN(detalle.cantidad) || 
					detalle.precio === '' || isNaN(detalle.precio)) {
					// Si alguna condición se cumple, muestra una alerta y detiene la ejecución
					alert(`Error en la línea de producto: ${detalle.descripcion}. La cantidad y el precio deben ser valores numéricos.`);
					return false; // Retorna false indicando que la validación falló
				}
			}
			return true; // Retorna true si todos los detalles son válidos
		},
		

		async CrearProforma2() 
		{ 
		
			if(this.clienteCedula == ""){
				
				this.snackbar = true;
				this.Mensaje = 'Seleccione un Cliente para continuar';
				return;
			} 
			if (!this.validarDetalles()) {
				return; // Detiene la ejecución si la validación falla
			}

			var products = "";
			for(var i = 0; i < this.detalles.length; ++i)
				{
					products += `<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.detalles[i].descripcion+` (`+this.detalles[i].cantidad+`) </p></td>
									<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.monedaPago+` `+this.detalles[i].precio+`</p></td>
								</tr>`
					
				}
			

		var email = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
				<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<head>
				<meta charset="UTF-8">
				<meta content="width=device-width, initial-scale=1" name="viewport">
				<meta name="x-apple-disable-message-reformatting">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta content="telephone=no" name="format-detection">
				<title>Nuevo mensaje</title>
				<!--[if (mso 16)]>
				<style type="text/css">
				a {text-decoration: none;}
				</style>
				<![endif]-->
				<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
				<!--[if gte mso 9]>
				<xml>
				<o:OfficeDocumentSettings>
				<o:AllowPNG></o:AllowPNG>
				<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
				</xml>
				<![endif]-->
				<!--[if !mso]><!-- -->
				<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i" rel="stylesheet">
				<!--<![endif]-->
				<style type="text/css">
				#outlook a {
				padding:0;
				}
				.ExternalClass {
				width:100%;
				}
				.ExternalClass,
				.ExternalClass p,
				.ExternalClass span,
				.ExternalClass font,
				.ExternalClass td,
				.ExternalClass div {
				line-height:100%;
				}
				.es-button {
				mso-style-priority:100!important;
				text-decoration:none!important;
				}
				a[x-apple-data-detectors] {
				color:inherit!important;
				text-decoration:none!important;
				font-size:inherit!important;
				font-family:inherit!important;
				font-weight:inherit!important;
				line-height:inherit!important;
				}
				.es-desk-hidden {
				display:none;
				float:left;
				overflow:hidden;
				width:0;
				max-height:0;
				line-height:0;
				mso-hide:all;
				}
				@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1 { font-size:32px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:32px!important } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:16px!important; display:inline-block!important; border-width:15px 30px 15px 30px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
				</style>
				</head>
				<body style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<div class="es-wrapper-color" style="background-color:#EEEEEE">
				<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#eeeeee"></v:fill>
				</v:background>
				<![endif]-->
				<table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td valign="top" style="padding:0;Margin:0">
				<table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<!--[if mso]><table style="width:580px" cellpadding="0" cellspacing="0"><tr><td style="width:282px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:282px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">Nueva proforma de `+this.$store.state.usuario.localidad+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:278px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:278px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><a href="https://www.noah.cr" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">WebSite booster</a></p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse"></tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#044767;width:600px" cellspacing="0" cellpadding="0" bgcolor="#044767" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:340px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:340px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;font-size:0px"><img class="adapt-img" src="https://i.ibb.co/jzWbkDB/logo-noah-2.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="140"></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:170px" valign="top"><![endif]-->
				<table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr class="es-hidden" style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:170px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:5px;font-size:0">
				<table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;border-bottom:1px solid #044767;background:#FFFFFF none repeat scroll 0% 0%;height:1px;width:100%;margin:0px"></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0">
				<table cellspacing="0" cellpadding="0" align="right" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#FFFFFF;font-size:14px">Nueva Proforma</p></td>
				</tr>
				</table></td>
				<td valign="top" align="left" style="padding:0;Margin:0;padding-left:10px;font-size:0"><a href="https://www.noah.cr" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#FFFFFF;font-size:14px"><img src="https://i.ibb.co/dkwq9DD/Logo-2019-website3-1.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="27"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px;padding-top:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-top:25px;padding-bottom:25px;padding-left:35px;padding-right:35px;font-size:0"><a target="_blank" href="https://viewstripo.email/" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#ED8E20;font-size:16px"><img src="https://i.ibb.co/jzWbkDB/logo-noah-2.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="120"></a></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:10px"><h2 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#333333">Gracias por cotizar en `+this.$store.state.usuario.localidad+`!</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:15px;padding-bottom:20px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#777777;font-size:16px">Estimad@ `+this.clienteNombre+` su proforma esta lista, Puede presionar el botón para aceptar, rechazar o a descargarla en PDF.<br> Proforma realizada por: `+this.$store.state.usuario.nombre+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td bgcolor="#eeeeee" align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Producto</h4></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Precio</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				`+products+`
				<tr style="border-collapse:collapse">
				<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Impuestos</p></td>
				<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px"> `+this.totalImpuesto+`</p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Descuentos</p></td>
				<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px"> `+this.totalDescuento+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:10px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;border-top:3px solid #EEEEEE;border-bottom:3px solid #EEEEEE" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">TOTAL</h4></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">`+this.total+`</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:35px;padding-right:35px;padding-top:40px;padding-bottom:40px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:255px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Address</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:10px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Costa Rica</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:255px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Fecha</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.today+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#1B9BA3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#1b9ba3" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:25px"><h2 style="Margin:0;line-height:29px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:24px;font-style:normal;font-weight:bold;color:#FFFFFF">Aceptar Proforma</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-left:10px;padding-right:10px;padding-bottom:15px;padding-top:30px"><span class="es-button-border" style="border-style:solid;border-color:transparent;background:#66B3B7;border-width:0px;display:inline-block;border-radius:5px;width:auto"><a href="https://www.noah.cr/aceptarproforma/0/`+this.$store.state.usuario.localidad+`" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:18px;border-style:solid;border-color:#66B3B7;border-width:15px 30px 15px 30px;display:inline-block;background:#66B3B7;border-radius:5px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-weight:normal;font-style:normal;line-height:22px;width:auto;text-align:center">Aceptar Proforma</a></span></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table cellpadding="0" cellspacing="0" class="es-footer es-visible-simple-html-only" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td class="es-stripe-html" align="center" style="padding:0;Margin:0">
				<table class="es-footer-body" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-left:35px;padding-right:35px;padding-bottom:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:15px;font-size:0"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/67371618634728603.png" alt="Beretun logo" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title="Beretun logo" width="37"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:35px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#333333;font-size:14px"><b>Enviado por Noah Systems CR</b></p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td esdev-links-color="#777777" align="left" class="es-m-txt-c" style="padding:0;Margin:0;padding-bottom:5px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#777777;font-size:14px">
				Este email fue generado de forma automática, por favor no responda ya que no obtendrá respuesta</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				</div>
				</body>
				</html>`;
			this.loading = true;
			let barcodepreview = Date.now();
			let idsa = barcodepreview.toString();
			let NoProforma = idsa.substring(5, 12);
			for(var i = 0; i < this.detalles.length; ++i)
			{
			this.productosDatos.push(
				{
					CodigoProducto:this.detalles[i].idarticulo,
					Cantidad:this.detalles[i].cantidad,
					UnidadMedida:"UND",
					Descripcion:this.detalles[i].descripcion,
					PrecioUnitario:this.detalles[i].precio,
					MontoDescuento:this.detalles[i].descuento,                          
					ValorImpuesto:this.detalles[i].valorImpuesto,
					Gravado:this.detalles[i].gravado,
					Ivi: this.detalles[i].Ivi,
					DetalleLinea :this.detalles[i].detalle
				}
				);
			}
			var self = this;
			var link = '';
			var linkProforma = location.origin+'/proformas';
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.post('api/Proformas/Crear',{
				'Cajero':self.$store.state.usuario.nombre,
				'Localidad': self.$store.state.usuario.localidad,
				'Cliente':self.clienteNombre + " - "+ self.nombreComercial,
				'Correo': self.clienteCorreo,
				'Vendedor': self.vendedor,
				'iva': self.totalImpuesto,
				'PrecioSinIva': self.totalGravado,
				'Contacto':self.clienteTelefono,
				'TipoDocumento':self.clienteCedula.replace(/-/g,"").replace(/ /g, ""),
				'MontoFacturado':self.total,
				'Contacto1':self.monedaPago,
				'Estado': 0,
				'Mail':email,
				'detalles': self.productosDatos,
				'Detalle':self.detalleFactura,
				'Descuento':self.totalDescuento,
				'EnviarMail': self.EnviarEmail,
				'Vencimiento': this.vencimiento,
			},configuracion).then(function (response) {
				if(self.modoPDV == 5  || self.modoPDV == 3 || self.modoPDV == 1){
						//console.log(response)
						self.noFactura = response.data;
						self.$nextTick(() => {
							self.ImpresiondirectaProforma();
						});
						return;
				}
				else {
					location.assign(linkProforma); 
				}
				// location.reload();
			}).catch(function(error){
				self.snackbar = true;
				self.productosDatos = [];
				self.Mensaje = 'Error al crear proforma, reporte a su proveedor el problema'+error;
			}); 
		},
		async CrearODT() 
		{ 
			this.loading = true;
			if(this.clienteNombre == ""){
				
				this.snackbar = true;
				this.Mensaje = 'Seleccione un Cliente';
				this.loading= false;
				return;
			} 
			//this.loading = true;
			for(var i = 0; i < this.detalles.length; ++i)
				{
				this.productosDatos.push(
					{
						CodigoProducto:this.detalles[i].idarticulo,
						Cantidad:this.detalles[i].cantidad,
						UnidadMedida:"UND",
						Descripcion:this.detalles[i].descripcion,
						PrecioUnitario:this.detalles[i].precio,
						MontoDescuento:this.detalles[i].descuento,                          
						ValorImpuesto:this.detalles[i].valorImpuesto,
						Gravado:this.detalles[i].gravado,
						Ivi: this.detalles[i].Ivi,
						DetalleLinea :this.detalles[i].detalle
					}
					);
				}
			var self = this;
			var link = '';
			var linkProforma = location.origin+'/odt';
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.post('api/Odts/Crear',{
				'Cajero':self.$store.state.usuario.nombre,
				'Localidad': self.$store.state.usuario.localidad,
				'Cliente':self.clienteNombre + " - "+ self.nombreComercial,
				'Correo': self.clienteCorreo,
				'Vendedor': self.vendedor,
				'iva': self.totalImpuesto,
				'PrecioSinIva': self.totalGravado,
				'Contacto':self.clienteTelefono,
				'TipoDocumento':self.clienteCedula.replace(/-/g,"").replace(/ /g, ""),
				'MontoFacturado':self.total,
				'Contacto1':self.monedaPago,
				'Estado': 0,
				'Mail':self.saldo,
				'Total':self.total,
				'TipoPagoCredito':self.tipoPagoCredito,
				'detalles': self.productosDatos,
				'Detalle':self.detalleFactura+ "Adelanto: "+this.total,
				'Saldo': this.saldo,
				'CedulaReceptor': this.clienteCedula.replace(/-/g,"").replace(/ /g, ""),
				'DiasCredito': this.diasCredito,
				'Vencimiento': this.vencimiento,
				'EstadoLinea':'Pendiente',
				'Dept':'Sin Asignar',
			},configuracion).then(function (response) {
			location.assign(linkProforma); 
			// location.reload();
			}).catch(function(error){
				self.snackbar = true;
				self.Mensaje = 'Error al crear ODT, reporte a su proveedor el problema ' +error;
			}); 
		},
		async ActualizarProforma() 
		{ 
		
			if(this.clienteNombre == ""){
				
				this.snackbar = true;
				this.Mensaje = 'Seleccione un Cliente';
				return;
			} 
			var products = "";
			for(var i = 0; i < this.detalles.length; ++i)
					{
						products += `<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.detalles[i].descripcion+` (`+this.detalles[i].cantidad+`) </p></td>
										<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.monedaPago+` `+this.detalles[i].precio+`</p></td>
									</tr>`
						
					}
			var email = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
				<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<head>
				<meta charset="UTF-8">
				<meta content="width=device-width, initial-scale=1" name="viewport">
				<meta name="x-apple-disable-message-reformatting">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta content="telephone=no" name="format-detection">
				<title>Nuevo mensaje</title>
				<!--[if (mso 16)]>
				<style type="text/css">
				a {text-decoration: none;}
				</style>
				<![endif]-->
				<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
				<!--[if gte mso 9]>
				<xml>
				<o:OfficeDocumentSettings>
				<o:AllowPNG></o:AllowPNG>
				<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
				</xml>
				<![endif]-->
				<!--[if !mso]><!-- -->
				<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i" rel="stylesheet">
				<!--<![endif]-->
				<style type="text/css">
				#outlook a {
				padding:0;
				}
				.ExternalClass {
				width:100%;
				}
				.ExternalClass,
				.ExternalClass p,
				.ExternalClass span,
				.ExternalClass font,
				.ExternalClass td,
				.ExternalClass div {
				line-height:100%;
				}
				.es-button {
				mso-style-priority:100!important;
				text-decoration:none!important;
				}
				a[x-apple-data-detectors] {
				color:inherit!important;
				text-decoration:none!important;
				font-size:inherit!important;
				font-family:inherit!important;
				font-weight:inherit!important;
				line-height:inherit!important;
				}
				.es-desk-hidden {
				display:none;
				float:left;
				overflow:hidden;
				width:0;
				max-height:0;
				line-height:0;
				mso-hide:all;
				}
				@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1 { font-size:32px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:32px!important } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:16px!important; display:inline-block!important; border-width:15px 30px 15px 30px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
				</style>
				</head>
				<body style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<div class="es-wrapper-color" style="background-color:#EEEEEE">
				<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#eeeeee"></v:fill>
				</v:background>
				<![endif]-->
				<table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td valign="top" style="padding:0;Margin:0">
				<table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<!--[if mso]><table style="width:580px" cellpadding="0" cellspacing="0"><tr><td style="width:282px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:282px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">Nueva proforma de `+this.$store.state.usuario.localidad+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:278px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:278px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><a href="https://www.noah.cr" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">WebSite booster</a></p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse"></tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#044767;width:600px" cellspacing="0" cellpadding="0" bgcolor="#044767" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:340px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:340px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;font-size:0px"><img class="adapt-img" src="https://i.ibb.co/jzWbkDB/logo-noah-2.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="140"></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:170px" valign="top"><![endif]-->
				<table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr class="es-hidden" style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:170px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:5px;font-size:0">
				<table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;border-bottom:1px solid #044767;background:#FFFFFF none repeat scroll 0% 0%;height:1px;width:100%;margin:0px"></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0">
				<table cellspacing="0" cellpadding="0" align="right" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#FFFFFF;font-size:14px">Nueva Proforma</p></td>
				</tr>
				</table></td>
				<td valign="top" align="left" style="padding:0;Margin:0;padding-left:10px;font-size:0"><a href="https://www.noah.cr" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#FFFFFF;font-size:14px"><img src="https://i.ibb.co/dkwq9DD/Logo-2019-website3-1.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="27"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px;padding-top:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-top:25px;padding-bottom:25px;padding-left:35px;padding-right:35px;font-size:0"><a target="_blank" href="https://viewstripo.email/" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#ED8E20;font-size:16px"><img src="https://i.ibb.co/jzWbkDB/logo-noah-2.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="120"></a></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:10px"><h2 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#333333">Gracias por cotizar en `+this.$store.state.usuario.localidad+`!</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:15px;padding-bottom:20px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#777777;font-size:16px">Estimad@ `+this.clienteNombre+` su proforma esta lista, Puede presionar el botón para aceptar, rechazar o a descargarla en PDF.<br> Proforma realizada por: `+this.$store.state.usuario.nombre+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td bgcolor="#eeeeee" align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Producto</h4></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Precio</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				`+products+`
				<tr style="border-collapse:collapse">
				<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Impuestos</p></td>
				<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px"> `+this.totalImpuesto+`</p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Descuentos</p></td>
				<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px"> `+this.totalDescuento+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:10px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;border-top:3px solid #EEEEEE;border-bottom:3px solid #EEEEEE" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">TOTAL</h4></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">`+this.total+`</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:35px;padding-right:35px;padding-top:40px;padding-bottom:40px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:255px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Address</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:10px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">Costa Rica</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:255px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Fecha</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.today+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#1B9BA3;width:600px" cellspacing="0" cellpadding="0" bgcolor="#1b9ba3" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:25px"><h2 style="Margin:0;line-height:29px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:24px;font-style:normal;font-weight:bold;color:#FFFFFF">Aceptar Proforma</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-left:10px;padding-right:10px;padding-bottom:15px;padding-top:30px"><span class="es-button-border" style="border-style:solid;border-color:transparent;background:#66B3B7;border-width:0px;display:inline-block;border-radius:5px;width:auto"><a href="https://www.noah.cr/aceptarproforma/`+this.$route.params.id+ `/`+this.$store.state.usuario.localidad+`" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:18px;border-style:solid;border-color:#66B3B7;border-width:15px 30px 15px 30px;display:inline-block;background:#66B3B7;border-radius:5px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-weight:normal;font-style:normal;line-height:22px;width:auto;text-align:center">Aceptar Proforma</a></span></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table cellpadding="0" cellspacing="0" class="es-footer es-visible-simple-html-only" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td class="es-stripe-html" align="center" style="padding:0;Margin:0">
				<table class="es-footer-body" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-left:35px;padding-right:35px;padding-bottom:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:15px;font-size:0"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/67371618634728603.png" alt="Beretun logo" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title="Beretun logo" width="37"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:35px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#333333;font-size:14px"><b>Enviado por Noah Systems CR</b></p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td esdev-links-color="#777777" align="left" class="es-m-txt-c" style="padding:0;Margin:0;padding-bottom:5px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#777777;font-size:14px">
				Este email fue generado de forma automática, por favor no responda ya que no obtendrá respuesta</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				</div>
				</body>
				</html>`;
			this.loading = true;
			for(var i = 0; i < this.detalles.length; ++i)
				{
				this.productosDatos.push(
					{
						CodigoProducto:this.detalles[i].idarticulo,
						Cantidad:this.detalles[i].cantidad,
						UnidadMedida:"UND",
						Descripcion:this.detalles[i].descripcion,
						PrecioUnitario:this.detalles[i].precio,
						MontoDescuento:this.detalles[i].descuento,                          
						ValorImpuesto:this.detalles[i].valorImpuesto,
						Gravado:this.detalles[i].gravado,
						Ivi: this.detalles[i].Ivi,
						DetalleLinea : this.detalles[i].detalle
					}
					);
				}
			var self = this;
			var NoProforma = this.$route.params.id;
			var linkProforma = location.origin+'/proformas';
			let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				await axios.post('api/Proformas/Actualizar',{
					'Cajero':self.$store.state.usuario.nombre,
					'NoProforma':NoProforma,
					'Localidad': self.$store.state.usuario.localidad,
					'Cliente':self.clienteNombre + " - ",
					'Correo': self.clienteCorreo,
					'Vendedor': self.vendedor,
					'iva': self.totalImpuesto,
					'PrecioSinIva': self.totalGravado,
					'Contacto':self.clienteTelefono,
					'TipoDocumento':self.clienteCedula.replace(/-/g,"").replace(/ /g, ""),
					'MontoFacturado':self.total,
					'Contacto1':self.monedaPago,
					'Estado': 0,
					'Mail':email,
					'detalles': self.productosDatos,
					'Descuento':self.totalDescuento,
					'Detalle':self.detalleFactura,
					'NoPrecompra': self.AdelantoTrabajo,
				},configuracion).then(function (response) {
				location.assign(linkProforma); 
				// location.reload();
				}).catch(function(error){
					self.snackbar = true;
					self.Mensaje = 'Error al crear proforma, reporte a su proveedor el problema'+error;
				}); 
		},
		selectTipoCambioInterno(){  
			let me=this;
			var localidadesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ParametrosEmisors/ListarLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				localidadesArray=response.data;
				me.TipoCambioInterno= localidadesArray[0].tipoCambio;
			})
		},
		CrearProforma(){
			let barcodepreview = Date.now();
			let idsa = barcodepreview.toString();
			let NoProforma = idsa.substring(5, 12);
			for(var i = 0; i < this.detalles.length; ++i)
				{
				this.productosDatos.push(
					{
						CodigoProducto:this.detalles[i].idarticulo,
						Cantidad:this.detalles[i].cantidad,
						UnidadMedida:"UND",
						Descripcion:this.detalles[i].descripcion,
						PrecioUnitario:this.detalles[i].precio,
						MontoDescuento:this.detalles[i].descuento,                          
						ValorImpuesto:this.detalles[i].valorImpuesto,
						Gravado:this.detalles[i].gravado
					}
					);
				}
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
				let me=this;
				axios.put('api/Proformas/Crear',{
					'NoProforma':NoProforma,
				},configuracion).then(function(response){
					me.snackbar = true;
					me.Mensaje = 'Proforma creada correctamente';
				}).catch(function(error){
					alert(error);
					me.snackbar = true;
					me.Mensaje = 'Error al crear proforma, reporte a su proveedor el problema'+error;
				});
		},
		pagar() 
		{
			this.modelCarga =true;
			
			this.ValidarIvI();
			if(this.SaldoFacturas <= 0){
				this.SaldoAgotado = true;
				return;
			}
			this.resultadoCompra = ((parseInt(this.tarjetaPagar) + parseInt(this.efectivoPagar) + parseInt(this.depositoPagar)) - parseInt(this.Total));
			this.FacturarNew();
		},
		pagarCredito() 
			{
				if (this.validarPago() != 1)
				{
					return;
				}
				else
				{
					if (!this.monedaPago){
						alert("Seleccione un tipo de moneda.");
						return;
					}
					this.loading = true;
					this.resultadoCompra = ((parseInt(this.tarjetaPagar) + parseInt(this.efectivoPagar)) - parseInt(this.totalPagar));
					this.CondicionVenta = 'CREDITO'
					if(this.detalles[0].Ivi == false)
					{
					this.IviBackend = true;
					}
					this.FacturarNew();
					if (this.saldo < 0)
						{
						alert("Revisar montos de pago, Saldo sobrepasa monto total de factura")
						return;
						}
				}
			},
		async FacturarNew(){
			if (!this.validarDetalles()) {
				return; // Detiene la ejecución si la validación falla
			}
			if(this.tipoPago == ''){
				this.snackbar = true;
				this.Mensaje = "Debe seleccionar un método de pago";
				this.modelCarga = false;
				return;
			}
			if(this.vueltoPagar < 0 && this.tipoPago != "CREDITO"){
				this.snackbar = true;
				this.Mensaje = "No alcanza para cubrir el total de la factura, añada fondos en algun método de pago para continuar";
				this.modelCarga = false;
				return;
			}
			this.loading = true;
			var self = this;
			var momentoActual = new Date(); 
			var documentoHacienda = "";
			var link = '';
			var ticketNum = 0;
			var hora = momentoActual.getHours(); 
			var minuto = momentoActual.getMinutes(); 
			var segundo = momentoActual.getSeconds();
			var impuesto = 0;
			if (this.barbero.text != undefined)
			{
			this.barbero = this.barbero.text;
			} 

			if (this.tipoFactura == 1)
			{
			documentoHacienda = "FACTURA ELECTRONICA";
			impuesto = parseFloat(this.totalImpuesto);
			}
			else if (this.tipoFactura == 4)
			{
			documentoHacienda = "TIQUETE ELECTRONICO";
			impuesto = parseFloat(this.totalImpuesto);
			}
			else if (this.tipoFactura == 8)
			{
			documentoHacienda = "RECIBO";
			impuesto = 0;
			}
			// Pregunta si este valor esta en true para hacer un recibo (No Enviar Hacienda)
			if(this.ActivarRecibos == true && this.clienteNombre == "" && this.clienteCedula == "" && this.tipoPago == "EFECTIVO"){
				documentoHacienda = "RECIBO";
				this.tipoFactura = 8;
			} 
			for(var i = 0; i < this.detalles.length; ++i)
			{
				var montodesc = 0.0;
				var cant = 0.0;
				var UtilidadFactura = this.total - this.calcularCosto;
				cant = this.detalles[i].cantidad
				cant = parseFloat(cant)
				if( this.detalles[i].Ivi == false){
					montodesc=+(((this.detalles[i].descuento)/100)*(this.detalles[i].precio * this.detalles[i].cantidad));
				} else
				if( this.detalles[i].Ivi == true){
					montodesc=  ((this.detalles[i].descuento/100)*((this.detalles[i].precio / 1.13) * this.detalles[i].cantidad));
				}
				this.productosDatos.push(
				{
					CodigoProducto:this.detalles[i].idarticulo,
					Cantidad:parseFloat(cant), 
					UnidadMedida:"UND",
					Descripcion:this.detalles[i].descripcion,
					PrecioUnitario:this.detalles[i].precio,
					MontoDescuento:montodesc.toFixed(2),                          
					ValorImpuesto:this.detalles[i].valorImpuesto,
					Gravado:this.detalles[i].gravado,
					CodigoHacienda: this.detalles[i].cabys,
					EstadoImp: this.IviBackend,
					NumeroMM:this.detalles[i].impEspecial,
					TipoDocumento: this.tipoFactura,
					DiasCredito: this.diasCredito,
					TipoCedulaReceptor: this.clienteTipoCedula.toUpperCase()
				}
				);
			}
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				await axios.post('api/Facturas/CrearFactura',{
					'Detalle':this.detalleFactura+this.RefXML,
					'Gravado': parseFloat(this.totalGravado),
					'Exento': parseFloat(this.totalExento),
					'Iv': parseFloat(this.totalImpuesto),
					'Total': this.total,
					'Localidad': this.$store.state.usuario.localidad,
					'Cajero': this.$store.state.usuario.nombre,
					'TipoPago': this.tipoPago,
					'Descuento': this.totalDescuento,
					'ImpServicio': 0,
					'MontoExpress': 0,
					'SubTotal': this.totalParcial,
					'MontoExpres': 0,
					'TipoDocumento': documentoHacienda,
					'Nocomprobante': 0,
					'NoNotaCredito': "",
					'CondicionVenta': this.CondicionVenta,
					'Correo2': this.clienteCorreo2,
					'ClaveComprobante': 0,
					'Moneda': this.monedaPago.toUpperCase(),//USD O CRC
					'RefFacturaReal': "",
					'RefComprobante': "",
					'razonReferencia': "",
					'MensajeRespuesta': "",
					'NombreReceptor': this.clienteNombre,
					'CedulaReceptor': this.clienteCedula.replace(/-/g,"").replace(/ /g, ""),
					'CorreoReceptor': this.clienteCorreo,
					'TelefonoReceptor': this.clienteTelefono,
					'Razon': "",
					'RefFecha': "",
					'Vuelto': this.vueltoPagar,
					'Impuesto1': this.imp1,
					'Impuesto4 ': this.imp4,
					'Impuesto13': this.imp13,//total de Iva al 13%
					'Impuesto2': this.imp2,
					'Sincronizado ': 0,
					'Vendedor': this.vendedor,
					'TipoCambio': parseInt(this.Compra),
					'TotalSinR': this.total,
					'Hora': hora + ":" + minuto + ":" + segundo,
					'DiasCredito': this.diasCredito,
					'Saldo': this.saldo,
					'Producto': this.productosDatos,
					'Proforma': this.$route.params.id,
					'Motorizado':"",
					'TotalTarjeta':this.tarjetaPagar,
					'TotalEfectivo': this.efectivoPagar,
					'TotalSimpe':this.SinpePagar,
					'TotalDeposito':this.depositoPagar,
					'UtilidadFactura':UtilidadFactura,
					'Puntos':this.puntosAplicados,
					'Orden':this.orden,
					'TipoPagoCredito':this.tipoPagoCredito,
					'TotalNC':this.totalNC,
					'Credito':this.plataforma_pago,
					'TotalDolares':this.PagoDolares,
					'TipoFactura':this.tipoFactura,
				},configuracion).then(function (response) {
					self.snackbar= true;
					self.Mensaje = "Factura Realizada con éxito";
					ticketNum = response.data.item1;
					
					if(self.banco != ''){
						self.Deposito(ticketNum,documentoHacienda);
					}
					if(self.modoPDV == 3){
						self.ImprimrFactura(ticketNum,documentoHacienda,response.data.item2);
					}
					if(self.modoPDV == 1){
						var link = location.origin+'/'+'ticket/'+ticketNum;
						location.assign(link); 
						return;
					} 
					if(self.modoPDV == 2){
						link = location.origin+'/'+'repventas/';
						location.assign(link); 
						return;
					}
					if(self.modoPDV == 4){
						self.imprimirA4(ticketNum,documentoHacienda,response.data.item2);
						return;
					} 
					if(self.modoPDV == 0){
						if(self.$route.params.id != "0"){
						var link = location.origin+'/proformas';
						location.assign(link); 
						return;
						
						}
						location.reload();
						return;
					} else
					if(self.modoPDV == 5){
						let clave = 0
						if (response.data.item2 == null)
							{
								clave = 0;
							} else
							{
								clave  =response.data.item2;
							}
						self.Impresiondirecta(ticketNum,documentoHacienda,clave);
						return;
					};
					if(self.modoPDV == 6){
						let clave = 0
						if (response.data.item2 == null)
							{
								clave = 0;
							} else
							{
								clave  =response.data.item2;
							}
						self.imprimirTicket(ticketNum,documentoHacienda,clave);
						return;
					};
							
						location.reload();
					})
						.catch(function (error) {
						alert("No se pudo obtener respuesta, por favor verifique que la factura se realizó" +error)
						self.modelCarga = false;
						self.loading = false;
						location.reload();
				}
			)
		},
		ImpresiondirectaProforma(){
			// Mostrar solo la comanda para la impresión
				
				var printContents = document.getElementById("comandaproforma").innerHTML;

				document.body.innerHTML = printContents;

				window.print('', '', 'height=500, width=500');

				location.reload();
				// ...
		},
		async imprimirTicket(Factura,documentoHacienda,clave) {
			let clave2 = ""
			this.tipoFactura = 4;
			if (clave === undefined || clave === null || isNaN(clave)) {
				// El campo es undefined, null o NaN
				// Realiza la acción que deseas en este caso
				clave = "";
				} else {
				clave2 =  clave;
				}
			if (documentoHacienda === undefined || documentoHacienda === null || isNaN(documentoHacienda)) {
				// El campo es undefined, null o NaN
				// Realiza la acción que deseas en este caso
				documentoHacienda = "";
				} 
				var abono = parseInt(this.Total) - parseInt(this.saldo);
			
			// Sección de detalles de los productos
			let imp13 = this.imp13.toFixed(2);
			let dataParaImprimir = {
				Localidad:this.DatosLocalidad[0],
				productos: this.detalles,
				cliente: {
					nombre: this.clienteNombre,
					cedula: this.clienteCedula,
					telefono: this.clienteTelefono,
					documento: documentoHacienda,
					tipoPago: this.tipoPago,
					vendedor: this.vendedor,
					copias:1,
					abono: abono,
					saldo:this.saldo,
					beeper:this.beeper,
				},
				moneda:this.monedaPago,
				noFactura:Factura,
				Fecha:new Date().toLocaleString(),
				tipoPago:this.tipoPago,
				documento:documentoHacienda,
				total: this.Total,
				subtotal:this.totalParcial,
				descuento:this.calcularDescuento,
				items:this.totalCantidadFiltrada,
				vuelto:this.vueltoPagar,
				impEspecial: 0,
				impuestos: {
					iva13: imp13,
					iva1: this.imp1,
					iva2: this.imp2,
					iva4: this.imp4,
					otros: 0,
				},
				otrosDatos: {
					clave: clave2,
					detalle:this.detalleFactura,
				}
				
			};
			console.log(JSON.stringify(dataParaImprimir, null, 2));

			// Enviar el HTML al servidor Python para imprimir
			try {
				const response = await axios.post('http://localhost:5000/imprimir', dataParaImprimir);
				
				console.log('Ticket enviado a imprimir', response.data);
			} catch (error) {
				alert("Error al imprimir ticket: "+error);
				location.reload();
				console.error('Error al enviar el ticket para imprimir', error);
			}
			this.FinalizarOrden();
		},
		// Abrir el cajón de dinero desde el frontend
		ConsultaAperturaCajon(){
			if(this.esVendedor || this.esFacturador){
				this.dialogToken = true;
				this.GuiaToken = 1;
			} else
			{
				this.abrirCajonDinero();
			}
		},
		ConfirmacionToken(){
			let me = this;
			let tokenrecibido = 0;
			axios.get(`/token`)
			.then(response => {
				const data = response.data;
				tokenrecibido = data.token;
				if(tokenrecibido == me.TokenDigitado ){
					me.snackbar = true;
					me.Mensaje = "Token Aceptado";
					me.dialogToken = false;
					me.TokenDigitado = null;
					switch (me.GuiaToken) {
					case 1:
						me.abrirCajonDinero();
						break;
					case 2:
						for(var i=0;i<me.detalles.length;i++){
							me.detalles[i].MaxDescuento = 100;
						}
						me.AplicarDescuento();
						break;
					case 3:
					
					// Agrega más casos según sea necesario
					default:
						// Opcionalmente manejar cualquier caso no específicamente mencionado
						break;
					}
				} else
				{
					me.snackbar = true;
					me.Mensaje = "Token Invalido";
				}
			})
			.catch(error => {
				console.error("Error al obtener los del Token", error);
			});
		},
		async abrirCajonDinero() {
			try {
				const response = await axios.get('http://localhost:5000/abrir-cajon');
				console.log('Cajón de dinero abierto', response.data);
				this.Mensaje = "Cajón de dinero abierto";
				this.snackbar = true;
			} catch (error) {
				console.error('Error al abrir el cajón de dinero', error);
				this.Mensaje = "Error abriendo Cajón de dinero "+error;
				this.snackbar = true;
			}
		},
		Impresiondirecta(Factura,documentoHacienda,clave){
			const fechaActual = new Date();
			const Moneda = this.Moneda();
			let clave2 = ""
			if (clave === undefined || clave === null || isNaN(clave)) {
				// El campo es undefined, null o NaN
				// Realiza la acción que deseas en este caso
				clave = "";
				} else {
				clave2 =  clave;
				}
			// Obtener componentes de la fecha
			const dia = fechaActual.getDate();
			const mes = fechaActual.getMonth() + 1; // Sumamos 1 para obtener el mes correcto
			const año = fechaActual.getFullYear();

			// Obtener componentes de la hora
			const horas = fechaActual.getHours();
			const minutos = fechaActual.getMinutes();
			const segundos = fechaActual.getSeconds();

			// Formatear la fecha y hora en una cadena
			const fech = `${(dia)}/${(mes)}/${año} : ${(horas)}:${(minutos)}:${(segundos)}`;
			var contenidoImpresion = "\x1B\x40"; // Inicializar impresora en modo ESC/POS
			// Logo con enlace
			const logoURL = this.DatosLocalidad[0].imagen; // Reemplaza con la URL de tu logo
			const logoHTML = `<a href="${logoURL}"><img style="max-width: 180px; max-height: 180px;" src="${logoURL}" alt="Logo" /></a>`;

			// Función para ajustar el texto a los 80 mm de ancho y establecer el tamaño de fuente
			function ajustarTexto(texto, anchoMaximo, tamañoFuente) {
				// Convierte "texto" en una cadena de texto usando toString()
				texto = texto.toString();

				var espacios = anchoMaximo - texto.length;
				var estilo = `font-size: ${tamañoFuente}px;`;
				
				if (espacios >= 0) {
					return `<span style="${estilo}">${texto + " ".repeat(espacios)}</span>`;
				} else {
					var primeraLinea = texto.slice(0, anchoMaximo);
					var segundaLinea = texto.slice(anchoMaximo, anchoMaximo * 2);
					
					return `<span style="${estilo}">${primeraLinea}</span><br><span style="${estilo}">${segundaLinea}</span>`;
				}
			}
			// Encabezado
			// Encabezado
				contenidoImpresion += `
				<table style="width: 100%;">
					<tr>
					<td style="width: 50%;">
						${logoHTML}
					</td>
					<td style="width: 50%;">
						${ajustarTexto(this.$store.state.usuario.localidad, 80, 25)}<br>
						${ajustarTexto(this.DatosLocalidad[0].razonSocial, 80, 14)}<br>
						${ajustarTexto(this.DatosLocalidad[0].dirreccion, 80, 14)}<br>
						${ajustarTexto(this.DatosLocalidad[0].nombre, 80, 14)}<br>
						${ajustarTexto(this.DatosLocalidad[0].cedulaJuridica, 80, 14)}<br>
						${ajustarTexto(this.DatosLocalidad[0].telefono, 80, 14)}<br>
						${ajustarTexto(this.DatosLocalidad[0].correo, 80, 14)}<br>
					</td>
					</tr>
				</table>
				`;

			// Línea horizontal
			contenidoImpresion += ajustarTexto("Fecha: "+fech, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("No Factura: "+Factura, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Cliente: "+this.clienteNombre, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Cédula: "+this.clienteCedula, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Tel: "+this.clienteTelefono, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Documento: "+documentoHacienda, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Tipo Pago: "+this.tipoPago, 80,16) + "\n";
			contenidoImpresion += ajustarTexto("Vendedor: "+this.vendedor, 80,16) + "\n";
			contenidoImpresion += "-".repeat(80) + "\n";
			

			// Encabezado de la tabla de productos
			
			contenidoImpresion += ajustarTexto("Cant", 5);
			contenidoImpresion += ajustarTexto("Nombre", 45);
			contenidoImpresion += ajustarTexto("Precio", 30); // Ancho máximo ajustado para el campo precio
			contenidoImpresion += "\n";
			contenidoImpresion += "-".repeat(80) + "\n";

			// Filas de la tabla
			this.detalles.forEach(function (producto) {
			contenidoImpresion += ajustarTexto(producto.cantidad.toString(), 5, 16);
			contenidoImpresion += ajustarTexto(producto.descripcion, 35, 16);
			contenidoImpresion += ajustarTexto(Moneda + producto.precio.toString(), 40, 16); // Ajuste también el campo precio
			contenidoImpresion += "\n";
			});
			contenidoImpresion += "-".repeat(80) + "\n";
			// Línea horizontal

			// Encabezado de la de impuestos
			contenidoImpresion += ajustarTexto("IVA 1%", 10,16);
			contenidoImpresion += ajustarTexto("IVA 2%", 10,16);
			contenidoImpresion += ajustarTexto("IVA 4%", 10,16);
			contenidoImpresion += ajustarTexto("IVA 13%", 40,16);
			contenidoImpresion += "\n";
			// Vallores de impuesto
			contenidoImpresion += ajustarTexto(Moneda+this.imp1.toFixed(2), 10,16);
			contenidoImpresion += ajustarTexto(Moneda+this.imp2.toFixed(2), 10,16);
			contenidoImpresion += ajustarTexto(Moneda+this.imp4.toFixed(2), 10,16);
			contenidoImpresion += ajustarTexto(Moneda+this.imp13.toFixed(2), 40,16);
			contenidoImpresion += "\n";	
			contenidoImpresion += "-".repeat(80) + "\n";

			// Encabezado de la tabla totales
			contenidoImpresion += ajustarTexto("SubTotal", 10,16);
			contenidoImpresion += ajustarTexto("Descuento", 10,16);
			contenidoImpresion += ajustarTexto("   Total", 10,16);
			contenidoImpresion += ajustarTexto("Vuelto", 10,16);
			contenidoImpresion += "\n";

			// Valores de totales
			contenidoImpresion += ajustarTexto(Moneda+this.totalParcial, 10,16);
			contenidoImpresion += ajustarTexto(Moneda+this.calcularDescuento, 10,16);
			contenidoImpresion += ajustarTexto(Moneda+this.total, 10,20);
			contenidoImpresion += ajustarTexto(Moneda+this.vueltoPagar, 50,16);
			contenidoImpresion += "\n";

			contenidoImpresion += "-".repeat(80) + "\n";

			if(this.tipoPago == "CREDITO"){
				var abono = this.total - this.saldo;
				contenidoImpresion += ajustarTexto("Abono: "+abono, 80,16) + "\n";
				contenidoImpresion += ajustarTexto("Saldo: "+this.saldo, 80,16) + "\n";
				contenidoImpresion += "\n";
				contenidoImpresion += "\n";
				contenidoImpresion += "\n";
				contenidoImpresion += ajustarTexto("Firma: ____________________________", 80,16) + "\n";
			}
			// Píe Pagina
			contenidoImpresion += ajustarTexto("Detalle: "+this.detalleFactura, 80,16) + "\n";
			contenidoImpresion += ajustarTexto(clave2, 80,16) + "\n";
			contenidoImpresion += this.DatosLocalidad[0].longitud+"\n";
			contenidoImpresion += ajustarTexto(this.DatosLocalidad[0].pieDocumento,80,14)+"\n";


			contenidoImpresion += "\x1D\x56\x01"; // Corte de papel
			document.write('<pre>' + contenidoImpresion + '</pre>');
			
			setTimeout(() => {
				
				window.print();
				if (this.tipoPago === "CREDITO") {
					const confirmImpresion = confirm("¿Desea imprimir otra copia?");
					if (confirmImpresion) {
						// Aquí podrías realizar acciones adicionales si el usuario confirma
						window.print();
					}
				}
				if(this.$route.params.id != "0"){
						var link = location.origin+'/proformas';
						location.assign(link); 
						return;
					}
				window.location.reload();
			}, 1000);
		},
		async ImprimrFactura(NoFactura,TipoFactura,clave){
			var momentoActual = new Date(); 
			var hora = momentoActual.getHours(); 
			var minuto = momentoActual.getMinutes(); 
			var segundo = momentoActual.getSeconds();
			var time = hora + ":" + minuto + ":" + segundo;
			var Año = momentoActual.getFullYear(); 
			var Mes = momentoActual.getMonth() + 1; 
			var Dia = momentoActual.getDate();
			var fech =  Dia + "-"+"0" + Mes + "-"+"0" + Año;
			var Firma = "";
			var Cajon = "";
			
			if(this.ip1 == "" || this.devid1 == ""){
				this.Mensaje= "No hay impresora de red asignada";
				this.snackbar = true;
				location.reload();
			}
			if(this.CopiasImpresion == 2){
				Firma = `<feed line="2"/>
						<text>Firma: _______________________&#10;</text>
						<feed line="3"/>
						<text>Cédula: _______________________&#10;</text>`;
			}
			var products = "";
			if(this.tipoPago == "EFECTIVO"){
				Cajon = '<pulse drawer="drawer_1" time="pulse_100"/>';
			}
			for(var i = 0; i < this.detalles.length; ++i)
				{
					products += "<text>"+this.detalles[i].cantidad+"   "+this.detalles[i].descripcion.substring(0, 22)+"&#9;"+this.detalles[i].precio * this.detalles[i].cantidad+"&#10;</text>"
				}
			for(var i = 0; i < this.CopiasImpresion; ++i)
				{
					var request = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">
					<logo key1="48" key2="48"/>
					<text align="center"/>
					<text font="font_a"/>
					<text width="2" height="2"/>
					<text reverse="false" ul="false" em="false" color="color_1"/>
					<text>`+this.$store.state.usuario.localidad+`&#10;</text>
					<text width="1" height="1"/>
					<text>`+this.DatosLocalidad[0].razonSocial+`&#10;</text>
					<text>`+this.DatosLocalidad[0].dirreccion+`&#10;</text>
					<text>`+this.DatosLocalidad[0].nombre+`&#10;</text>
					<text> `+this.DatosLocalidad[0].cedulaJuridica+`&#10;</text>
					<text>`+this.DatosLocalidad[0].telefono+`&#10;</text>
					<text>`+this.DatosLocalidad[0].correo+`&#10;</text>
					<text reverse="false" ul="false" em="false" color="color_1"/>
					<text>---------------------------------------&#10;</text>
					<text align="left"/>
					<text>Vendedor: `+this.$store.state.usuario.nombre+`&#10;</text>
					<text>Fecha: `+fech+` - `+time+`&#10;</text>
					<text>Factura: `+NoFactura+`&#10;</text>
					<text>Cliente: `+this.clienteNombre+`&#10;</text>
					<text>Cédula: `+this.clienteCedula+`&#10;</text>
					<text>Teléfono: `+this.clienteTelefono+`&#10;</text>
					<text>Tipo de Documento: `+this.tipoDocumento+`&#10;</text>
					<text>`+TipoFactura+`&#10;</text>
					<text>---------------------------------------&#10;</text>
					<text>Cant   &#9;   Producto   &#9;   Precio&#10;</text>
					`+products+`
					<text align="center"/>
					<text>---------------------------------------&#10;</text>
					<text>Imp%1 &#9; Imp%2 &#9; Imp%4 &#9; Imp%13 &#10;</text>
					<text>`+this.imp1.toFixed(2)+`&#9; `+this.imp2.toFixed(2)+`&#9; `+this.imp4.toFixed(2)+`&#9; `+this.imp13.toFixed(2)+`&#10;</text>
					<text>   SubTotal &#9; Vuelto &#9; Total   &#10;</text>
					<text>`+this.subtotal+`&#9; `+this.vueltoPagar+`&#9;   `+this.Total+`&#10;</text>
					<text>---------------------------------------&#10;</text>
					<text>Detalle: `+this.detalleFactura+`&#10;</text>
					<text>`+clave+`&#10;</text>
					<text>`+this.DatosLocalidad[0].pieDocumento+`&#10;</text>
					`+Firma+`
					<feed line="3"/>
					<cut type="feed"/>
					`+Cajon+`
					</epos-print>`;
					
					//Create a SOAP envelop
					var soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
					'<s:Body>' + request + '</s:Body></s:Envelope>';
					//Create an XMLHttpRequest object
					var xhr = new XMLHttpRequest();
					//Set the end point address
					var url = 'http://'+this.ip1+'/cgi-bin/epos/service.cgi?devid='+this.devid1+'&timeout=60000';
					//Open an XMLHttpRequest object
					xhr.open('POST', url, true);
					//<Header settings>
					xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
					xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
					// Send print document
					try {
					await xhr.send(soap);
					} catch (error) {
						alert('Error imprimiendo: '+error)
					}

				}
			this.FinalizarOrden();
		},
		FinalizarOrden(){
			this.dialog = false
			this.pagorealizado = true
			this.dialogPagoCredito = false;
			this.loading = false
			this.dialogPago = false;
			this.modelCarga = false;
			this.clienteNombre = '';
			this.CondicionVenta = '';
			this.detalleFactura = '';
			this.SinpePagar = 0;
			this.pagorealizado = false;
			this.detalles = [];
			this.productosDatos = [];
			this.Limpiar();
			//setTimeout(function(){  location.reload(); }, 3000); 
		},
		Limpiar(){
			this.detalles = [];
			this.nota = '';
			this.clienteNombreExpress= "";
			this.clienteCedula = "";
			this.clienteTelefono= "";
			this.PagaBillete = false;
			this.idcliente = '';
			this.clienteNombre = "";
			this.clienteCorreo = "";
			this.nombre = "";
			this.clienteTelefono ="";
			this.direccion = "";
			this.DireccionCliente ="";
			this.DireccionCliente2 ="";
			this.DireccionCliente3 ="";
			this.detalleFactura = "";
			this.CopiasImpresion = 1;
			this.recibidoEfectivo = 0;
			this.depositoPagar = 0,
			this.SinpePagar = 0;
			this.plataforma_pago = 0;
			this.tipoPago = '';
			this.totalNC = 0;
			this.detalleFactura = '';
			this.CondicionVenta = '';
        },
		validateInputCedula() {
			const inputValue = event.target.value;
			this.cedula = inputValue.replace(/[^0-9]/g, '');
		},
		validateInputTelefono() {
			this.telefono = this.telefono.replace(/\D/g, '');
		},
		AgregarSeriales(ticketObtenido){
			if(this.VentaSeriales != [] ){
				let me = this;
				let header={"Authorization" : "Bearer " + this.$store.state.token};
				let configuracion= {headers : header};
				axios.post('api/CodigosSeriales/ConfirmarVenta',{
				'Estado':"Facturado",
				'Vendedor': me.vendedor,
				'Localidad':me.$store.state.usuario.localidad,
				'Seriales': me.VentaSeriales,
				'NoFactura':ticketObtenido,
						
				},configuracion).then(function (response) {
				me.snackbar = true;
				me.Mensaje = 'Seriales agregados con éxito';  
				})
				.catch(function (error) {
				alert(error);
				me.snackbar = true;
				me.Mensaje = 'Error' +error;      
				})
			}  
			return;
		},
		AgregarVenta(){
			if(this.NoFactura == '' || this.vendedor == ''){
				this.snackbar = true;
				this.Mensaje = 'No puede dejar campos vacios'
				return;
			}
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
				let me=this;
				axios.put('api/CodigosSeriales/CrearSerial',{
					'Estado':"Despachado",
					'Vendedor': me.Vendedor,
					'Localidad':me.$store.state.usuario.localidad,
					'CodigoSerial': me.codigoSerial,
					'NoFactura':me.NoFactura,
				},configuracion).then(function(response){
					me.snackbar = true;
					me.Mensaje = 'Proceso realizado con éxito';    
					me.select();                 
				}).catch(function(error){
					alert(error);
					me.snackbar = true;
					me.Mensaje = 'Error' +error;   
				});
		},
		async AgregarTemp(Id,NoFactura,nombre,TipoCompra){
			this.loading = true;
			if(confirm("Seguro que quiere agregar productos a esta Factura? "+ NoFactura)){
				var self = this;
				var momentoActual = new Date(); 
				var hora = momentoActual.getHours(); 
				var minuto = momentoActual.getMinutes(); 
				var segundo = momentoActual.getSeconds();
				var time = hora + ":" + minuto + ":" + segundo;
				let header={"Authorization" : "Bearer " + this.$store.state.token};
				let configuracion= {headers : header};
				await axios.post('api/OrdenExpress/Agregar',{
					'NoFactura':NoFactura,
					'Localidad': this.$store.state.usuario.localidad,
					'Cajero': this.$store.state.usuario.nombre,
					'Fecha': "0/0/0/",
					'ID': Id,
					'detalles': this.detalles,
					'Nombre':nombre,
					'TipoCompra':TipoCompra,
					'Nota':this.nota,
					'Mesa':this.MesaSeleccionada,
					'Hora':time
					
				},configuracion).then(function (response) {
					self.Mensaje = "Productos cargados";
					self.snackbar = true;
					self.loading = false; 
					self.detalles = [];
					self.BuscarCuentas()
				})
				.catch(function (error) {
					alert(`Error Agregando`);  
				})
			}
		},
		limpiarPago()
		{
			this.pago = '';
			this.PagaBillete = false;
			this.efectivoPagar = 0;
			this.tarjetaPagar = 0;
			this.depositoPagar = 0;
			this.SinpePagar = 0;
			this.dialogDeposito = false;
			this.dialogEfectivo = false;
			this.dialogTarjeta = false;
			this.dialogCheque = false;
			this.dialogSinpe = false;
			this.dialogpuntos = false;
			this.vueltoPagar = this.total * -1;
			this.saldo = this.total;
		},
		agregarProducto() {
			this.cantidad = parseInt(this.cantidadDialog2);
			if (this.cantidad > 0)
			{
			this.dataArticulo.push(
				{
				codigoProducto:this.codigoArticulo2,
				descripcion:this.descripcion2,
				cantidad:this.cantidadDialog2,
				precioVenta:this.precio2,
				descuento:this.descuento2,
				iva:this.impuestoDialog2,
				subtotal:this.precio2 * this.cantidadDialog2,
				valorImpuesto:this.valorImpuesto2,
				gravado:this.gravado2
				}
			)
			this.agregarDetalle2(this.dataArticulo);
			this.dialogAgregarProducto = false;
			}
			else
			{
			alert("La cantidad debe tener un valor mayor o igual a uno");
			}
		},
		editItem() {
			this.cantidad = parseInt(this.cantidadDialog);
			if (this.cantidad > 0)
			{
				this.editedIndex = this.indexProducto;
				const index = this.indexProducto
				this.detalles.splice(index, 1);
				this.detalles.push(
					{
					idarticulo:this.codigoArticulo,
					descripcion:this.descripcion,
					cantidad:this.cantidad,
					precio:this.precio,
					descuento:this.descuento,
					impuesto:this.impuestoDialog,
					Ivi: this.Ivi,
					subtotal:((this.precio * this.cantidad) - this.descuento),
					valorImpuesto:this.valorImpuesto,
					gravado:this.gravado
					}
				);
				this.dialogProducto = false;
			}
			else
			{
				alert("La cantidad debe tener un valor mayor o igual a uno");
			}
		},  
		deleteItem () {
		if(confirm('Esta seguro de eliminar este producto?')){
			const index = this.indexProducto
			this.detalles.splice(index, 1);
			this.dialogProducto = false;
		}
		},
		eliminarLinea() {
		if(confirm('Esta seguro de eliminar los productos?')){
			this.detalles=[];
			this.orden = null;
		}
		},
		async listarBancos(){
			let me=this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.get('api/EstadoCuentas/ResumenCuentas/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.data=response.data;
				me.loading = false;
				me.data.map(function(x){
					me.bancos.push({text: x.alias+ '-'+ x.etiqueta +' ('+ x.moneda + ')',value:x.etiqueta});

				});
				// me.modelCarga = false;
			}).catch(function(error){
				alert(error);
			});
		},
		async Deposito(id,doc){
			let me=this;
			this.loading = true;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.post('api/EstadoCuentas/Deposito',{
				'TipoRegistro':doc,
				'Ingreso':me.total,
				'Egreso': 0,
				'Documento':id,
				'detalle': me.detalleFactura,
				'Usuario':me.$store.state.usuario.nombre,
				'Localidad':me.$store.state.usuario.localidad, 
				'Persona': me.clienteNombre,
				'Moneda':me.monedaPago,
				'TipoPago':me.tipoPago,
				'CuentaContable':me.banco,
			},configuracion).then(function(response){
					return;
				}).catch(err => {
				//console.log(err.response);
				alert("Error ingresando dinero a su cuenta, por favor ingrese el deposito manualmente y reporte a su proveedor "+error)
				return;
			})
		},
		SendBill(ticket,tipoDoc,clave) {
			let fechaActual = new Date();
			// Accede a los componentes de la fecha actual
			let dia = fechaActual.getDate(); // día del mes (1-31)
			let mes = fechaActual.getMonth() + 1; // mes (0-11, se suma 1 para mostrarlo como 1-12)
			let anio = fechaActual.getFullYear(); // año (4 dígitos)
			let hora = fechaActual.getHours(); // hora (0-23)
			let minuto = fechaActual.getMinutes(); // minutos (0-59)
			let segundo = fechaActual.getSeconds(); // segundos (0-59)
			let fecha = dia+'/'+mes+'/'+anio+ ' '+hora+':'+minuto+':'+segundo;
			var products = "";
			var link = location.hostname+'/perfilcliente/'+this.$store.state.usuario.localidad+'/'+this.clienteCedula;
			var cant = 0.0;
			for(var i = 0; i < this.detalles.length; ++i)
				{
					cant = this.detalles[i].cantidad
					cant = parseFloat(cant) * parseFloat(this.detalles[i].precio);
					products += `<tr>
						<td class="col-2 text-1">`+this.detalles[i].valorImpuesto+`* `+this.detalles[i].idarticulo+`</td>
						<td class="col-7 text-1">`+this.detalles[i].descripcion+` *`+ + this.detalles[i].detalle+`</td>
						<td class="col-1 text-center">`+this.detalles[i].precio+`</td>
						<td class="col-1 text-center">`+this.detalles[i].cantidad+`</td>
						<td class="col-1 text-end">`+this.detalles[i].descuento+`%</td>
						<td class="col-1 text-end">`+cant+`</td>
						</tr>`
				}
			let html = `<html lang="en">
					<head>
					<meta charset="utf-8" />
					<meta http-equiv="X-UA-Compatible" content="IE=edge">
					<meta name="viewport" content="width=device-width, initial-scale=1">
					<link href="images/favicon.png" rel="icon" />
					<title>General Invoice - Koice</title>
					<meta name="author" content="harnishdesign.net">

					<!-- Web Fonts
					======================= -->
					<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900' type='text/css'>

					<!-- Stylesheet
					======================= -->
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/bootstrap/css/bootstrap.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/font-awesome/css/all.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/css/stylesheet.css"/>
					</head>
					<body>
					<!-- Container -->
					<div class="container-fluid invoice-container">
					
					<!-- Main Content -->
					<main>
					<div class="table-responsive">
						<table >
							<thead >
								<tr>
									<td class="col-1 text-start"><img id="logo" src="`+this.DatosLocalidad[0].imagen+ `" width="80" height="80" title="NoahLogo" alt="Noah" /></td>
									<td class="col-4 text-center text-1"> `+this.$store.state.usuario.localidad+ `<br />
									`+this.DatosLocalidad[0].razonSocial+ `<br />
									`+this.DatosLocalidad[0].dirreccion+ `<br />
									`+this.DatosLocalidad[0].cedulaJuridica+ `<br />
									`+this.DatosLocalidad[0].telefono+ `<br />
									`+this.DatosLocalidad[0].correo+ `<br /> </td>
									<td class="col-1 text-end"><h4 class="text-7 mb-0">RECIBO</h4></td>
								</tr>
							</thead>
						</table>
					</div>
					<hr>
					<table >
						<thead >
							<tr>
								<td class="col-2 text-start text-1"><strong> Cliente:</strong> `+this.clienteNombre+ `<br /></td>
								<td class="col-2 text-end"><strong> Fecha:</strong> `+fecha+ `<br /></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="col-2 text-start text-1"><address>
									
									`+this.clienteCedula+ `<br />
									`+this.clienteTelefono+ `<br />
									`+this.clienteCorreo+ ` <br />
									
									</address>
								</td>
								<td class="col-2 text-end text-1"><address>
									<strong> No Factura:</strong> `+ticket+ `<br />
									Vendedor :`+this.vendedor+ `<br />
									Cajero: `+this.$store.state.usuario.nombre+ `
									</address>
								</td>
							</tr>
						</tbody>
					</table>
						
					<div class="card">
						<div class="card-body p-0">
						<div class="table-responsive">
							<table class="table mb-0">
							<thead class="card-header">
							<tr>
								<td class="col-2"><strong>Código</strong></td>
								<td class="col-8"><strong>Descripción</strong></td>
								<td class="col-1 text-center"><strong>Precio</strong></td>
								<td class="col-2 text-center"><strong>Cant</strong></td>
								<td class="col-2 text-end"><strong>Desc</strong></td>
								<td class="col-2 text-end"><strong>Cargo</strong></td>
							</tr>
							</thead>
							<tbody>
								`+products+`
							</tbody>
							<tfoot class="card-footer">
								<tr>
								<td colspan="2" class="text-end"><strong>Sub Total:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalParcial+ `</td>
								<td colspan="2" class="text-end"><strong>Descuento:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalDescuento+ `</td>
								</tr>
								<tr>
								<td colspan="2" class="text-end"><strong>IVA:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalImpuesto+ `</td>
								<td colspan="2" class="text-end border-bottom-0"><strong>Total:</strong></td>
								<td class="text-end border-bottom-0">`+this.Moneda()+this.total+ `</td>
								</tr>
							</tfoot>
							</table>
						</div>
						</div>
					</div>
					</main>
					<!-- Footer -->
					<footer class="text-center">
					<div>`+clave+ `.</div>
					<div><strong>Nota :</strong> `+this.detalleFactura+ `.</div>
					`+this.DatosLocalidad[0].pieDocumento+ `
					<div class="btn-group btn-group-sm d-print-none"> <a href="javascript:window.print()" class="btn btn-light border text-black-50 shadow-none"><i class="fa fa-print"></i> Print</a> <a href="`+link+ `" class="btn btn-light border text-black-50 shadow-none"><i class="fa fa-download"></i> Ver Todas las Facturas</a> </div>
					</footer>
					</div>
					</body>
				</html>
			`;
			this.EmailFacturaCorreo(html)
		},
		
		imprimirA4(ticket,tipoDoc,clave) {
			let fechaActual = new Date();
			// Accede a los componentes de la fecha actual
			let dia = fechaActual.getDate(); // día del mes (1-31)
			let mes = fechaActual.getMonth() + 1; // mes (0-11, se suma 1 para mostrarlo como 1-12)
			let anio = fechaActual.getFullYear(); // año (4 dígitos)
			let hora = fechaActual.getHours(); // hora (0-23)
			let minuto = fechaActual.getMinutes(); // minutos (0-59)
			let segundo = fechaActual.getSeconds(); // segundos (0-59)
			let fecha = dia+'/'+mes+'/'+anio+ ' '+hora+':'+minuto+':'+segundo;
			var products = "";
			var cant = 0.0;
			for(var i = 0; i < this.detalles.length; ++i)
				{
					
					cant = this.detalles[i].cantidad
					cant = parseFloat(cant) * parseFloat(this.detalles[i].precio);
					products += `<tr>
								<td class="col-2 text-1">`+this.detalles[i].valorImpuesto+`* `+this.detalles[i].idarticulo+`</td>
								<td class="col-7 text-1">`+this.detalles[i].descripcion+` *`+ + this.detalles[i].detalle+`</td>
								<td class="col-1 text-center">`+this.detalles[i].precio+`</td>
								<td class="col-1 text-center">`+this.detalles[i].cantidad+`</td>
								<td class="col-1 text-end">`+this.detalles[i].descuento+`%</td>
								<td class="col-1 text-end">`+cant+`</td>
								</tr>`
					
				}
		let html = `<html lang="en">
					<head>
					<meta charset="utf-8" />
					<meta http-equiv="X-UA-Compatible" content="IE=edge">
					<meta name="viewport" content="width=device-width, initial-scale=1">
					<link href="images/favicon.png" rel="icon" />
					<title>General Invoice - Koice</title>
					<meta name="author" content="harnishdesign.net">

					<!-- Web Fonts
					======================= -->
					<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900' type='text/css'>

					<!-- Stylesheet
					======================= -->
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/bootstrap/css/bootstrap.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/font-awesome/css/all.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/css/stylesheet.css"/>
					</head>
					<body>
					<!-- Container -->
					<div class="container-fluid invoice-container">
					
					<!-- Main Content -->
					<main>
					<div class="table-responsive">
						<table >
							<thead >
								<tr>
									<td class="col-1 text-start"><img id="logo" src="`+this.DatosLocalidad[0].imagen+ `" width="120" height="120" title="NoahLogo" alt="Noah" /></td>
									<td class="col-4 text-center"> `+this.$store.state.usuario.localidad+ `<br />
									`+this.DatosLocalidad[0].razonSocial+ `<br />
									`+this.DatosLocalidad[0].dirreccion+ `<br />
									`+this.DatosLocalidad[0].cedulaJuridica+ `<br />
									`+this.DatosLocalidad[0].telefono+ `<br />
									`+this.DatosLocalidad[0].correo+ `<br /> </td>
									<td class="col-1 text-end"><h4 class="text-7 mb-0">`+tipoDoc+` `+ticket+ `</h4></td>
								</tr>
							</thead>
						</table>
					</div>
					<hr>
					<table >
						<thead >
							<tr>
								<td class="col-2 text-start text-1"><strong> Cliente:</strong> `+this.clienteNombre+ `<br /></td>
								<td class="col-2 text-end"><strong> Fecha:</strong> `+fecha+ `<br /></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="col-2 text-start text-1"><address>
									
									`+this.clienteCedula+ `<br />
									`+this.clienteTelefono+ `<br />
									`+this.clienteCorreo+ ` <br />
									
									</address>
								</td>
								<td class="col-2 text-end text-1"><address>
									<strong> No Factura:</strong> `+ticket+ `<br />
									Vendedor :`+this.vendedor+ `<br />
									Cajero: `+this.$store.state.usuario.nombre+ `
									</address>
								</td>
							</tr>
						</tbody>
					</table>
						
					<div class="card">
						<div class="card-body p-0">
						<div class="table-responsive">
							<table class="table mb-0">
							<thead class="card-header">
							<tr>
								<td class="col-2"><strong>Código</strong></td>
								<td class="col-8"><strong>Descripción</strong></td>
								<td class="col-1 text-center"><strong>Precio</strong></td>
								<td class="col-2 text-center"><strong>Cant</strong></td>
								<td class="col-2 text-end"><strong>Desc</strong></td>
								<td class="col-2 text-end"><strong>Cargo</strong></td>
							</tr>
							</thead>
							<tbody>
								`+products+`
							</tbody>
							<tfoot class="card-footer">
								<tr>
								<td colspan="2" class="text-end"><strong>Sub Total:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalParcial+ `</td>
								<td colspan="2" class="text-end"><strong>Descuento:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalDescuento+ `</td>
								</tr>
								<tr>
								<td colspan="2" class="text-end"><strong>IVA:</strong></td>
								<td class="text-end">`+this.Moneda()+this.totalImpuesto+ `</td>
								<td colspan="2" class="text-end border-bottom-0"><strong>Total:</strong></td>
								<td class="text-end border-bottom-0">`+this.Moneda()+this.total+ `</td>
								</tr>
							</tfoot>
							</table>
						</div>
						</div>
					</div>
					</main>
					<!-- Footer -->
					<footer class="text-center">
					<div>`+clave+ `.</div>
					<div><strong>Nota :</strong> `+this.detalleFactura+ `.</div>
					`+this.DatosLocalidad[0].pieDocumento+ `
					</footer>
					</div>
					</body>
				</html>
			`;
		this.EmailFacturaCorreo(html)
		const nuevaVentana = window.open('' , '_blank');
		nuevaVentana.document.write(html);
		nuevaVentana.document.close();
		setTimeout(() => {
			nuevaVentana.print();
			nuevaVentana.close();
			location.reload();
		}, 2000);
		//this.$forceUpdate();
		},
		PrintDetails(){
		/*var divContents = document.getElementById("invoice").innerHTML;
		var a = window.open('', '', 'height=1200, width=850');
		a.document.write('<html>');
		a.document.write(divContents);
		a.document.write('</body></html>');
		a.document.close();
		a.print();
		a.window.close();*/

			var win = window.open('', '', 'height=1200, width=850');
			win.document.write(`
			<html lang="en">
					<head>
					<meta charset="utf-8" />
					<meta http-equiv="X-UA-Compatible" content="IE=edge">
					<meta name="viewport" content="width=device-width, initial-scale=1">
					<link href="images/favicon.png" rel="icon" />
					<title>General Invoice - Koice</title>
					<meta name="author" content="harnishdesign.net">

					<!-- Web Fonts
					======================= -->
					<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900' type='text/css'>

					<!-- Stylesheet
					======================= -->
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/bootstrap/css/bootstrap.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/vendor/font-awesome/css/all.min.css"/>
					<link rel="stylesheet" type="text/css" href="https://www.noah.cr/FacturaCSS/css/stylesheet.css"/>
					</head>
					<body>
					<!-- Container -->
					<div class="container-fluid invoice-container">
					<!-- Header -->
					<header>
					<div class="row align-items-center">
						<div class="col-sm-7 text-center text-sm-start mb-3 mb-sm-0">
						<img id="logo" src="https://www.noah.cr/FacturaCSS/images/logo.png" title="Koice" alt="Koice" />
						</div>
						<div class="col-sm-5 text-center text-sm-end">
						<h4 class="text-7 mb-0">Invoice</h4>
						</div>
					</div>
					<hr>
					</header>
					
					<!-- Main Content -->
					<main>
					<div class="row">
						<div class="col-sm-6"><strong>Date:</strong> 05/12/2020</div>
						<div class="col-sm-6 text-sm-end"> <strong>Invoice No:</strong> 16835</div>
						
					</div>
					<hr>
					<div class="row">
						<div class="col-sm-6 text-sm-end order-sm-1"> <strong>Pay To:</strong>
						<address>
						Koice Inc<br />
						2705 N. Enterprise St<br />
						Orange, CA 92865<br />
						contact@koiceinc.com
						</address>
						</div>
						<div class="col-sm-6 order-sm-0"> <strong>Invoiced To:</strong>
						<address>
						Smith Rhodes<br />
						15 Hodges Mews, High Wycombe<br />
						HP12 3JL<br />
						United Kingdom
						</address>
						</div>
					</div>
						
					<div class="card">
						<div class="card-body p-0">
						<div class="table-responsive">
							<table class="table mb-0">
							<thead class="card-header">
							<tr>
								<td class="col-3"><strong>Service</strong></td>
								<td class="col-4"><strong>Description</strong></td>
								<td class="col-2 text-center"><strong>Rate</strong></td>
								<td class="col-1 text-center"><strong>QTY</strong></td>
								<td class="col-2 text-end"><strong>Amount</strong></td>
							</tr>
							</thead>
							<tbody>
								<tr>
								<td class="col-3">Design</td>
								<td class="col-4 text-1">Creating a website design</td>
								<td class="col-2 text-center">$50.00</td>
								<td class="col-1 text-center">10</td>
								<td class="col-2 text-end">$500.00</td>
								</tr>
								<tr>
								<td>Development</td>
								<td class="text-1">Website Development</td>
								<td class="text-center">$120.00</td>
								<td class="text-center">10</td>
								<td class="text-end">$1200.00</td>
								</tr>
								<tr>
								<td>SEO</td>
								<td class="text-1">Optimize the site for search engines (SEO)</td>
								<td class="text-center">$450.00</td>
								<td class="text-center">1</td>
								<td class="text-end">$450.00</td>
								</tr>
							</tbody>
							<tfoot class="card-footer">
								<tr>
								<td colspan="4" class="text-end"><strong>Sub Total:</strong></td>
								<td class="text-end">$2150.00</td>
								</tr>
								<tr>
								<td colspan="4" class="text-end"><strong>Tax:</strong></td>
								<td class="text-end">$215.00</td>
								</tr>
								<tr>
								<td colspan="4" class="text-end border-bottom-0"><strong>Total:</strong></td>
								<td class="text-end border-bottom-0">$2365.00</td>
								</tr>
							</tfoot>
							</table>
						</div>
						</div>
					</div>
					</main>
					<!-- Footer -->
					<footer class="text-center mt-4">
					<p class="text-1"><strong>NOTE :</strong> This is computer generated receipt and does not require physical signature.</p>
					<div class="btn-group btn-group-sm d-print-none"> <a href="javascript:window.print()" class="btn btn-light border text-black-50 shadow-none"><i class="fa fa-print"></i> Print</a> <a href="" class="btn btn-light border text-black-50 shadow-none"><i class="fa fa-download"></i> Download</a> </div>
					</footer>
					</div>
					</body>
				</html>
			`);
			win.print();
			win.window.close();
		},
		async EmailFacturaCorreo(html){
			let fechaActual = new Date();
			// Accede a los componentes de la fecha actual
			let dia = fechaActual.getDate(); // día del mes (1-31)
			let mes = fechaActual.getMonth() + 1; // mes (0-11, se suma 1 para mostrarlo como 1-12)
			let anio = fechaActual.getFullYear(); // año (4 dígitos)
			let hora = fechaActual.getHours(); // hora (0-23)
			let minuto = fechaActual.getMinutes(); // minutos (0-59)
			let segundo = fechaActual.getSeconds(); // segundos (0-59)
			let fecha = dia+'/'+mes+'/'+anio+ ' '+hora+':'+minuto+':'+segundo;
			var products = "";
			var cant = 0.0;
			for(var i = 0; i < this.detalles.length; ++i)
				{
					
					cant = this.detalles[i].cantidad
					cant = parseFloat(cant) * parseFloat(this.detalles[i].precio);
					products += `<tr>
								<td class="col-2 text-1">`+this.detalles[i].valorImpuesto+`* `+this.detalles[i].idarticulo+`</td>
								<td class="col-7 text-1">`+this.detalles[i].descripcion+` *`+ + this.detalles[i].detalle+`</td>
								<td class="col-1 text-center">`+this.detalles[i].precio+`</td>
								<td class="col-1 text-center">`+this.detalles[i].cantidad+`</td>
								<td class="col-1 text-end">`+this.detalles[i].descuento+`%</td>
								<td class="col-1 text-end">`+cant+`</td>
								</tr>`
					
				}
			this.Mensaje = 'Enviando Correo.. por favor espere'
			this.snackbar = true;
			let self =  this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.post('api/Proformas/EnviarCorreo',{
				'Cajero':this.$store.state.usuario.nombre,
				'Localidad': this.$store.state.usuario.localidad,
				'Correo': this.clienteCorreo,
				'Mail': html,
			},configuracion).then(function (response) {
				self.Mensaje = "Correo enviado.";
				return;
			}).catch(function(error){
				self.snackbar = true;
				self.Mensaje = 'Error Enviand correo, por favor envie manualmente...'+error;
				return;
			}); 
		},
		guardar() {
			if (this.validarProducto() != 0){
				return;
			}
			let header={"Authorization" : "Bearer "};
			this.dialogNuevoProducto = false; 
			this.verArticulos = false; 
			let configuracion= {headers : header};
			//Código para guardar
			let me=this;
			axios.post('api/Productos/Crear',{
				'codigoProducto':me.codigoProducto,
				'descripcion':me.descripcion,
				'barcode':me.codigoProducto,
				'precioVenta':me.precioVenta,
				'precioDetalle':me.precioVenta,
				'precioMall':me.precioVenta,
				'precioMayor':me.precioVenta,
				'precioCentral':me.precioVenta,
				'precioCompra': me.precioCompra,
				'compuesto': 0,
				'comision': me.comision,
				'maxDescuento': me.maxDescuento,
				'proveedor': "Movil",
				'localizacion': "NA",
				'minimo':1,
				'EstadoInventario': me.Ivi,
				'maximos':5,
				'Exe_Grad':me.SoN,
				'valorImpuesto':me.categoria,
				'localidad': me.$store.state.usuario.localidad,
				'tipoProducto': "Movil",
				'SubFamilia': "NA",
				'CantPersonas': 1,
				'Categoria':"PRODUCTO", //Define si es un servicio o un Producto
				'Origen':"00:00", // Este campo es la hora inicial del servicio
				'InnerPack': "12:00", // Este campo es la Hora final del servicio
				'CantHoras': 1, // Este campo define la cantidad de horas disponibles del servicio
				'SincServer:':0,
				'CodigoRaiz':me.codigoCabys,
				'Color':"",
				'CodigoCaja':"",
				'Medidas':"",
				
			},configuracion).then(function(response){
					
					me.loading= false;
					me.codigo2 = me.codigoProducto;
					me.buscarCodigo();
					me.limpiarProducto();

			}).catch(function(error){
				this.Mensaje = "Error guardando, verfique que el código de producto no exista"+error;
				this.snackbar = true;
			});
		},
		crearCliente()
		{
			
			if (this.validarCliente() === 1)
			{
				var self = this;
				this.modelCarga = true;
				let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				axios.post('api/Empleados/Crear',{
					'Nombre':this.nombre,
					'TipoCedula':this.tipoDocumento,
					'Cedula': this.cedula.replace(/-/g,"").replace(/ /g, ""),
					'Localidad':this.$store.state.usuario.localidad,
					'Telefono':this.telefono.replace(/-/g,"").replace(/ /g, ""),
					'Periodo': this.DiasCreditoCliente,
					'Correo':this.correo,
					'Correo2':this.clienteCorreo2,
					'Cantidad':this.limiteCredito,
					'Genero':this.genero,
					'Edad':"0",
					'Facebook':this.direccion,
					'Vendedor': this.vendedor,
					'ListaPrecio':this.listaDePrecio,
					'NombreFantasia':this.nombreFantasia,
					'Celular':this.celular,
				},configuracion).then(function (response) {
					self.Mensaje = "Cliente ha sido insertado correctamente, por favor seleccione el cliente";
					self.snackbar = true;
					self.limpiarCliente();
					self.select();
					self.modelCarga = false;
					self.dialogCliente = false;
				}).catch(function(error){
					alert('El email o cédula ya existe'+error);
				}); 
			}
		},
		limpiarProducto(){
			this.id="";
			this.idcategoria="";
			this.codigo="";
			this.codigoProducto = '';
			this.descricion = '';
			this.nombre="";
			this.precio_venta="";
			this.descripcion="";
			let barcodepreview = Date.now();
			let idsa = barcodepreview.toString();
			let NoProforma = idsa.substring(5, 12);
			this.codigoProducto = NoProforma;
		},
		limpiarCliente(){
			this.nombre = "";
			this.tipoDocumento = "";
			this.cedula = "";
			this.idLocalidadCliente = "";
			this.telefono = "";
			this.correo = "";
		},
		validarProducto(){
			this.valida=0;
			if (this.descripcion.length<3 || this.descripcion.length>50){
				alert("El nombre debe tener más de 3 caracteres y menos de 50 caracteres.");
				this.valida=1;
			}
			if (this.categoria > 0){
				this.SoN = 'S'
			}
			
			if (!this.precioVenta || this.precioVenta==0){
				this.Mensaje = "Ingrese el precio de venta del artículo.";
				this.snackbar = true;
				return;
				this.valida=1;
			}
			return this.valida;
		},
		validarCliente() {
			this.validaCliente=1;

			if(!this.nombre){
				alert("Debe ingresar el nombre del cliente.");
				this.validaCliente=0;
			}
			if(!this.tipoDocumento){
				alert("Debe seleccionar un tipo de documento.");
				this.validaCliente=0;
			}
			if(!this.cedula){
				alert("Debe ingresar un número de documento.");
				this.validaCliente=0;
			}
			if(!this.telefono){
				alert("Debe ingresar un teléfono o un celular .");
				this.validaCliente=0;
			}
			if(!this.correo){
				alert("Debe ingresar un email.");
				this.validaCliente=0;
			}
			return this.validaCliente;
		},
		validarPago(){
			this.valida=1;

			if (!this.idcliente && this.tipoFactura == 1){
				this.Mensaje = "Seleccione un cliente para realizar Factura electrónica";
				this.snackbar = true;
				this.valida=0;
			}
			if (this.tipoFactura == 0){
				this.Mensaje = "Seleccione un tipo de documento para continuar";
				this.snackbar = true;
				this.valida=0;
			}
			if(this.vendedor === ""){
				this.Mensaje = "Debe seleccionar un vendedor para continuar";
				this.snackbar = true;
				this.valida=0;
			}
			if (this.detalles.length == 0){
				this.Mensaje = "Debe ingresar productos que facturar";
				this.snackbar = true;
				this.valida=0;
			}
			return this.valida;
		},
		async buscarCodigo(){
			if(this.Stock0 == true){
				this.buscarProductoDirecto();
				this.CalcularPrecio();
				this.codigo2 = '';
			} else
			if(this.Stock0 == false){
							
				let me=this;
				me.errorArticulo=null;
				if (this.codigo2 != "")
				{
					let header={"Authorization" : "Bearer "};
					let configuracion= {headers : header};
					await axios.get('api/Productos/BuscarCodigoVenta/'+this.codigo2+'/'+this.$store.state.usuario.localidad,configuracion)
					.then(function(response){
						me.agregarDetalleCodigo(response.data);
						me.CalcularPrecio();
						me.codigo2 = '';
					}).catch(function(error){
			
						me.Mensaje = "Producto no encontrado, revise el código digitado"+error;
						me.snackbar = true;
					});
				}
				this.codigo = "";
			}
		},
		buscarProducto(){
			this.buscarProductoDirecto();
			this.CalcularPrecio();
			this.codigo2 = '';
		},
		buscarProductoDirecto(){
			let me=this;
			if (this.codigo.value === undefined)
			{
				this.codigo = this.codigo;
			}
			else
			{
				this.codigo = this.codigo.value;
			}

			if (this.codigo != "")
			{
				let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				axios.get('api/Productos/BuscarCodigoVenta/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
				.then(function(response){
					me.agregarDetalleDirecto(response.data);
					me.CalcularPrecio();
				}).catch(function(error){
					//alert(error);
				});
			}
		},
		BarCodeScan(){
			let key = ""
			window.addEventListener("keydown", (event) => {
				if(event.key == "Enter"){
					alert("codigo Escaneado:" +key)
					this.BuscarCodeBar(key)
					key = "";
				}
				key = key + event.key;
				});
			
		},
		BuscarCodeBar(){
			let me=this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Productos/BuscarCodigoBarras/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
			.then(function(response){
				me.agregarDetalleDirecto(response.data);
				me.CalcularPrecio();
			}).catch(function(error){
				alert(error);
			});
		},
		agregarDetalleDirecto(data = []){
			var ImpuestoIncluido= "I.V.N.I."
			if(this.ModoCant == true){
				if (this.encuentra(data['codigoProducto'])){
					return;
				}
			}
			
			if (data['codigoProducto'] != '' && data['codigoProducto'] != undefined)
			{
				this.codigo = data['codigoProducto'];
			}
				if (this.codigo != '')
				{ 
					if(data['estadoInventario'] == true){
					ImpuestoIncluido= "I.V.I"
					}
					this.detalles.push(
						{
						id: this.detalles.length + 5, 
						idarticulo:data['codigoProducto'],
						descripcion:data['descripcion'],
						cantidad:1,
						precio:data['precioVenta'],
						precioVenta:data['precioVenta'],
						precioDetalle:data['precioDetalle'],
						precioCentral:data['precioCentral'],
						precioMayor:data['precioMayor'],
						precioCompra:data['precioCompra'],
						Ivi:data['estadoInventario'],
						LlevaIvi: ImpuestoIncluido,
						descuento:0,
						subtotal:data['precioVenta'],
						valorImpuesto:data['valorImpuesto'],
						gravado:data['exe_Grad'],
						cabys:data['codigoRaiz'],
						inv:10,
						minimo:0,
						detalle: "",
						MaxDescuento:data['maxDescuento'],
						activador:data['activador'],
						cantDescuento:data['descuento'],
						cantMinima:data['cantidad'],
						dimensiones:data['dimensiones'],
						impEspecial:data['tipoAlimento'],
						}
						);
						this.codigo = '';
						this.$nextTick(() => {
							this.$refs.inputCantidadIngreso.focus();
						});
					if(this.Stock0 == true){
						this.BuscarInventario(data['codigoProducto']);
					}
				}
				else
				{
					this.Mensaje = "Debe digitar un código de producto o servicio.";
					this.snackbar = true;
			}
		},
		async BuscarInventario(codigo){
			let me=this;
			let stock = 0;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/ProductosWebs/ConsultaStock/'+codigo+'/'+this.localidad,configuracion).then(function(response){
				stock=response.data;
				me.AsignarInventario(codigo,stock.stock)
			}).catch(function(error){
				//alert("Producto no encontrado"+error);
			});
		},
		AsignarInventario(id,stock){
			for(var i=0;i<this.detalles.length;i++){
				if (this.detalles[i].idarticulo==id){
					this.detalles[i].inv = stock;
				}
			}
			return 
		},
		encuentra(id){
			var sw=0;
			for(var i=0;i<this.detalles.length;i++){
				if (this.detalles[i].idarticulo==id){
					this.detalles[i].cantidad = this.detalles[i].cantidad + 1;
					this.codigo = "";
					sw=1;
				}
			}
			return sw;
		},
		agregarDetalle(data = []){
			this.errorArticulo=null;
			var ImpuestoIncluido= "I.V.N.I."
			if (data['codigoProducto'] != '' && data['codigoProducto'] != undefined)
			{
				this.codigo = data['codigoProducto'];
			}
			if (this.encuentra(data['idarticulo'])){
				alert("El producto ya ha sido agregado.");
			}
			else
			{
			if (this.codigo != '')
			{ 
				if(data['estadoInventario'] == true){
				ImpuestoIncluido= "I.V.I"
				}
				this.detalles.push(
					{
					id: this.detalles.length + 5, 
					idarticulo:data['codigoProducto'],
					descripcion:data['descripcion'],
					cantidad:1.0,
					precio:data['precioVenta'],
					precioVenta:data['precioVenta'],
					precioDetalle:data['precioDetalle'],
					precioCentral:data['precioCentral'],
					precioMayor:data['precioMayor'],
					precioCompra:data['precioCompra'],
					Ivi:data['estadoInventario'],
					LlevaIvi: ImpuestoIncluido,
					descuento:0,
					subtotal:data['precioVenta'],
					valorImpuesto:data['valorImpuesto'],
					gravado:data['exe_Grad'],
					cabys:data['codigoRaiz'],
					inv:data['cantidadInvActual'],
					minimo:data['minimo'],
					MaxDescuento:data['maxDescuento'],
					detalle: "",
					activador:data['activador'],
					cantDescuento:data['descuento'],
					cantMinima:data['cantidad'],
					}
					);
	
				this.codigo = '';
				
				this.$nextTick(() => {
							this.$refs.inputCantidadIngreso.focus();
						});
			}
			else
			{
				this.Mensaje = "Debe digitar un código de producto o servicio.";
				this.snackbar = true;
			}
			}
		},
		agregarDetalleCodigo(data = []){
			this.errorArticulo=null;
			var ImpuestoIncluido= "I.V.N.I."
			
			if (data['codigoProducto'] != '' && data['codigoProducto'] != undefined)
			{
				this.codigo = data['codigoProducto'];
			}
			else
			{
				if (this.codigo != '')
				{ 
				if(data['estadoInventario'] == true){
					ImpuestoIncluido= "I.V.I"
				}
					this.detalles.push(
					{
					id:this.detalles.length + 2,
					Codigop:data['codigoProducto'],
					descripcion:data['descripcion'],
					cantidad:1,
					PrecioFinal:data['precioVenta'],
					precio:data['precioVenta'],
					precioVenta:data['precioVenta'],
					precioDetalle:data['precioDetalle'],
					precioCentral:data['precioCentral'],
					precioMayor:data['precioMayor'],
					precioCompra:data['precioCompra'],
					Ivi:data['estadoInventario'],
					descuento:0,
					Temp: 0,
					detalle:"",
					cabys:data['codigoRaiz'],
					impuesto:data['iva'],
					valorImpuesto:data['valorImpuesto'],
					gravado:data['exe_Grad'],
					localizacion:data['localizacion'],
					cocina: data['cocina'],
					check: 0,
					MaxDescuento:data['maxDescuento'],
					activador:data['activador'],
					cantDescuento:data['descuento'],
					cantMinima:data['cantidad'],
					impEspecial:data['tipoAlimento'],
					}
					);
					this.codigo = '';
				}
				else{
				this.Mensaje = "Debe digitar un código de producto o servicio.";
				this.snackbar = true;
				}
			}
		},
		agregarProforma(){
			const duplicar = parseInt(this.$route.query.duplicar);
			if (!isNaN(duplicar)) {
				this.DuplicadoFactura()
			}

			if(this.$route.params.id != "0"){
				let DatosProforma = [];
				let me=this;
				let header={"Authorization" : "Bearer " + this.$store.state.token};
				let configuracion= {headers : header};
				axios.get('api/Proformas/ListarDatosFactura/'+this.$route.params.id+'/'+this.$route.params.localidad+'',configuracion).then(function(response){
					//console.log(response);
					DatosProforma=response.data;
					me.monedaPago = DatosProforma[0].contacto1;
					me.idcliente = DatosProforma[0].cliente;
					me.detalleFactura = DatosProforma[0].detalle;
					me.vendedor = DatosProforma[0].vendedor;
					me.obtenerClienteProforma();
					for(var i = 0; i < DatosProforma.length; ++i)
					{
						me.detalles.push(
						{
						id: DatosProforma[i].idProforma,
						idarticulo:DatosProforma[i].codigoProducto,
						descripcion:DatosProforma[i].descripcion,
						cantidad:DatosProforma[i].cantidad,
						descuento:DatosProforma[i].descuentoLinea,
						precio:DatosProforma[i].precioFinal,
						precioDetalle:DatosProforma[i].precioDetalle,
						precioCompra:DatosProforma[i].precioCompra,
						precioCentral:DatosProforma[i].precioFinal,
						precioMayor:DatosProforma[i].precioMayor,
						Ivi:DatosProforma[i].ivi,
						valorImpuesto:DatosProforma[i].valorImpuesto,
						gravado:DatosProforma[i].gravado,
						detalle:DatosProforma[i].detalleLinea,
						minimo: 0,
						impEspecial:0,
						inv: 10,
						cabys: DatosProforma[i].codigoRaiz,

						}
						);
						
					} 
					let codigosProductos = DatosProforma.map(item => item.codigoProducto);
    				me.BuscarInventarioMasivo(codigosProductos);
				}).catch(function(error){
					alert(error);
				});
			}    
		},
		async BuscarInventarioMasivo(codigos) {
			let me = this;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };
			await axios.post('api/ProductosWebs/ConsultaStockMasivo', { codigos, localidad: this.$store.state.usuario.localidad }, configuracion)
				.then(function(response) {
					me.AsignarInventarioMasivo(response.data);
				})
				.catch(function(error) {
					// Manejo de error
				});
		},
		AsignarInventarioMasivo(datosInventario) {
			// Itera sobre cada detalle en tus proformas
			this.detalles.forEach(detalle => {
				// Encuentra el objeto de inventario correspondiente al producto en el detalle
				// Asegúrate de que la propiedad que comparas sea la correcta
				let inventarioProducto = datosInventario.find(item => item.codigoProducto === detalle.idarticulo);

				// Si se encuentra el inventario, asigna el stock al detalle
				if (inventarioProducto) {
					detalle.inv = inventarioProducto.stock; // Asegúrate de que estés usando el nombre correcto de la propiedad, aquí parece ser 'stock', no 'Stock'
				} else {
					// Si no se encuentra, asigna un stock de 0 o el valor que desees
					detalle.inv = 0;
				}
			});
		},


		DuplicadoFactura(){
			let DatosProforma = [];
			let me=this;
			this.snackbar = true;
			this.Mensaje = "Buscando productos de factura "+this.$route.query.duplicar;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/Facturas/DuplicarFactura/'+this.$route.query.duplicar+'/'+this.$store.state.usuario.localidad+'',configuracion).then(function(response){
				//console.log(response);
				DatosProforma=response.data;
				for(var i = 0; i < DatosProforma.length; ++i)
				{
					me.detalles.push(
					{
					id: DatosProforma[i].idproducKey,
					idarticulo:DatosProforma[i].codigoProducto,
					descripcion:DatosProforma[i].descripcion,
					cantidad:DatosProforma[i].cantidad,
					precio:DatosProforma[i].total,
					precioDetalle:DatosProforma[i].precioDetalle,
					precioCentral:DatosProforma[i].precioFinal,
					precioMayor:DatosProforma[i].precioMayor,
					precioCompra:DatosProforma[i].precioCompra,
					Ivi:true,
					valorImpuesto:DatosProforma[i].valorImpuesto,
					gravado:DatosProforma[i].gravado,
					detalle:'',
					minimo: 0,
					inv: 10,
					impEspecial: 0,
					descuento: 0,
					cabys: DatosProforma[i].codigoRaiz,

					}
					);
				} 
			}).catch(function(error){
				alert(error);
			});
		},
		async ObtenerCabys(){
			if(this.$route.params.id != "0"){
				let me=this;
				let Prod = [];
				let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				for(var i = 0; i < this.detalles.length; ++i)
				{	
					await axios.get('api/ProductosWebs/BuscarCodigoVenta/'+this.detalles[i].idarticulo+'/'+this.$store.state.usuario.localidad,configuracion)
					.then(function(response){
						Prod = response.data;
						me.detalles[i].minimo = Prod.minimo;
						me.detalles[i].inv = Prod.cantidadInvActual;
						me.detalles[i].cabys = Prod.codigoRaiz;
					}).catch(function(error){
						
						me.Mensaje = "Producto de la proforma no encontrado en la base de datos. agregue el cabys manualmente"+error;
						me.snackbar = true;
					});
				}
			}
		},
		agregarDetalle2(data = []){
			this.errorArticulo=null;
			if (data[0]['codigoProducto'] != '' && data[0]['codigoProducto'] != undefined)
			{
				this.codigo = data[0]['codigoProducto'];
			}
			if (this.encuentra(data[0]['idarticulo'])){
				alert("El producto ya ha sido agregado.");
			}
			else{
				if (this.codigo != '')
				{
				if (data[0]['cantidad'] > 0)
				{
					this.detalles.push(
					{idarticulo:data[0]['codigoProducto'],
					descripcion:data[0]['descripcion'],
					cantidad:1.0,
					precio:data[0]['precioVenta'],
					descuento:0,
					impuesto:data[0]['iva'],
					subtotal:data[0]['subtotal'],
					valorImpuesto:data[0]['valorImpuesto'],
					gravado:data[0]['gravado'],
					}
				);
					alert("Producto agregado.");
				}
				else
				{
					alert("Cantidad debe ser mayor a 0");
				}
					
				}
				else
				{
				alert("Debe digitar un código de producto o servicio");
				
				}
			} 
		},
		limpiar(){
			this.idcliente="";
			this.barbero="";
			this.localidad="";
			this.detalles=[];
			this.name = '',
			this.details = '',
			this.start = '',
			this.PagaBillete = false;
			this.end = '',
			this.color = '',
			this.hora = '',
			this.hora2 = '',
			this.codigo = '',
			this.descripcion = ''
			this.codigo = '',
			this.precioVenta = '',
			this.precioCompra = '',
			this.categoria = 0
		},
		select(){
			let me=this;
			var clientesArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Empleados/SelectEmpleadosLocalidad/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				clientesArray=response.data;
				clientesArray.map(function(x){
					me.clientes.push({text: (x.nombre+' | '+x.nombreFantasia), text2:x.nombre,value:x.idEmpleado});
				});
			}) 
				//	document.querySelector("#CodigoBarras").focus();
			me.modelCarga= false;
		},
		selectBarbero(){
			let me=this;
			var barberosArray=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Usuarios/SelectUsuarios',configuracion).then(function(response){
				barberosArray=response.data;
				barberosArray.map(function(x){
					me.barberos.push({text: x.nombre,value:x.idusuario});
				});
			})
		},  
		cargarColor(){
			for(var i = 0; i < this.localidadesColor.length; ++i)
			{
				if(this.localidadesColor[i].value == this.localidad.value){
						this.color = this.localidadesColor[i].color;
						break;
				}
			}
	},
	methods: {
		isNumber: function(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			evt.preventDefault();
		} else {
			return true;
		}
		}
	},
	abrirCabys(){
		var url = 'https://app.powerbi.com/view?r=eyJrIjoiZDdmNTBlYTktYmE0Ni00NGM3LWJhNzYtMGZhNjBlNTQyYTdmIiwidCI6IjYxOGQwYTQ1LTI1YTYtNDYxOC05ZjgwLThmNzBhNDM1ZWU1MiJ9';
		var win = window.open(url, '_blank');
		win.focus();
	},
	cargarColorActualizar(){
		for(var i = 0; i < this.localidadesColor.length; ++i)
		{
			if(this.localidadesColor[i].value == this.localidad){
					this.color = this.localidadesColor[i].color;
					break;
			}
		}
	},
	ActualizarCabys(){ 
		let header={"Authorization" : "Bearer "};
		let configuracion= {headers : header};
			//Código para editar
			let me=this;
			axios.put('api/Productos/ActualizarCabys',{
				'CodigoProducto':this.codigoProducto,
				'Localidad' : me.$store.state.usuario.localidad,
				'CodigoRaiz': me.serial,
			},configuracion).then(function(response){
				me.Mensaje = 'Cabys Agregado a la base de datos' +response;
				me.snackbar = true;                     
			}).catch(function(error){
				alert("Problema agregando el CABYS a al base de datos, envie una foto de este problema a su equipo de soporte"+error);
				alert(error);
			});
	},
	
	PrecioVariable(){
			var tipoimpuestograbado = 'N'
			if (this.categoria > 0){
			tipoimpuestograbado = 'S'
			}
				this.detalles.push(
					{
						id: Date.now(),
						idarticulo:"PV01",
						descripcion:this.descripcion,
						cantidad:1,
						precio:this.precioVenta,
						precioCompra: 0,
						precioVenta: 0,
						precioDetalle: 0,
						precioMayor: 0,
						descuento:0,
						Ivi: this.Ivi,
						LlevaIvi: 'IVI',
						impuesto:0,
						subtotal:0,
						valorImpuesto:this.categoria,
						gravado:tipoimpuestograbado,
						cabys:this.serial,
					}
				);
			this.dialogPrecioVariable = false;
			this.verArticulos = false;
		
		},
		validarSelectBarberoValor() {
		for(var i = 0; i < this.barberos.length; ++i)
				{
					if(this.barberos[i].value == this.barbero){
						this.barbero = this.barberos[i].text
					}
				}
		},
		obtenerClienteEvento(clienteId){
					var self = this;
					var clientesArray=[];
					let header={"Authorization" : "Bearer "};
					let configuracion= {headers : header};
					axios.get('api/Empleados/ObtenerClienteId', { params: {'clienteId': clienteId}},configuracion).then(function(response){
						clientesArray=response.data;
						for(var i = 0; i < clientesArray.length; ++i)
						{
						self.clienteNombre = clientesArray[i].nombre;
						self.clienteCorreo = clientesArray[i].correo;
						self.clienteCedula = clientesArray[i].cedula;
						self.clienteTipoCedula = clientesArray[i].tipoCedula;
						self.clienteTelefono = clientesArray[i].telefono;
						break;
						} 
					})
		},
	}
	}
</script>

<style lang="scss">
    .productos table {
		width: 100%;
		border-collapse: collapse;
	}
	.productos th, .productos td {
		text-align: left;
		padding: 2px; /* Ajusta el padding según necesites */
	}
	.productos th {
		border-bottom: 1px solid #000;
	}
	.productos .cantidad {
		width: 15%; /* Ajusta el porcentaje según necesites */
	}
	.productos .descripcion {
		width: 50%; /* Ajusta el porcentaje según necesites */
	}
	.productos .precio {
		width: 35%; /* Ajusta el porcentaje según necesites */
		text-align: right; /* Alinea los precios a la derecha */
	}
    #factura {
        padding: 20px;
    }
    #ticket {
    width: 60px;
    max-width: 155px;
    }

    
	.font{
		font-family: generalFont;
	}
    #logo {
        float: left;
        margin-left: 2%;
        margin-right: 2%;
    }
    #imagen {
        width: 100px;
    }

    #fact {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }   
	#field {
		width: 100%;
		height: 5px;
		padding: 0px;
		overflow: auto;
	}
    #datos {
        float: left;
        margin-top: 0%;
        margin-left: 2%;
        margin-right: 2%;
    }

    #encabezado {
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
        font-size: 16px;
    }

    section {
        clear: left;
    }

    #cliente {
        text-align: left;
    }

    #facliente {
        width: 40%;
        border-collapse: collapse;
        border-spacing: 0;
        margin-bottom: 15px;
    }

    #fa {
        color: #FFFFFF;
        font-size: 14px;
    }
    @media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
    }   
    #facarticulo {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        padding: 20px;
        margin-bottom: 15px;
    }

    #facarticulo thead {
        padding: 20px;
        background: #2183E3;
        text-align: center;
        border-bottom: 1px solid #FFFFFF;
    }

    #gracias {
        text-align: center;
    }
    tr.v-data-table__selected {
      background: #7d92f5 !important;
    }

    button#facturaBoton {
      margin: 18px;
    }

    button#hoyBoton {
      margin: 18px;
    }

    .tarjeta{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .efectivo{
        margin-bottom: 15px!important;
        margin-top: 20px!important;
    }

    .btnLimpiarGrid {
        margin-bottom: 20px;
    }

    button#productoBoton {
        top: 6px;
        margin-left: 35px;
    }

    td,
    th,
    tr,

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%!important;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }
	.footer {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	/* altura del footer si es conocida */
	}

	.data-table {
	margin-bottom: [altura del footer]px;
	}
    .ticket {
        width: 155px;
        max-width: 155px;
    }

    img {
        max-width: inherit;
        width: inherit;
    }
    .centrado {
    text-align: center;
    align-content: center;
    }

    .ticket {
        width: 200px;
        max-width: 200px;
    }

    img {
        max-width: inherit;
        width: inherit;
    }
	.payment-buttons {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	}

	.payment-button {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 100px;
	height: 100px;
	border: none;
	border-radius: 5px;
	font-size: 16px;
	color: #1c837a;
	text-transform: uppercase;
	cursor: pointer;
	}

	.payment-button i {
	margin-bottom: 10px;
	font-size: 36px;
	}
	#comandaproforma {
		display: none;
	}
	/* Muestra el contenido solo en la impresión */
	@media print {
		#comandaproforma {
			display: block;
		}
	}
	.cash {
		background-color: #ddfcf9;
		border: 2px solid #28b6aa; /* Color intenso */
	}

	.payment-button i {
	margin-right: 10px;
	}


</style>